// quiz-main.js
// Erwartet, dass quiz-config.js, quiz-data.js und quiz-logic.js vorher geladen wurden


// Safety: prevent hard crash if older code calls this
window.deferStepRender = window.deferStepRender || function (fn) {
  try {
    requestAnimationFrame(() => requestAnimationFrame(fn));
  } catch (e) {
    setTimeout(fn, 0);
  }
};

(function bootstrapCatQuiz() {

  // Prevent double-init (Shopify Theme Editor Preview / Section re-render)
  if (window.__fellinoraCatQuizMainInitDone) return;
  window.__fellinoraCatQuizMainInitDone = true;
  const MAX_TRIES = 80;     // ~4s bei 50ms
  const RETRY_MS = 50;
  let tries = 0;

  function depsReady() {
    return !!(window.CatQuiz && CatQuiz.config && CatQuiz.data && CatQuiz.logic && CatQuiz.labels);
  }

  function tryInit() {
    if (!depsReady()) return false;

    const quizRoot = document.getElementById("cat-nutrition-quiz");
    if (!quizRoot) return false;

    // Guard gegen Double-Init (Shopify kann Scripts mehrfach injizieren)
    if (quizRoot.__catQuizInitialized) return true;
    quizRoot.__catQuizInitialized = true;

    mainInit(quizRoot);
    return true;
  }

  function startRetries() {
    if (tryInit()) return;

    const iv = setInterval(() => {
      tries += 1;

      if (tryInit()) {
        clearInterval(iv);
        return;
      }

      if (tries >= MAX_TRIES) {
        clearInterval(iv);
        console.error("[CatQuiz] Init fehlgeschlagen: DOM oder CatQuiz-Module nicht verfügbar.");
      }
    }, RETRY_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startRetries);
  } else {
    startRetries();
  }

  // --------------------------------------------------
  // Haupt-Init (alles was vorher im IIFE stand)
  // --------------------------------------------------
  function mainInit(quizRoot) {

  // --------------------------------------------------
  // Imports aus den Namespaces
  // --------------------------------------------------

const {
  GESUNDHEITSPLAN_VARIANT_ID,
  GESUNDHEITSPLAN_OWN_FOOD_ID,
  GESUNDHEITSPLAN_REZEPTE_KOCH_BARF_ID,
  FUTTERPLAN_VARIANT_ID,
  FUTTERPLAN_3_Mahlzeiten_ID,
  FUTTERPLAN_4_Mahlzeiten_ID,
  FUTERPLAN_4_Mahlzeiten_ID,
  NAEHRSTOFFPLAN_ID,
  IDEAL_WEIGHTS,
  SELLING_PLANS,
  QUIZ_TAG,
  sendEvent,
  FAQ_ITEMS
} = CatQuiz.config;



  const {
    CAT_BREEDS,
    ALLERGY_LABELS,
    HEALTH_LABELS,
    SOCIAL_LABELS
  } = CatQuiz.labels;

const {
  INGREDIENTS_DATA,
  ANALYTICS_DATA,
  MICRONUTRIENTS_DATA,
  FEEDING_RECOMMENDATIONS_DATA,
  MODAL_META
} = CatQuiz.data;


const {
  calcME,
  computeBasePlan,
  computeIntervalPlan,
  getWeightTexts,
  calcProteinNeedGPerDay,
  calcTaurineMgPerDay,
  calcWaterMlPerDay,
  buildDailyNeeds,
  resolveIdealWeightKg,
  buildNutrientPlanMetrics,
  buildFoodCollectionHealthMetrics
} = CatQuiz.logic;




  // --------------------------------------------------
  // Root / Form / DOM-Referenzen
  // --------------------------------------------------

  
const PRODUCTS = {
  huhn: {
    title: "Huhn",
    img: () => IMG_HUHN_CARD || IMG_HUHN,
    alt: "Katzenliebe Huhn",
    claims: [
      { icon: () => ICON_FAT,     text: "96 % Fleisch, Innereien & Brühe" },
      { icon: () => ICON_MEAT,    text: "Hoher Anteil an hochwertigen Proteinen" },
      { icon: () => ICON_PROTEIN, text: "Niedriger Kohlenhydratanteil" },
      { icon: () => ICON_GUT,     text: "Präbiotika & Ballaststoffe für die Verdauung" },
    ],
  },

  huhnForelle: {
    title: "Huhn &amp; Forelle",
    img: () => IMG_HUHN_FORELLE_CARD || IMG_HUHN_FORELLE,
    alt: "Katzenliebe Huhn & Forelle",
    claims: [
      { icon: () => ICON_HARNWEGE, text: "96 % Fleisch, Innereien & Brühe" },
      { icon: () => ICON_MEAT,     text: "Mit Omega-3-Fettsäuren für Haut und Fell" },
      { icon: () => ICON_SATT,     text: "Macht richtig satt" },
      { icon: () => ICON_OMEGA3,   text: "Präbioikaformel für die Verdauung" },
    ],
  },
    extraCard1: {
  title: "Gesundheitsplan für deine Katze",
  img: () => IMG_GESUNDHEITSPLAN || IMG_HUHN, // Fallback falls data-attr fehlt
  alt: "Individueller Gesundheitsplan",
  badgeText: "Kostenlos",
  claims: [
    { icon: () => ICON_HAKEN, text: "Erstellung eines Gesundheitsprofils für deine Katze" },
    { icon: () => ICON_HAKEN, text: "Berechnung von Nährstoffen wie Kalorienbedarf" },
    { icon: () => ICON_HAKEN, text: "Individuelle Ernährungsempfehlungen durch unsere Experten" },
    { icon: () => ICON_HAKEN, text: "Fachliche Beurteilung des Körperprofils" },
  ],
},


extraCard2: {
  title: "4-wöchiger Futterplan",
  img: () => IMG_FUTTERPLAN || IMG_HUHN_FORELLE, // Fallback, falls Asset fehlt
  alt: "Individueller Futterplan",
  badgeText: "Kostenlos",
  claims: [
    { icon: () => ICON_HAKEN, text: "Individuell abgestimmter Futterplan für deine Katze" },
    { icon: () => ICON_HAKEN, text: "Futtermengen abgestimmt auf den Kalorienbedarf deiner Katze" },
    { icon: () => ICON_HAKEN, text: "Bedarfsgerechte Fütterungszeiten und Fütterungsempfehlungen" },
    { icon: () => ICON_HAKEN, text: "Praktisches Abhaken jeder Mahlzeit" },
  ],
},


};

const IMG_HUHN = quizRoot.dataset.imgHuhn || "";
const IMG_HUHN_FORELLE =
  quizRoot.dataset.imgHuhnForelle ||
  quizRoot.dataset["imgHuhn_forelle"] ||
  quizRoot.dataset.imgRind ||
  "";

const IMG_HUHN_CARD = quizRoot.dataset.imgHuhnCard || IMG_HUHN;

// WICHTIG: dein HTML-Attribut ist `data-img-huhnForelle-card="..."`
// Das wird im DOM zu `dataset.imgHuhnforelleCard` (kleines "f").
const IMG_HUHN_FORELLE_CARD =
  quizRoot.dataset.imgHuhnForelleCard ||  // ✅ korrekt für: data-img-huhn-forelle-card
  quizRoot.dataset.imgHuhnforelleCard ||  // (Legacy-Fallback, falls irgendwo so drin)
  IMG_HUHN_FORELLE;

// Zusätzliche (Content-)Karten unter den Produktcards (Platzhalter)
const IMG_EXTRA_CARD_1 = quizRoot.dataset.imgExtraCard1 || ""; // später: png url
const IMG_EXTRA_CARD_2 = quizRoot.dataset.imgExtraCard2 || "";

// Icons aus data-Attributen
const ICON_FAT     = quizRoot.dataset.imgClaimPfeil     || "";
const ICON_MEAT    = quizRoot.dataset.imgClaimFleisch   || "";
const ICON_PROTEIN = quizRoot.dataset.imgClaimMuskel    || "";
const ICON_GUT     = quizRoot.dataset.imgClaimVerdauung || "";

const ICON_OMEGA3  = quizRoot.dataset.imgClaimOmega3    || "";
const ICON_HARNWEGE= quizRoot.dataset.imgClaimHarnwege  || "";
const ICON_SATT    = quizRoot.dataset.imgClaimSatt      || "";
// Extra-Card Assets
const IMG_GESUNDHEITSPLAN = quizRoot.dataset.imgGesundheitsplan || "";
const IMG_FUTTERPLAN = quizRoot.dataset.imgFutterplan || "";
const ICON_HAKEN          = quizRoot.dataset.imgHaken || "";
const IMG_KATZE_FUTTERCARD = quizRoot.dataset.imgKatzeFuttercard || "";
const IMG_DOKTOR_KATZE = quizRoot.dataset.imgDoktorKatze || "";
const IMG_KATZE_FORELLECARD = quizRoot.dataset.imgKatzeForelleCard || "";
const IMG_MODAL_HUHN = quizRoot.dataset.imgModalHuhn || "";
const IMG_MODAL_HUHN_FORELLE =
  quizRoot.dataset.imgModalHuhnForelle ||
  quizRoot.dataset.imgModalHuhnforelle ||
  "";
const INGREDIENT_RAY_IMAGES = Array.from({ length: 13 }, (_, idx) => {
  const n = idx + 1;
  return (quizRoot.getAttribute(`data-ingredient-ray-${n}`) || "").trim();
});
// WICHTIG: bewusst KEIN filter(Boolean) – sonst verschwindet alles,
// wenn eine URL leer ist (z.B. Datei noch nicht in Shopify Files).

const HEALTHPLAN_IMG  = quizRoot.dataset.healthplanImg  || "";
const FEEDINGPLAN_IMG = quizRoot.dataset.feedingplanImg || "";
 // Ownfood Plan Card Bild aus Liquid-Attribut ziehen (einmalig, wie bei den anderen Bildern)
const IMG_OWNFOOD_PLAN_CARD = quizRoot.dataset.imgOwnfoodplancardImg || "";
const IMG_OWNFOOD_ADDON_CARD = quizRoot?.dataset?.imgOwnfoodaddoncardImg || "";
const IMG_OWNFOOD_COMPOSITION_EXAMPLE =
  quizRoot?.dataset?.imgOwnfoodCompositionExample ||
  "";


const ICON_FLEISCH =
  quizRoot?.dataset?.imgOwnfoodBulletFleisch ||
  quizRoot?.dataset?.imgClaimFleisch || // optionaler Fallback falls vorhanden
  "";

const ICON_MAUS =
  quizRoot?.dataset?.imgOwnfoodBulletMaus || "";

const ICON_VERDAUUNG =
  quizRoot?.dataset?.imgOwnfoodBulletVerdauung ||
  quizRoot?.dataset?.imgClaimVerdauung || // optionaler Fallback falls vorhanden
  "";

const ICON_WOW =
  quizRoot?.dataset?.imgOwnfoodBulletWow || "";
const heroImg = quizRoot?.dataset?.imgOwnfoodHeroCat || "";
const iconImg = (src) =>
  src ? `<img src="${src}" alt="" loading="lazy" decoding="async">` : "";

const IMG_PRODUKTION = (quizRoot.dataset.imgProduktion || "");
const IMG_DAMPFGARUNG_1 = (quizRoot.getAttribute("data-img-dampfgarung-1") || "");
const IMG_DAMPFGARUNG_2 = (quizRoot.getAttribute("data-img-dampfgarung-2") || "");
const IMG_DAMPFGARUNG_3 = (quizRoot.getAttribute("data-img-dampfgarung-3") || "");
const IMG_VET_KATHI = (quizRoot.dataset.imgVetKathi || "").trim();
const IMG_TESTIMONIAL_LISA = (quizRoot.dataset.imgTestimonialLisa || "").trim();
const IMG_TESTIMONIAL_EMMA = (quizRoot.dataset.imgTestimonialEmma || "").trim();
const COMMUNITY_IMAGES = (quizRoot?.dataset?.communityImages || "")
  .split("|")
  .map(s => s.trim())
  .filter(Boolean);

function cqNormalizeFoodCode(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function cqNormalizeVariantKey(value, fallback = "") {
  const normalized = cqNormalizeFoodCode(value);
  return normalized || cqNormalizeFoodCode(fallback);
}

function cqRound(value, digits = 6) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Number(n.toFixed(digits));
}

function cqCoercePositiveNumber(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

function cqNormalizeAnalytics(input) {
  const src = input || {};
  return {
    protein: Number(src.protein),
    fat: Number(src.fat),
    ash: Number(src.ash),
    fiber: Number(src.fiber),
    moisture: Number(src.moisture),
  };
}

function cqBuildFallbackFoodCatalog() {
  const variants = CatQuiz.config?.VARIANTS || {};
  const fallback = [];
  if (variants.huhn100g) {
    fallback.push({
      code: "huhn",
      uiKey: "huhn",
      label: "Huhn",
      variants: [
        {
          variantId: Number(variants.huhn100g),
          packSizeGrams: 100,
          label: "100g",
          key: "100g",
          isDefault: true,
          useForCart: true,
          isActive: true,
        }
      ],
      isActive: true,
    });
  }
  if (variants.huhnForelle100g) {
    fallback.push({
      code: "huhn_forelle",
      uiKey: "huhnForelle",
      label: "Huhn & Forelle",
      variants: [
        {
          variantId: Number(variants.huhnForelle100g),
          packSizeGrams: 100,
          label: "100g",
          key: "100g",
          isDefault: true,
          useForCart: true,
          isActive: true,
        }
      ],
      isActive: true,
    });
  }
  return fallback;
}

function cqNormalizeCatalogVariant(food, variant, index) {
  const packSizeGrams = cqCoercePositiveNumber(variant?.packSizeGrams || variant?.pack_size_g || food?.packSizeGrams || food?.pack_size_g, 100);
  const variantIdRaw = variant?.variantId ?? variant?.variant_id ?? variant?.id ?? null;
  const variantId = variantIdRaw == null || variantIdRaw === "" ? null : Number(variantIdRaw);
  const fallbackKey = `${food?.code || food?.uiKey || "food"}_${packSizeGrams}g_${index + 1}`;
  return {
    variantId: Number.isFinite(variantId) && variantId > 0 ? variantId : null,
    packSizeGrams,
    variantKey: cqNormalizeVariantKey(variant?.variantKey || variant?.key || variant?.code || variant?.label, fallbackKey),
    variantLabel: String(variant?.variantLabel || variant?.label || `${packSizeGrams}g`).trim() || `${packSizeGrams}g`,
    isActive: variant?.isActive !== false && variant?.enabled !== false,
    isDefault: variant?.isDefault === true || variant?.default === true,
    useForCart: variant?.useForCart === true || variant?.isCartDefault === true,
  };
}

function cqNormalizeCatalogFood(food, index) {
  if (!food) return null;
  const code = cqNormalizeFoodCode(food?.code || food?.uiKey);
  if (!code) return null;

  const rawVariants = Array.isArray(food?.variants) && food.variants.length
    ? food.variants
    : [
        {
          variantId: food?.variantId ?? null,
          packSizeGrams: food?.packSizeGrams ?? null,
          key: food?.variantKey || null,
          label: food?.variantLabel || null,
          isDefault: true,
          useForCart: true,
          isActive: food?.isActive !== false,
        }
      ].filter((entry) => entry.variantId != null || entry.packSizeGrams != null);

  const variants = rawVariants
    .map((variant, variantIndex) => cqNormalizeCatalogVariant({ ...food, code }, variant, variantIndex))
    .filter(Boolean);

  const activeVariants = variants.filter((variant) => variant.isActive !== false);
  const cartVariant =
    activeVariants.find((variant) => variant.useForCart) ||
    activeVariants.find((variant) => variant.isDefault) ||
    activeVariants[0] ||
    variants.find((variant) => variant.useForCart) ||
    variants.find((variant) => variant.isDefault) ||
    variants[0] ||
    null;

  return {
    ...food,
    code,
    uiKey: String(food?.uiKey || food?.code || code).trim() || code,
    label: String(food?.label || food?.name || food?.uiKey || code).trim() || code,
    analytics: cqNormalizeAnalytics(food?.analytics || null),
    allergenTags: Array.isArray(food?.allergenTags) ? food.allergenTags : [],
    isActive: food?.isActive !== false,
    variants,
    variantId: cartVariant?.variantId ?? null,
    variantKey: cartVariant?.variantKey ?? null,
    variantLabel: cartVariant?.variantLabel ?? null,
    packSizeGrams: cartVariant?.packSizeGrams ?? cqCoercePositiveNumber(food?.packSizeGrams || food?.pack_size_g, 100),
    cartVariantId: cartVariant?.variantId ?? null,
    cartVariantKey: cartVariant?.variantKey ?? null,
  };
}

const FOOD_CATALOG = (Array.isArray(CatQuiz.config?.FOOD_CATALOG) && CatQuiz.config.FOOD_CATALOG.length
  ? CatQuiz.config.FOOD_CATALOG
  : cqBuildFallbackFoodCatalog())
  .map(cqNormalizeCatalogFood)
  .filter(Boolean);

function cqGetCatalogFood(ref) {
  const needle = cqNormalizeFoodCode(ref);
  return FOOD_CATALOG.find((food) => cqNormalizeFoodCode(food?.code) === needle || cqNormalizeFoodCode(food?.uiKey) === needle) || null;
}

function cqResolveCatalogVariant(foodLike, catalogFood) {
  const source = foodLike || {};
  const food = catalogFood || cqGetCatalogFood(source.code || source.uiKey);
  const variants = Array.isArray(food?.variants) ? food.variants : [];
  if (!variants.length) {
    const fallbackPack = cqCoercePositiveNumber(source.packSizeGrams || food?.packSizeGrams, 100);
    return {
      variantId: source.variantId ?? food?.variantId ?? null,
      variantKey: cqNormalizeVariantKey(source.variantKey || food?.variantKey, `${food?.code || source.code || source.uiKey || 'food'}_${fallbackPack}g`),
      variantLabel: String(source.variantLabel || food?.variantLabel || `${fallbackPack}g`).trim() || `${fallbackPack}g`,
      packSizeGrams: fallbackPack,
      isActive: true,
      isDefault: true,
      useForCart: true,
    };
  }

  const explicitVariantId = String(source.variantId ?? source.variant_id ?? "").trim();
  const explicitVariantKey = cqNormalizeVariantKey(source.variantKey || source.variant_key || "");
  const explicitPackSize = cqCoercePositiveNumber(source.packSizeGrams || source.pack_size_g, 0);

  return (
    variants.find((variant) => explicitVariantId && String(variant.variantId) === explicitVariantId) ||
    variants.find((variant) => explicitVariantKey && variant.variantKey === explicitVariantKey) ||
    variants.find((variant) => explicitPackSize > 0 && Number(variant.packSizeGrams) === explicitPackSize) ||
    variants.find((variant) => variant.useForCart) ||
    variants.find((variant) => variant.isDefault) ||
    variants.find((variant) => variant.isActive !== false) ||
    variants[0]
  );
}

function cqFormatPropNumber(value, decimals = 0) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return n.toFixed(decimals).replace(".", ",");
}

function cqNormalizeFood(food) {
  if (!food) return null;
  const catalogFood = cqGetCatalogFood(food.code || food.uiKey);
  const code = catalogFood?.code || cqNormalizeFoodCode(food.code || food.uiKey);
  if (!code) return null;

  const resolvedVariant = cqResolveCatalogVariant(food, catalogFood);
  const packSizeGrams = cqCoercePositiveNumber(food.packSizeGrams || resolvedVariant?.packSizeGrams || catalogFood?.packSizeGrams, 100);
  const grams = food.grams == null ? null : (Number(food.grams || 0) || 0);
  let units = food.units == null ? null : (Number(food.units || 0) || 0);
  if (grams != null && packSizeGrams > 0) {
    units = grams > 0 ? Math.ceil(grams / packSizeGrams) : 0;
  }

  return {
    code,
    uiKey: catalogFood?.uiKey || food.uiKey || null,
    label: catalogFood?.label || food.label || code,
    variantId: resolvedVariant?.variantId ?? food.variantId ?? catalogFood?.variantId ?? null,
    variantKey: resolvedVariant?.variantKey ?? food.variantKey ?? catalogFood?.variantKey ?? null,
    variantLabel: resolvedVariant?.variantLabel ?? food.variantLabel ?? catalogFood?.variantLabel ?? null,
    packSizeGrams,
    share: cqRound(food.share || 0, 6),
    gramsPerDay: Number(food.gramsPerDay || 0) || 0,
    grams,
    units,
    meKcalPerG: Number(food.meKcalPerG || food.me_kcal_per_g || 0) || null,
    analytics: cqNormalizeAnalytics(food.analytics || catalogFood?.analytics || null),
  };
}

function cqGetFoodsFromBase(baseLike) {
  return (Array.isArray(baseLike?.foods) ? baseLike.foods : []).map(cqNormalizeFood).filter(Boolean);
}

function cqGetFoodsFromPlan(planLike) {
  return (Array.isArray(planLike?.foods) ? planLike.foods : []).map(cqNormalizeFood).filter(Boolean);
}

function cqBuildFoodsPayload(baseLike, intervalLike) {
  const baseFoods = cqGetFoodsFromBase(baseLike);
  const intervalFoods = cqGetFoodsFromPlan(intervalLike);
  const intervalByCode = new Map(intervalFoods.map((food) => [food.code, food]));
  return baseFoods.map((food, index) => {
    const intervalFood = intervalByCode.get(food.code) || {};
    return {
      code: food.code,
      uiKey: food.uiKey,
      label: food.label,
      variantId: intervalFood.variantId ?? food.variantId ?? null,
      variantKey: intervalFood.variantKey ?? food.variantKey ?? null,
      variantLabel: intervalFood.variantLabel ?? food.variantLabel ?? null,
      packSizeGrams: intervalFood.packSizeGrams || food.packSizeGrams,
      share: cqRound(food.share || 0, 6),
      gramsPerDay: cqRound(food.gramsPerDay || 0, 6),
      grams: intervalLike ? Math.round(Number(intervalFood.grams || 0)) : null,
      units: intervalLike ? (Number.isFinite(Number(intervalFood.units)) ? Math.round(Number(intervalFood.units || 0)) : null) : null,
      analytics: food.analytics,
      meKcalPerG: Number(food.meKcalPerG || 0) || null,
      rank: index + 1,
    };
  }).filter((food) => food.code && ((food.gramsPerDay > 0) || (food.grams || 0) > 0 || (food.units || 0) > 0 || food.share > 0));
}

function cqBuildFixedIntervalFoodsFromDaily(baseLike, days) {
  const safeDays = Math.max(0, Number(days) || 0);
  return cqGetFoodsFromBase(baseLike).map((food, index) => {
    const gramsPerDay = cqRound(food?.gramsPerDay || 0, 6);
    const totalGrams = Math.round(gramsPerDay * safeDays);
    const packSizeGrams = cqCoercePositiveNumber(food?.packSizeGrams, 100);
    const units = totalGrams > 0 ? Math.ceil(totalGrams / packSizeGrams) : 0;

    return {
      code: food.code,
      uiKey: food.uiKey,
      label: food.label,
      variantId: food.variantId ?? null,
      variantKey: food.variantKey ?? null,
      variantLabel: food.variantLabel ?? null,
      packSizeGrams,
      share: cqRound(food.share || 0, 6),
      gramsPerDay,
      grams: totalGrams,
      units,
      analytics: food.analytics,
      meKcalPerG: Number(food.meKcalPerG || 0) || null,
      rank: index + 1,
    };
  }).filter((food) => food.code && ((food.gramsPerDay > 0) || (food.grams || 0) > 0 || (food.units || 0) > 0 || food.share > 0));
}

function cqAddFoodCollectionProps(target, foods, prefix = "") {
  const safeFoods = Array.isArray(foods) ? foods : [];
  target[`_cq_${prefix}foods_json`] = JSON.stringify(safeFoods);
  target[`_cq_${prefix}food_count`] = String(safeFoods.length);
  safeFoods.forEach((food, idx) => {
    const i = idx + 1;
    const key = `_cq_${prefix}food_${i}_`;
    target[`${key}code`] = String(food.code || "");
    if (food.uiKey) target[`${key}ui_key`] = String(food.uiKey);
    target[`${key}label`] = String(food.label || food.code || "");
    if (food.variantId != null) target[`${key}variant_id`] = String(food.variantId);
    if (food.variantKey) target[`${key}variant_key`] = String(food.variantKey);
    if (food.variantLabel) target[`${key}variant_label`] = String(food.variantLabel);
    target[`${key}pack_size_g`] = String(food.packSizeGrams || 100);
    target[`${key}share`] = String(cqRound(food.share || 0, 6));
    target[`${key}grams_per_day`] = String(cqRound(food.gramsPerDay || 0, 6));
    if (food.grams != null) target[`${key}grams`] = String(Math.round(Number(food.grams || 0)));
    if (food.units != null) target[`${key}units`] = String(Math.round(Number(food.units || 0)));
  });
}

function cqSumFoodMetric(foods, field, digits = 6) {
  const total = (Array.isArray(foods) ? foods : []).reduce((sum, food) => sum + Number(food?.[field] || 0), 0);
  return Number(total.toFixed(digits));
}

function cqBuildFoodSummaryLabel(foods) {
  const labels = (Array.isArray(foods) ? foods : []).map((food) => food?.label).filter(Boolean);
  return labels.join(" + ") || "Fellinora";
}

function cqGetKnownProductKey(food) {
  if (!food) return null;
  const key = food.uiKey || food.code;
  return PRODUCTS[key] ? key : null;
}

function cqAddDynamicFoodLineProps(target, foods, { current = false, targetPlan = false } = {}) {
  (Array.isArray(foods) ? foods : []).forEach((food) => {
    const label = String(food.label || food.code || "").trim();
    if (!label) return;
    if (current) target[`Aktuelle Tagesmenge ${label} (g/Tag)`] = cqFormatPropNumber(food.gramsPerDay, 0);
    if (targetPlan) {
      target[`30 Tage Abo ${label} ${food.packSizeGrams || 100}g (Anzahl)`] = String(Math.round(Number(food.units || 0)));
      target[`30 Tage Abo ${label} (g)`] = cqFormatPropNumber(food.grams || 0, 0);
    }
  });
}
// ================================
// Ernährungsempfehlungen (rechts unter Bedarfskachel)
// BCS im Quiz: 1..5
// ================================
const NUTRITION_RECO = {
  kitten: [
    "Nährstoffbedarf eines Kittens im Wachstum",
    "Hoher Proteinwert für Wachstum und Muskelaufbau",
    "Hoher Calciumbedarf zum Aufbau von Knochen",
    "Hochwertige Fette als Energiequelle",
  ],
  adult: {
    1: [
      "Nährstoffbedarf einer Katze im Erhaltungsbedarf",
      "Angepasste Futtermengen bei Untergewicht",
      "Hoher Proteinwert und hochwertige Fette",
      "Präbiotika zur Unterstützung der Verdauung",
    ],
    2: [
      "Nährstoffbedarf einer Katze im Erhaltungsbedarf",
      "Angepasste Futtermengen bei Untergewicht",
      "Hoher Proteinwert und hochwertige Fette",
      "Präbiotika zur Unterstützung der Verdauung",
    ],
    3: [
      "Nährstoffbedarf einer Katze im Erhaltungsbedarf",
      "Angepasste Futtermengen zum Erhalt des Idealgewichts",
      "Hoher Proteinwert und niedriger Kohlenhydratanteil",
      "Präbiotika zur Unterstützung der Verdauung",
    ],
    4: [
      "Nährstoffbedarf einer Katze im Erhaltungsbedarf",
      "Angepasste Futtermengen bei Übergewicht",
      "Hoher Proteinwert und niedriger Kohlenhydratanteil",
      "Präbiotika zur Unterstützung der Verdauung",
    ],
    5: [
      "Nährstoffbedarf einer Katze im Erhaltungsbedarf",
      "Angepasste Futtermengen bei Übergewicht",
      "Hoher Proteinwert und niedriger Kohlenhydratanteil",
      "Präbiotika zur Unterstützung der Verdauung",
    ],
  },
  senior: {
    1: [
      "Nährstoffbedarf einer Seniorenkatze",
      "Angepasste Futtermengen bei Untergewicht",
      "Kleine Mahlzeiten mit hoher Nährstoffdichte",
      "Hochwertige und leicht verdauliche Proteine",
    ],
    2: [
      "Nährstoffbedarf einer Seniorenkatze",
      "Angepasste Futtermengen bei Untergewicht",
      "Kleine Mahlzeiten mit hoher Nährstoffdichte",
      "Hochwertige und leicht verdauliche Proteine",
    ],
    3: [
      "Nährstoffbedarf einer Seniorenkatze",
      "Angepasste Futtermengen zum Erhalt des Idealgewichts",
      "Kleine Mahlzeiten mit hoher Nährstoffdichte",
      "Hochwertige und leicht verdauliche Proteine",
    ],
    4: [
      "Nährstoffbedarf einer Seniorenkatze",
      "Angepasste Futtermengen bei Übergewicht",
      "Kleine Mahlzeiten mit hoher Nährstoffdichte",
      "Hochwertige und leicht verdauliche Proteine",
    ],
    5: [
      "Nährstoffbedarf einer Seniorenkatze",
      "Angepasste Futtermengen bei Übergewicht",
      "Kleine Mahlzeiten mit hoher Nährstoffdichte",
      "Hochwertige und leicht verdauliche Proteine",
    ],
  },
};

function getNutritionRecoLines(answers) {
  const ageCategory = (answers.ageCategory || "").toLowerCase(); // "kitten"|"adult"|"senior"
  const bcs = Number(answers.bcs) || 3;

  if (ageCategory === "kitten") {
    return NUTRITION_RECO.kitten;
  }

  const bucket = ageCategory === "senior" ? "senior" : "adult";
  return (NUTRITION_RECO[bucket] && NUTRITION_RECO[bucket][bcs]) || NUTRITION_RECO[bucket][3];
}



  // DOM-Referenzen relativ zum Quiz-Root
const form              = quizRoot.querySelector("#cat-quiz-form");
const steps             = Array.from(quizRoot.querySelectorAll(".quiz-step"));
// --------------------------------------
// Quiz Titel (H2) pro Step
// --------------------------------------
const quizTitleEl =
  quizRoot.querySelector(".js-quiz-main-title") || quizRoot.querySelector("h2");

const defaultQuizTitle = (quizTitleEl?.textContent || "").trim();

function setQuizTitleForStep(stepEl) {
  if (!quizTitleEl) return;
  const rawTitle = (stepEl?.dataset?.title || "").trim();
  let nextTitle = rawTitle || defaultQuizTitle;

  if (nextTitle && nextTitle.includes("%NAME%")) {
    const name = (nameInput?.value || "deiner Katze").toString().trim() || "deiner Katze";
    nextTitle = nextTitle.replace(/%NAME%/g, name);
  }

  quizTitleEl.textContent = nextTitle;
}

const resultBox         = quizRoot.querySelector("#result-summary");
const progressSteps     = Array.from(quizRoot.querySelectorAll(".progress-step"));
const nameInput         = form.querySelector('input[name="name"]');
const nameTargets       = Array.from(quizRoot.querySelectorAll(".js-name-text"));
const breedHiddenInput  = form.querySelector('input[name="breed"]');       // hidden
const breedTextInput    = form.querySelector('input[name="breed_text"]');  // sichtbares Feld
const breedSuggestions  = form.querySelector(".breed-suggestions");
const breedMixBtn       = form.querySelector(".breed-mix-toggle");
const ageCategoryInputs = Array.from(form.querySelectorAll('input[name="age_category"]'));
const ageMonthsInput    = form.querySelector('input[name="age_months"]');
const ageYearsInput     = form.querySelector('input[name="age_years"]');
const birthMonthCard   = form.querySelector(".age-birthmonth-card");
const birthMonthSelect = form.querySelector('select[name="birth_month"]');
const ageInfoBox        = form.querySelector('.age-info-box');
const ageInfoTitle      = form.querySelector('.age-info-box-title');
const ageInfoText       = form.querySelector('.age-info-box-text');
const ageInfoKitten     = form.querySelector('.age-info-inputs--kitten');
const ageInfoAdult      = form.querySelector('.age-info-inputs--adult');
const ageCardsRow       = form.querySelector('.age-cards-row');
const ageInputWrap      = form.querySelector('.age-input-wrap') || form.querySelector('.age-input-card');

const weightInput       = form.querySelector('input[name="weight"]');


// Placeholder-Styling fürs Gewichtsfeld (grau hinterlegt, nur solange kein Wert eingegeben ist)
if (weightInput) {
  weightInput.classList.add("cq-weight-input");
  if (!document.getElementById("cq-weight-placeholder-style")) {
    const st = document.createElement("style");
    st.id = "cq-weight-placeholder-style";
    st.textContent = `
      input.cq-weight-input::placeholder { color: rgba(0,0,0,0.55); }
      input.cq-weight-input:placeholder-shown { background-color: rgba(0,0,0,0.04); }
    `;
    document.head.appendChild(st);
  }
}

                    /// API KEYS ///
const OPTIN_ENDPOINT_URL = "https://fellinora-optin.crimson-breeze-0d16.workers.dev/";

// Turnstile Site Key (aus Cloudflare Turnstile → dein Site Key)
const TURNSTILE_SITE_KEY = "0x4AAAAAACexW16jk2NUtoS4";
// ==================================================
// Persistenz: Quiz-State in localStorage speichern
// ==================================================
const QUIZ_STORAGE_KEY = 'fellinora_catquiz_state_v1';

// ==================================================
// Reload vs Wiederöffnen:
// - Reload (Cmd+R/F5): gleicher Step im selben Tab
// - Seite später neu öffnen / neue Navigation: Step 1 (Index 0) mit Prefill
// ==================================================
const QUIZ_SESSION_STEP_KEY = "fellinora_catquiz_session_step_v1";
function getNavigationTypeSafe() {
  try {
    const nav = performance.getEntriesByType && performance.getEntriesByType("navigation");
    const type = nav && nav[0] && nav[0].type;
    return type || "navigate"; // "reload" | "navigate" | "back_forward"
  } catch (e) {
    return "navigate";
  }
}

function saveSessionStep(stepIndex) {
  try {
    const stepEl = steps && steps[stepIndex];
    const stepNoRaw = stepEl && stepEl.dataset ? Number(stepEl.dataset.step) : NaN;
    const payload = {
      i: Number(stepIndex),
      stepNo: Number.isFinite(stepNoRaw) ? stepNoRaw : null,
      ts: Date.now(),
    };
    sessionStorage.setItem(QUIZ_SESSION_STEP_KEY, JSON.stringify(payload));
  } catch {}
}

function loadSessionStep() {
  try {
    const raw = sessionStorage.getItem(QUIZ_SESSION_STEP_KEY);
    if (!raw) return null;

    // New format: JSON { i, stepNo }
    const parsed = safeJsonParse(raw);
    if (parsed && typeof parsed === "object") {
      const stepNo = Number(parsed.stepNo);
      if (Number.isFinite(stepNo) && Array.isArray(steps)) {
        const idx = steps.findIndex((s) => Number(s?.dataset?.step) === stepNo);
        if (idx >= 0) return idx;
      }
      const i = Number(parsed.i);
      return Number.isFinite(i) ? i : null;
    }

    // Legacy format: plain number string
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}
// ==================================================
// Restore-Guard: verhindert Überschreiben beim Initial-Load
// ==================================================
let _isRestoringQuizState = false;

// Helper: wird im Breed-Block gesetzt, damit Restore die UI korrekt synchronisieren kann
let _syncBreedUIFromCurrentValue = null;


function safeJsonParse(str) {
  try { return JSON.parse(str); } catch { return null; }
}

function serializeFormState(formEl) {
  const fields = Array.from(formEl.querySelectorAll('input, select, textarea'));
  const state = {};

  fields.forEach((el) => {
    if (!el.name) return;

    const type = (el.type || '').toLowerCase();

    // Checkbox groups: speichere Array der gecheckten values
    if (type === 'checkbox') {
      if (!state[el.name]) state[el.name] = [];
      if (el.checked) state[el.name].push(el.value);
      return;
    }

    // Radio groups: speichere selected value
    if (type === 'radio') {
      if (el.checked) state[el.name] = el.value;
      else if (state[el.name] === undefined) state[el.name] = '';
      return;
    }

    // Text/number/hidden/textarea/select
    state[el.name] = el.value;
  });

  return state;
}

function applyFormState(formEl, savedFields) {
  if (!savedFields || typeof savedFields !== 'object') return;

  const fields = Array.from(formEl.querySelectorAll('input, select, textarea'));

  fields.forEach((el) => {
    if (!el.name) return;
    if (!(el.name in savedFields)) return;

    const type = (el.type || '').toLowerCase();
    const saved = savedFields[el.name];

    if (type === 'checkbox') {
      const arr = Array.isArray(saved) ? saved : [];
      el.checked = arr.includes(el.value);
      return;
    }

    if (type === 'radio') {
      el.checked = (saved === el.value);
      return;
    }

    el.value = (saved ?? '');
  });
}

function saveQuizState() {
  try {
    const payload = {
      v: 1,
      ts: Date.now(),
currentStep1Index: Number(currentStep1Index) || 0,
      currentStep4Index: Number(currentStep4Index) || 0,
      currentCookStepIndex: Number(currentCookStepIndex) || 0,
      currentBarfStepIndex: Number(currentBarfStepIndex) || 0,
      ageCategory: ageCategory || '',
      marketingSubmitDone: !!marketingSubmitDone,
      fields: serializeFormState(form),
    };

    localStorage.setItem(QUIZ_STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    // storage kann z.B. im Private Mode/blocked failen → still schweigend weiter
  }
}

function loadQuizState() {
  const raw = localStorage.getItem(QUIZ_STORAGE_KEY);
  if (!raw) return null;
  return safeJsonParse(raw);
}

function clearQuizState() {
  try { localStorage.removeItem(QUIZ_STORAGE_KEY); } catch {}
}

// kleines Debounce, damit nicht jede Taste sofort schreibt
let _saveTimer = null;
function scheduleSaveQuizState() {
  // WICHTIG: Während Restore nicht speichern (sonst überschreibt man saved state)
  if (_isRestoringQuizState) return;

  if (_saveTimer) clearTimeout(_saveTimer);
  _saveTimer = setTimeout(() => {
    _saveTimer = null;
    saveQuizState();
  }, 150);
}

// ==================================================
// Persistenz: Autosave bei JEDEM Input/Change
// ==================================================
if (form) {
  // Persistenz: Autosave bei JEDEM Input/Change + Live-ReRender auf Ergebnis/Abo
  function getCurrentStepNoSafe() {
    try {
      const el = steps && steps[currentStep];
      const n = el && el.dataset ? Number(el.dataset.step) : NaN;
      return Number.isFinite(n) ? n : null;
    } catch {
      return null;
    }
  }

  let _liveRenderT = null;

  function scheduleLiveRenderCurrentStep() {
    if (_liveRenderT) clearTimeout(_liveRenderT);
    _liveRenderT = setTimeout(() => {
      _liveRenderT = null;
      const stepNo = getCurrentStepNoSafe();
if (stepNo === 8) {
  deferStepRender(() => updateResultSummary());
} else if (stepNo === 9) {
  deferStepRender(() => updateSubscriptionOverview());
}

    }, 80);
  }

  function onAnyFormEdit() {
    scheduleSaveQuizState();
    scheduleLiveRenderCurrentStep();
  }

  form.addEventListener("input",  onAnyFormEdit, true);
  form.addEventListener("change", onAnyFormEdit, true);
  window.addEventListener("pagehide", () => {
    try { saveQuizState(); } catch {}
  });

  window.addEventListener("beforeunload", () => {
    try { saveQuizState(); } catch {}
  });
document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      try { saveQuizState(); } catch {}
    }
  });
}



// --------------------------------------------------
// Step 2: BCS (Körperbau) erst nach gültiger Gewichtseingabe anzeigen
// --------------------------------------------------

const bcsRadios = Array.from(form.querySelectorAll('input[name="bcs"]'));

// Versuche, einen sinnvollen Container für die gesamte BCS-Frage zu finden
const bcsContainer =
  bcsRadios[0]?.closest(".bcs-question") ||   // falls du einen Wrapper hast/ergänzt
  bcsRadios[0]?.closest(".bcs-fieldset") ||   // falls vorhanden
  bcsRadios[0]?.closest("fieldset") ||        // meistens ausreichend
  bcsRadios[0]?.closest(".form-card") ||      // fallback, falls ihr Cards nutzt
  null;

const bcsInfoBox   = form.querySelector(".bcs-info-box");
const bcsInfoTitle = form.querySelector(".bcs-info-box-title");
const bcsInfoText  = form.querySelector(".bcs-info-box-text");
const bcsExtraBox = form.querySelector(".bcs-extra-box");

function parseWeightValue() {
  const raw = (weightInput?.value || "").toString().trim().replace(",", ".");
  const n = parseFloat(raw);
  return Number.isFinite(n) ? n : NaN;
}


// ---------------------------------------
// Gewicht: Maximalwert (Business-Constraint)
// ---------------------------------------
const WEIGHT_MAX_KG = 8;

// Inline-Fehlermeldung unter dem Gewichtsfeld (ohne CSS-Anpassung)
let weightErrorEl = null;
(function ensureWeightErrorEl() {
  if (!weightInput) return;
  const label = weightInput.closest("label");
  if (!label) return;

  // Falls im HTML schon vorhanden -> nutzen
  weightErrorEl = label.querySelector(".weight-error");

  if (!weightErrorEl) {
    const p = document.createElement("p");
    p.className = "help-text weight-error";
    p.style.marginTop = "0.6rem";
    p.style.marginBottom = "0";
    p.style.fontWeight = "600";
    p.style.color = "#b00020";
    p.hidden = true;
    label.appendChild(p);
    weightErrorEl = p;
  }
})();

function validateWeight(showMessage = false) {
  if (!weightInput) return true;

  // Max-Attribut zur Sicherheit auch per JS setzen
  weightInput.setAttribute("max", String(WEIGHT_MAX_KG));

  const raw = (weightInput.value || "").toString().trim();
  if (!raw) {
    weightInput.setCustomValidity("");
    if (weightErrorEl) weightErrorEl.hidden = true;
    return true;
  }

  const w = parseWeightValue();

  // Nur der gewünschte Sonderfall: > 8 kg
  if (Number.isFinite(w) && w > WEIGHT_MAX_KG) {
    const msg = `Bitte gib ein Gewicht von maximal ${WEIGHT_MAX_KG} kg ein.`;
    try { weightInput.setCustomValidity(msg); } catch {}
    if (weightErrorEl) {
      weightErrorEl.textContent = msg;
      weightErrorEl.hidden = false;
    }
    if (showMessage) {
      try { weightInput.reportValidity(); } catch {}
    }
    return false;
  }

  // OK -> Fehler weg
  try { weightInput.setCustomValidity(""); } catch {}
  if (weightErrorEl) weightErrorEl.hidden = true;
  return true;
}

function restoreBCSInfoPlaceholder() {
  if (bcsInfoTitle) bcsInfoTitle.textContent = "Beschreibung zum Körperzustand";
  if (bcsInfoText)  bcsInfoText.textContent  = "Wähle einen Körperzustand aus, um eine kurze Beschreibung zu sehen.";
  if (bcsInfoBox)   bcsInfoBox.style.removeProperty("--bcs-arrow-left");
}


function updateBCSVisibility() {
  if (!bcsContainer || !bcsRadios.length) return;

  const w = parseWeightValue();
  const show = Number.isFinite(w) && w > 0 && w <= WEIGHT_MAX_KG;

  // BCS-Block und erste Infobox nur anzeigen, wenn Gewicht gültig ist
  bcsContainer.hidden = !show;
  if (bcsInfoBox) bcsInfoBox.hidden = !show;

  // Radios nur aktiv/required, wenn sichtbar
  bcsRadios.forEach(r => {
    r.disabled = !show;
    r.required = show;
  });

  const hasChecked = bcsRadios.some(r => r.checked);

  // Wenn Gewicht entfernt/ungültig: alles resetten
  if (!show) {
    bcsRadios.forEach(r => (r.checked = false));
    restoreBCSInfoPlaceholder();
    if (bcsExtraBox) bcsExtraBox.hidden = true;
    return;
  }

  // Gewicht vorhanden, aber noch kein BCS gewählt: Placeholder anzeigen
  if (!hasChecked) {
    restoreBCSInfoPlaceholder();
  }

  // Extra-Box konsistent setzen (wichtig!)
  if (bcsExtraBox) bcsExtraBox.hidden = !hasChecked;
}

// Initial einmal ausführen
updateBCSVisibility();





// --------------------------------------------------
  // INPUTS die in mehreren Bereichen gebraucht werden
  // (MUSS vor updateBreedWeightInfo() existieren!)
  // --------------------------------------------------

  const sexInputs      = Array.from(form.querySelectorAll('input[name="sex"]'));
  const neuteredInputs = Array.from(form.querySelectorAll('input[name="neutered"]'));

  // --------------------------------------------------
  // Gewichts-Infofeld (Tabelle B): reagiert auf Rasse + Geschlecht
  // --------------------------------------------------

  const weightRangeBox   = form.querySelector(".weight-range-box");
  const weightRangeTitle = form.querySelector(".weight-range-title");
  const weightRangeText  = form.querySelector(".weight-range-text");

  // Tabelle B: Rasse -> { female: [min,max], male: [min,max] }
  const BREED_WEIGHT_RANGES = {
    "Abessinier": { female: [2.5, 3.5], male: [3.0, 4.0] },
    "Burma": { female: [2.5, 3.5], male: [3.0, 4.0] },
    "Devon Rex": { female: [2.5, 3.5], male: [3.0, 4.0] },
    "Siam": { female: [2.5, 3.5], male: [3.0, 4.0] },
    "Somali-Katze": { female: [2.5, 3.5], male: [3.0, 4.0] },

    "Europäisch Kurzhaar (Mischling)": { female: [3.0, 3.5], male: [4.0, 4.5] },
    "Heilige Birma": { female: [3.0, 3.5], male: [4.0, 4.5] },
    "Perser": { female: [3.0, 3.5], male: [4.0, 4.5] },
    "British Kurzhaar": { female: [3.5, 4.0], male: [4.5, 5.0] },

    "Karthäuser (Chartreux)": { female: [3.5, 4.0], male: [4.5, 5.0] },

    "Sibirische Katze": { female: [3.0, 6.0], male: [4.5, 8.0] },

    "Maine Coon": { female: [4.0, 6.5], male: [5.5, 9.0] },
    "Norwegische Waldkatze": { female: [4.0, 6.5], male: [5.5, 9.0] },

    "Bengal": { female: [4.0, 4.0], male: [5.5, 5.5] },
    "Orientalisch Kurzhaar": { female: [3.0, 4.0], male: [4.0, 5.0] },
    "Russisch Blau": { female: [2.5, 4.5], male: [3.5, 6.5] },
    "Scottish Fold": { female: [2.6, 6.0], male: [2.6, 6.0] },
    "Selkirk Rex": { female: [4.0, 6.0], male: [5.0, 7.0] },
    "American Bobtail": { female: [3.0, 7.0], male: [3.0, 7.0] },
    "Balinese": { female: [3.0, 4.0], male: [4.0, 5.0] },
    "British Langhaar": { female: [4.0, 5.5], male: [5.0, 7.5] },
    "Deutsch Langhaar": { female: [3.5, 5.0], male: [4.0, 6.0] },
    "Orientalisch Langhaar": { female: [3.0, 4.0], male: [4.0, 5.0] },
    "Ragdoll": { female: [4.5, 6.5], male: [6.5, 10.0] },
    "Türkisch Angora": { female: [2.5, 4.0], male: [3.0, 5.0] },
    "Tonkanese": { female: [3.0, 4.0], male: [4.0, 5.0] },
    "Singapura": { female: [2.0, 3.0], male: [2.5, 3.0] },
    "Koratkatze": { female: [4.5, 6.5], male: [4.5, 6.5] },
    "Exotic Shorthair": { female: [3.0, 3.0], male: [3.5, 3.5] },
    "Cornish Rex": { female: [2.5, 3.5], male: [3.0, 4.5] },
    "Burmilla": { female: [2.5, 4.5], male: [3.5, 6.5] },
    "Ägyptisch Mau": { female: [3.0, 3.0], male: [4.0, 4.0] }
  };

  // Aliases für eure UI-Werte
  const BREED_ALIASES = {
    "Europäisch Kurzhaar oder Mischling": "Europäische Hauskatze (Mischling)",
    "Karthäuser": "Karthäuser (Chartreux)",
    // wichtig: falls irgendwo "Mischling" als Wert auftaucht
    "Mischling": "Europäische Hauskatze (Mischling)"
  };

  function formatKg(n) {
    const s = (Math.round(n * 10) / 10).toString();
    return s.replace(".", ",");
  }

  function getSelectedSexKey() {
    const checked = sexInputs && sexInputs.find(r => r.checked);
    const raw = (checked?.value || "").toString().trim().toLowerCase();

    if (!raw) return "";

    if (["weiblich", "female", "katze", "w", "f"].includes(raw)) return "female";
    if (["männlich", "maennlich", "male", "kater", "m"].includes(raw)) return "male";

    if (raw === "female" || raw === "male") return raw;

    return "";
  }

  function resolveBreedKey() {
    const rawHidden = (breedHiddenInput?.value || "").trim();
    const rawText   = (breedTextInput?.value || "").trim();
    const raw = rawHidden || rawText;

    if (!raw) return "";

    const aliased = BREED_ALIASES[raw] || raw;

    if (BREED_WEIGHT_RANGES[aliased]) return aliased;

    const lower = aliased.toLowerCase();
    const match = Object.keys(BREED_WEIGHT_RANGES).find(k => k.toLowerCase() === lower);
    return match || "";
  }
function updateBreedWeightInfo() {
  const sexKey   = getSelectedSexKey();   // "female" | "male" | ""
  const breedKey = resolveBreedKey();     // exakter Key aus BREED_WEIGHT_RANGES oder ""

  // 1) Placeholder im Gewichtsfeld (grau im Input, wie gewünscht)
  if (weightInput) {
    let placeholder = "";
    if (sexKey && breedKey) {
      const ranges = BREED_WEIGHT_RANGES[breedKey];
      const r = ranges?.[sexKey];
      if (r && Array.isArray(r) && r.length >= 2) {
        const min = r[0];
        const max = r[1];
        placeholder = `Geschätzter Gewichtsbereich: ${formatKg(min)} - ${formatKg(max)} kg`;
      }
    }
    if ((weightInput.placeholder || "") !== placeholder) {
      weightInput.placeholder = placeholder;
    }
  }

  // 2) Unteres Infobox-Verhalten (Text ersetzt wie gewünscht)
  if (!weightRangeBox || !weightRangeTitle || !weightRangeText) return;

  if (!sexKey || !breedKey) {
    weightRangeTitle.textContent = "Gewicht & Gesundheit";
    weightRangeText.textContent  = "Wähle in Schritt 1 Geschlecht und Rasse, um eine Einschätzung zum Normalbereich zu erhalten.";
    weightRangeBox.hidden        = false;
    return;
  }

  const ranges = BREED_WEIGHT_RANGES[breedKey];
  const r = ranges?.[sexKey];
  if (!r) {
    weightRangeBox.hidden = true;
    return;
  }

  const min = r[0];
  const max = r[1];

  // Name dynamisch einsetzen
  const rawName = (nameInput?.value || "").trim();
  const hasName = !!rawName;
  const nameForSentence1 = hasName ? rawName : "Deine Katze";
  const nameForSentence2 = hasName ? rawName : "deiner Katze";

  const entered = parseFloat(weightInput?.value || "");

    let message = "";
  if (!Number.isNaN(entered) && entered > 0) {
    if (entered < min) {
      message = `${nameForSentence1} hat ein Gewicht unterhalb des empfohlenen Idealbereichs.`;
    } else if (entered > max) {
      message = `${nameForSentence1} hat ein Gewicht oberhalb des empfohlenen Idealbereichs.`;
    } else {
      message = `${nameForSentence1} hat ein Gewicht innerhalb des empfohlenen Idealbereichs.`;
    }
  } else {
    message = "Trage das Gewicht ein, um eine Einschätzung zu erhalten.";
  }


  weightRangeTitle.textContent = "Gewicht & Gesundheit";
  weightRangeText.textContent  = message;
  weightRangeBox.hidden        = false;
}
  // Listener: bei Änderungen neu rendern
  if (sexInputs && sexInputs.length) {
    sexInputs.forEach(r => r.addEventListener("change", updateBreedWeightInfo));
  }
if (weightInput) {
  weightInput.addEventListener("input", () => {
    // Live validieren (inline Hinweis) + UI updaten
    validateWeight(false);
    updateBreedWeightInfo();
    updateBCSVisibility();
    try { syncNextButtonState(); } catch {}
  });

  // Auf Blur auch die Browser-Fehlermeldung zeigen (falls ungültig)
  weightInput.addEventListener("blur", () => {
    validateWeight(true);
  });

  // Initialzustand (z.B. nach Restore)
  validateWeight(false);
}


  // --------------------------------------------------
  // Autocomplete für Rasse + Hidden-Sync
  // --------------------------------------------------

  // Helper: wird im Mischling-Block gesetzt (siehe weiter unten)
  let cqSetMixState = null;

  function renderBreedSuggestions(matches) {
    if (!breedSuggestions) return;

    if (!matches.length) {
      breedSuggestions.innerHTML = "";
      breedSuggestions.hidden = true;
      return;
    }

    const html = matches
      .slice(0, 300)
      .map(breed =>
        `<li data-value="${breed.replace(/"/g, "&quot;")}">${breed}</li>`
      )
      .join("");

    breedSuggestions.innerHTML = html;
    breedSuggestions.hidden = false;
  }

  function handleBreedInput() {
    if (!breedTextInput || !breedSuggestions) return;

    const query = (breedTextInput.value || "").trim().toLowerCase();

    if (!query) {
      renderBreedSuggestions(CAT_BREEDS);
      return;
    }

    const startsWithMatches = CAT_BREEDS.filter(b =>
      b.toLowerCase().startsWith(query)
    );
    const includesMatches = CAT_BREEDS.filter(b =>
      !startsWithMatches.includes(b) && b.toLowerCase().includes(query)
    );

    renderBreedSuggestions([...startsWithMatches, ...includesMatches]);
  }

  if (breedTextInput && breedSuggestions) {
    breedTextInput.addEventListener("input", () => {
      // Wenn Mischling aktiv ist und der Nutzer trotzdem in die Rassen-Eingabe geht,
      // sofort sauber auf "Rasse" umschalten.
      const mixActive = breedMixBtn && breedMixBtn.classList.contains("is-active");
      if (mixActive) {
        if (typeof cqSetMixState === "function") {
          cqSetMixState(false);
        } else {
          // Fallback (sollte kaum nötig sein)
          breedMixBtn.classList.remove("is-active");
          breedTextInput.classList.remove("breed-text--disabled");
          breedTextInput.readOnly = false;
          breedTextInput.required = true;
        }
      }

      // Autocomplete updaten
      handleBreedInput();

      // Hidden-Feld syncen (solange nicht Mischling aktiv ist)
      const mixActiveAfter = breedMixBtn && breedMixBtn.classList.contains("is-active");
      if (breedHiddenInput && !mixActiveAfter) {
        breedHiddenInput.value = breedTextInput.value.trim();
        // Change-Event für Persistenz/Progress/Validierung
        const ev = new Event("change", { bubbles: true });
        breedHiddenInput.dispatchEvent(ev);
      }

      updateBreedWeightInfo();
      try { syncNextButtonState(); } catch {}
    });

breedTextInput.addEventListener("focus", () => {
      // Keyboard-Fokus soll genauso wie Klick sofort auf "Rasse" umschalten
      const mixActive = breedMixBtn && breedMixBtn.classList.contains("is-active");
      if (mixActive) {
        if (typeof cqSetMixState === "function") {
          cqSetMixState(false);
        } else {
          breedMixBtn.classList.remove("is-active");
          breedTextInput.classList.remove("breed-text--disabled");
          breedTextInput.readOnly = false;
          breedTextInput.required = true;
        }
      }
      renderBreedSuggestions(CAT_BREEDS);
    });

breedTextInput.addEventListener("blur", () => {
      setTimeout(() => {
        if (breedSuggestions) breedSuggestions.hidden = true;
      }, 150);
    });

    breedSuggestions.addEventListener("mousedown", e => {
      const li = e.target.closest("li");
      if (!li) return;

      const value = li.dataset.value || li.textContent;

      // Wenn vorher Mischling aktiv war, jetzt wirklich auf "Rasse" umschalten,
      // damit Hidden-Wert + Line-Item-Properties korrekt die Rasse übernehmen.
      const mixActive = breedMixBtn && breedMixBtn.classList.contains("is-active");
      if (mixActive) {
        if (typeof cqSetMixState === "function") {
          cqSetMixState(false);
        } else {
          breedMixBtn.classList.remove("is-active");
          breedTextInput.classList.remove("breed-text--disabled");
          breedTextInput.readOnly = false;
          breedTextInput.required = true;
        }
      }

      breedTextInput.value = value;

      // Hidden-Feld IMMER aktualisieren (Rasse gewinnt)
      if (breedHiddenInput) {
        breedHiddenInput.value = value.trim();
        const ev = new Event("change", { bubbles: true });
        breedHiddenInput.dispatchEvent(ev);
      }

      updateBreedWeightInfo();
      updateBCSVisibility();
      try { syncNextButtonState(); } catch {}

      const len = value.length;
      setTimeout(() => {
        breedTextInput.focus();
        breedTextInput.setSelectionRange(len, len);
      }, 0);

      breedSuggestions.hidden = true;
      e.preventDefault();
    });

}

  

  // --------------------------------------------------
  // Mischling-Toggle (robust + ohne Syntaxfehler)
  // --------------------------------------------------

  if (breedHiddenInput && breedTextInput && breedMixBtn) {
    // Default so wählen, dass es über BREED_ALIASES zu einem echten Key wird
    const mixValue = (breedMixBtn.dataset.breedValue || "Europäisch Kurzhaar (Mischling)").trim();

    // Merker: falls Nutzer erst eine Rasse getippt/ausgewählt hat und dann auf "Mischling" wechselt
    let lastNonMixBreedText = "";
    let lastNonMixBreedHidden = "";

    function setMixState(isOn) {
      breedMixBtn.classList.toggle("is-active", isOn);

      if (isOn) {
        // Vorherige (nicht-Mix) Auswahl merken, damit man bequem zurückwechseln kann
        const currentHidden = (breedHiddenInput.value || "").trim();
        const currentText   = (breedTextInput.value || "").trim();

        if (currentHidden && currentHidden !== mixValue) lastNonMixBreedHidden = currentHidden;
        if (currentText && currentText !== mixValue)     lastNonMixBreedText   = currentText;

        breedHiddenInput.value = mixValue;

        // Das sichtbare Feld "deaktiviert" wirken lassen, aber klickbar lassen,
        // damit ein Klick direkt zurück zur Rassen-Eingabe wechseln kann.
        breedTextInput.value = "";
        breedTextInput.classList.add("breed-text--disabled");
        breedTextInput.readOnly = true;

        // Wichtig: required temporär entfernen, damit validateStep nicht blockiert
        breedTextInput.required = false;

        if (breedSuggestions) breedSuggestions.hidden = true;
      } else {
        // Zurück in die Rassen-Eingabe wechseln
        breedTextInput.classList.remove("breed-text--disabled");
        breedTextInput.readOnly = false;
        breedTextInput.required = true;

        // Falls es vorher eine Eingabe gab, wiederherstellen
        const restore = (lastNonMixBreedHidden || lastNonMixBreedText || "").trim();

        if (restore) {
          breedHiddenInput.value = restore;
          breedTextInput.value = restore;
        } else {
          breedHiddenInput.value = "";
          // Falls im Feld noch irgendwo Mix-Text stehen sollte, leeren
          if ((breedTextInput.value || "").trim() === mixValue) breedTextInput.value = "";
        }

        breedTextInput.focus();
      }

      updateBreedWeightInfo();
      try { syncNextButtonState(); } catch {}
    }

    // Für andere Handler verfügbar machen
    cqSetMixState = setMixState;

    // Toggle klicken
  // Toggle klicken
  breedMixBtn.addEventListener("click", (e) => {
    e.preventDefault();
    const nowOn = !breedMixBtn.classList.contains("is-active");
    setMixState(nowOn);

    // Progress neu berechnen, weil sich der Wert von "breed" ändert
    if (breedHiddenInput) {
      const ev = new Event("change", { bubbles: true });
      breedHiddenInput.dispatchEvent(ev);
    }
  });
    // UX: Wenn "Mischling" aktiv ist, soll ein Klick in die Rassen-Eingabe
    // direkt auf die andere Option wechseln (wie bei Radio-Buttons).
    const switchOffMixIfActive = (e) => {
      if (!breedMixBtn.classList.contains("is-active")) return;
      e && e.preventDefault && e.preventDefault();
      setMixState(false);
      // Fokus sauber setzen (nach State-Update)
      try { requestAnimationFrame(() => breedTextInput.focus()); } catch {}
    };

    // pointerdown fängt den ersten Klick sofort ab (auch bevor "click" kommt)
    breedTextInput.addEventListener("pointerdown", switchOffMixIfActive);
    breedTextInput.addEventListener("mousedown", switchOffMixIfActive);




    // Falls beim Reload bereits Mischling aktiv (Hidden-Wert gesetzt)
function syncBreedUIFromCurrentValue() {
  const hidden = (breedHiddenInput.value || "").trim();
  const text   = (breedTextInput.value || "").trim();

  const isMix =
    !!hidden &&
    (
      hidden === mixValue ||
      hidden === "Europäisch Kurzhaar (Mischling)" ||
      hidden === "Europäisch Kurzhaar oder Mischling" ||
      hidden === "Europäische Hauskatze (Mischling)" ||
      BREED_ALIASES[hidden] === "Europäische Hauskatze (Mischling)"
    );

  if (isMix) {
    setMixState(true);
    // Normalize hidden value (für konsistentes Speichern)
    breedHiddenInput.value = mixValue;
  } else {
    // UI auf "nicht-Mischling" setzen, OHNE hidden zu löschen (wichtig fürs Restore)
    breedMixBtn.classList.remove("is-active");
    breedTextInput.classList.remove("breed-text--disabled");
    breedTextInput.readOnly = false;
    breedTextInput.required = true;

    // Falls hidden Wert existiert, aber das sichtbare Feld leer ist → sichtbar vorbefüllen
    if (!text && hidden) breedTextInput.value = hidden;
  }
}

// Für Restore verfügbar machen
_syncBreedUIFromCurrentValue = syncBreedUIFromCurrentValue;

// Initial: UI aus vorhandenem hidden/text Wert ableiten
syncBreedUIFromCurrentValue();
}

  // Initial
  updateBreedWeightInfo();



  // Step-1: Fragen nacheinander
  const step1Questions    = Array.from(form.querySelectorAll(".step1-question"));
  const step1Nav          = form.querySelector(".quiz-nav--step1");
  // Step 1: Nav-Buttons (Back immer sichtbar, Next nur auf letzter Subfrage)
const step1NextBtn = step1Nav ? step1Nav.querySelector(".btn-next") : null;
let step1BackBtn   = step1Nav ? step1Nav.querySelector(".btn-back") : null;

// Falls im Liquid kein Back-Button existiert: per JS ergänzen
if (step1Nav && !step1BackBtn) {
  step1BackBtn = document.createElement("button");
  step1BackBtn.type = "button";
  step1BackBtn.className = "btn-back";
  step1BackBtn.textContent = "Zurück";
  // Back links platzieren
  step1Nav.insertBefore(step1BackBtn, step1Nav.firstChild);
}

   // Step-4: Fragen nacheinander
  const step4Questions    = Array.from(form.querySelectorAll(".step4-question"));
  const step4Nav          = form.querySelector(".quiz-nav--step4");

  // Step 6.75/6.85: Kochplan/BARF – Frageblöcke
  const cookPlanQuestions = Array.from(form.querySelectorAll('.cookplan-step[data-step="6.75"] .cookplan-question'));
  const barfPlanQuestions = Array.from(form.querySelectorAll('.barfplan-step[data-step="6.85"] .barfplan-question'));
  const allergyInputs     = Array.from(form.querySelectorAll('.allergy-fieldset input[name="allergy_protein"]'));
  const feedingFreqInputs = Array.from(form.querySelectorAll('input[name="feeding_frequency"]'));

  // Wählerischkeit / Picky
  const pickyHiddenInput  = form.querySelector('.picky-fieldset input[name="picky_level"]');
  const pickyOptions      = Array.from(form.querySelectorAll('.picky-option'));
  const pickyDescription  = form.querySelector('.picky-description'); // falls noch vorhanden
  const pickyInfoBox      = form.querySelector('.picky-info-box');
  const pickyInfoText     = pickyInfoBox
    ? pickyInfoBox.querySelector('.picky-info-box-text')
    : null;
  const pickyInputs       = pickyHiddenInput ? [pickyHiddenInput] : []; // für Restore-Logik

  // Hauptfutter-Auswahl
  const currentFoodInputs = Array.from(
    form.querySelectorAll('.food-fieldset input[name="current_food"]')
  );

  // Infobox im Allergy-Step
  const allergyInfoBox     = form.querySelector('.allergy-info-box');
  const allergyInfoBoxText = allergyInfoBox
    ? allergyInfoBox.querySelector('.allergy-info-box-text')
    : null;




  let currentStep1Index   = 0; // 0 = Name, 1 = Alter, 2 = Geschlecht, 3 = Kastriert, 4 = Rasse
  let currentStep4Index   = 0; // 0 = Allergien, 1 = Fütterungshäufigkeit, 2 = Wählerischkeit, 3 = Hauptfutter

  // Step 6.75/6.85: Kochplan & BARF – progressive Fragen auf einer Seite
  let currentCookStepIndex = 0; // 0 = Q1, 1 = Q2, 2 = Q3 (nur wenn <7 Tage)
  let currentBarfStepIndex = 0; // 0 = Q1, 1 = Q2, 2 = Q3 (nur wenn <7 Tage)


  
const neuteredInfoBox   = form.querySelector('.neutered-info-box');
const neuteredInfoTitle = form.querySelector('.neutered-info-title');
const neuteredInfoText  = form.querySelector('.neutered-info-text');
  
const NEUTERED_TEXTS = {
  kastriert: {
    title: "Kastriert",
    text: "Kastrierte Katzen haben oft einen höheren Appetit und frei verfügbares Futter sollte vermieden werden."
  },
  nicht_kastriert: {
    title: "Nicht kastriert",
    text: "Eine Kastration verhindert nicht nur eine unkontrollierte Fortpflanzung, sondern hat auch positive Auswirkungen auf Gesundheit & Verhalten."
  }
};

 // --------------------------------------------------
// Popovers (Health + Social) – wirklich viewport-fixed
// Fix: Portale die Panels in <body>, sonst "fixed" innerhalb transform-Parent
// --------------------------------------------------

const healthInfoPanel   = document.querySelector(".health-info-panel");
const healthInfoHeading = healthInfoPanel?.querySelector(".health-info-heading");
const healthInfoText    = healthInfoPanel?.querySelector(".health-info-text");

const socialInfoPanel   = document.querySelector(".social-info-panel");
const socialInfoHeading = socialInfoPanel?.querySelector(".social-info-heading");
const socialInfoText    = socialInfoPanel?.querySelector(".social-info-text");

let currentHealthInfoKey = null;
let currentSocialInfoKey = null;


let currentOwnfoodInfoKey = null;
function portalPopover(panel) {
  if (!panel) return;
  if (panel.dataset.portaled === "1") return;

  // Wichtig: raus aus dem Quiz-Container, rein in body
  document.body.appendChild(panel);
  panel.dataset.portaled = "1";
}

function hidePopover(panel) {
  if (!panel) return;
  panel.hidden = true;
}

function positionPopover(panel, anchorEl, offsetPx = 12) {
  if (!panel || !anchorEl) return;

  // Panel sichtbar machen, damit offsetWidth korrekt ist
  panel.hidden = false;

  const rect = anchorEl.getBoundingClientRect();

  // Du nutzt in CSS transform: translateX(-50%) für die Panels (zentriert)
  // Deshalb setzen wir left auf die Mitte des Buttons und clampen anhand der Panelbreite.
  const panelWidth = panel.offsetWidth || 260; // Fallback
  const half = panelWidth / 2;

  let left = rect.left + rect.width / 2;
  let top  = rect.bottom + offsetPx;

  const padding = 12;
  left = Math.max(left, half + padding);
  left = Math.min(left, window.innerWidth - half - padding);

  panel.style.left = `${left}px`;
  panel.style.top  = `${top}px`;
}

function hideAllPopovers() {
  currentHealthInfoKey = null;
  currentSocialInfoKey = null;
  currentOwnfoodInfoKey = null;

  hidePopover(healthInfoPanel);
  hidePopover(socialInfoPanel);

  // Ownfood: es kann (nach Re-render / Back+Forward) mehrere Panels geben.
  // Alle schließen, sonst "klebt" eins im DOM.
  document.querySelectorAll(".ownfood-info-panel").forEach((p) => {
    p.hidden = true;
  });
}


// 1) Portale einmalig – das ist der eigentliche Fix gegen “scrollt mit”
portalPopover(healthInfoPanel);
portalPopover(socialInfoPanel);

// 2) UX: Beim Scroll/Resize Popover schließen (sonst “klebt” es irgendwo)
window.addEventListener("scroll", hideAllPopovers, true);
window.addEventListener("resize", hideAllPopovers);

// 3) Klick außerhalb schließt Popover
document.addEventListener("click", (e) => {
  const insideHealth  = e.target.closest(".health-info-panel")  || e.target.closest(".health-info-btn");
  const insideSocial  = e.target.closest(".social-info-panel")  || e.target.closest(".social-info-btn");
  const insideOwnfood = e.target.closest(".ownfood-info-panel") || e.target.closest(".ownfood-info-btn");
  if (insideHealth || insideSocial || insideOwnfood) return;

  hideAllPopovers();
});

  // Zustände
  let currentStep          = 0;   // Index im steps-Array
  let ageCategory          = "";   // "kitten" | "adult" | "senior"
  let navInFlight = false; // globaler Lock für Next/Back (wichtig: NICHT im Click-Handler!)

  // --------------------------------------------------
  // Step 1 & 4: Progressive Fragen
  // --------------------------------------------------

function updateStep1Questions() {
  if (!step1Questions.length) return;

  step1Questions.forEach((q, i) => {
    q.hidden = i > currentStep1Index;
  });

  // Leiste immer sichtbar
  if (step1Nav) step1Nav.style.display = "flex";

  // Disabled-State vom Weiter-Button aktualisieren
  try { syncNextButtonState(); } catch {}
}

function updateStep4Questions() {
  if (!step4Questions.length) return;

  const adult = isAdultCat();

  step4Questions.forEach((q, i) => {
    const isFrequencyQuestion = q.classList.contains("step4-question--frequency");

    if (!adult && isFrequencyQuestion) {
      q.hidden = true;
      return;
    }

    q.hidden = i > currentStep4Index;
  });

  // Leiste immer sichtbar
  if (step4Nav) step4Nav.style.display = "flex";

  // Disabled-State vom Weiter-Button aktualisieren
  try { syncNextButtonState(); } catch {}
}

// --------------------------------------------------
// Step 6.75 (Kochplan) & Step 6.85 (BARF): Progressive Fragen
// --------------------------------------------------

function cqFormatDays(n) {
  const num = Number(n) || 0;
  return num === 1 ? "1 Tag" : `${num} Tage`;
}

function cqSetInputsDisabled(rootEl, selector, disabled) {
  if (!rootEl) return;
  rootEl.querySelectorAll(selector).forEach((el) => {
    try { el.disabled = !!disabled; } catch {}
  });
}

function updateCookPlanQuestions() {
  const stepEl = form.querySelector('.cookplan-step[data-step="6.75"]');
  if (!stepEl || !cookPlanQuestions.length) return;

  const days = Number(stepEl.querySelector('input[name="cook_days"]:checked')?.value || 0);
  const needsWet = Number.isFinite(days) && days > 0 && days < 7;

  // Wenn kein Nassfutter nötig ist, darf Q3 nicht aktiv bleiben
  if (!needsWet && currentCookStepIndex > 1) currentCookStepIndex = 1;

  cookPlanQuestions.forEach((q, i) => {
    if (i === 2) {
      q.hidden = !(needsWet && currentCookStepIndex >= 2);
    } else {
      q.hidden = i > currentCookStepIndex;
    }
  });

  // Q2 erst aktiv, wenn Q1 beantwortet
  cqSetInputsDisabled(stepEl, 'input[name="cook_days"]', currentCookStepIndex < 1);

  // Dynamischer Text (Q2)
  const infoBox = stepEl.querySelector(".cookplan-days-info");
  const infoText = infoBox ? infoBox.querySelector(".frequency-info-box-text") : null;

  if (infoBox && infoText) {
    if (!days) {
      infoBox.hidden = true;
      infoText.textContent = "";
    } else {
      infoBox.hidden = false;

      if (days >= 7) {
        infoText.textContent = "Du fütterst deine Katze 7 Tage pro Woche mit selbst gekochten Mahlzeiten.";
      } else {
        const rest = 7 - days;
        infoText.textContent =
          `Du fütterst deine Katze ${cqFormatDays(days)} pro Woche mit selbst gekochten Mahlzeiten und ${cqFormatDays(rest)} mit einem ergänzenden Nassfutter.`;
      }
    }
  }

  // Q3 Inputs nur aktiv, wenn nötig
  const wetEnabled = needsWet && currentCookStepIndex >= 2;
  cqSetInputsDisabled(stepEl, 'input[name="cookwet_protein_step"], input[name="cookwet_fat_step"], input[name="cookwet_ash_step"], input[name="cookwet_fiber_step"], input[name="cookwet_moisture_step"]', !wetEnabled);

  // Wenn Q3 wegfällt: Werte leeren (damit nichts "mitgeschleppt" wird)
  if (!needsWet) {
    ["cookwet_protein_step","cookwet_fat_step","cookwet_ash_step","cookwet_fiber_step","cookwet_moisture_step"].forEach((n) => {
      const el = stepEl.querySelector(`input[name="${n}"]`);
      if (el) el.value = "";
    });
    const meEl = stepEl.querySelector('input[name="cookwet_me"]');
    if (meEl) meEl.value = "";
  }

  try { syncNextButtonState(); } catch {}
}

function updateBarfPlanQuestions() {
  const stepEl = form.querySelector('.barfplan-step[data-step="6.85"]');
  if (!stepEl || !barfPlanQuestions.length) return;

  const days = Number(stepEl.querySelector('input[name="barf_days"]:checked')?.value || 0);
  const needsWet = Number.isFinite(days) && days > 0 && days < 7;

  if (!needsWet && currentBarfStepIndex > 1) currentBarfStepIndex = 1;

  barfPlanQuestions.forEach((q, i) => {
    if (i === 2) {
      q.hidden = !(needsWet && currentBarfStepIndex >= 2);
    } else {
      q.hidden = i > currentBarfStepIndex;
    }
  });

  cqSetInputsDisabled(stepEl, 'input[name="barf_days"]', currentBarfStepIndex < 1);

  const infoBox = stepEl.querySelector(".barfplan-days-info");
  const infoText = infoBox ? infoBox.querySelector(".frequency-info-box-text") : null;

  if (infoBox && infoText) {
    if (!days) {
      infoBox.hidden = true;
      infoText.textContent = "";
    } else {
      infoBox.hidden = false;

      if (days >= 7) {
        infoText.textContent = "Du fütterst deine Katze 7 Tage pro Woche mit Rohfleisch (BARF).";
      } else {
        const rest = 7 - days;
        infoText.textContent =
          `Du fütterst deine Katze ${cqFormatDays(days)} pro Woche mit Rohfleisch und ${cqFormatDays(rest)} mit einem Nassfutter deiner Wahl.`;
      }
    }
  }

  const wetEnabled = needsWet && currentBarfStepIndex >= 2;
  cqSetInputsDisabled(stepEl, 'input[name="barfwet_protein_step"], input[name="barfwet_fat_step"], input[name="barfwet_ash_step"], input[name="barfwet_fiber_step"], input[name="barfwet_moisture_step"]', !wetEnabled);

  if (!needsWet) {
    ["barfwet_protein_step","barfwet_fat_step","barfwet_ash_step","barfwet_fiber_step","barfwet_moisture_step"].forEach((n) => {
      const el = stepEl.querySelector(`input[name="${n}"]`);
      if (el) el.value = "";
    });
    const meEl = stepEl.querySelector('input[name="barfwet_me"]');
    if (meEl) meEl.value = "";
  }

  try { syncNextButtonState(); } catch {}
}

// Init Listener (einmalig)
(function initCookAndBarfProgressiveSteps() {
  const cookEl = form.querySelector('.cookplan-step[data-step="6.75"]');
  if (cookEl) {
    cookEl.addEventListener("change", (e) => {
      const t = e.target;

      if (t && t.matches && t.matches('input[name="cook_familiarity"]')) {
        currentCookStepIndex = Math.max(currentCookStepIndex, 1);
        updateCookPlanQuestions();
        try { scheduleSaveQuizState(); } catch {}
      }

      if (t && t.matches && t.matches('input[name="cook_days"]')) {
        const days = Number(cookEl.querySelector('input[name="cook_days"]:checked')?.value || 0);
        if (days && days < 7) currentCookStepIndex = 2;
        else if (days) currentCookStepIndex = Math.max(currentCookStepIndex, 1);
        updateCookPlanQuestions();
        try { scheduleSaveQuizState(); } catch {}
      }
    });

    // initial UI state (für Back/Reload)
    updateCookPlanQuestions();
  }

  const barfEl = form.querySelector('.barfplan-step[data-step="6.85"]');
  if (barfEl) {
    barfEl.addEventListener("change", (e) => {
      const t = e.target;

      if (t && t.matches && t.matches('input[name="barf_familiarity"]')) {
        currentBarfStepIndex = Math.max(currentBarfStepIndex, 1);
        updateBarfPlanQuestions();
        try { scheduleSaveQuizState(); } catch {}
      }

      if (t && t.matches && t.matches('input[name="barf_days"]')) {
        const days = Number(barfEl.querySelector('input[name="barf_days"]:checked')?.value || 0);
        if (days && days < 7) currentBarfStepIndex = 2;
        else if (days) currentBarfStepIndex = Math.max(currentBarfStepIndex, 1);
        updateBarfPlanQuestions();
        try { scheduleSaveQuizState(); } catch {}
      }
    });

    updateBarfPlanQuestions();
  }
})();



  // Fragt ab, ob Katze erwachsen. Wichtig für die Frage "Wie oft fütterst du?"
  function isAdultCat() {
  // Kitten = keine Fütterungshäufigkeit-Frage
  if (ageCategory === "kitten") return false;
  // Adult und Senior gelten beide als „erwachsen“ für die Logik
  return true;
}




// Step 4: Allergien sind optional. Wenn nichts ausgewählt ist, soll es trotzdem weitergehen.
// Adult/Senior: starte mind. bei Index 1 (Fütterungshäufigkeit sichtbar)
// Kitten: starte mind. bei Index 2 (Fütterungshäufigkeit wird übersprungen, Wählerisch sichtbar)
function ensureStep4StartIndex() {
  try {
    if (ageCategory === "kitten") {
      if (typeof currentStep4Index === "number" && currentStep4Index < 2) currentStep4Index = 2;
    } else {
      if (typeof currentStep4Index === "number" && currentStep4Index < 1) currentStep4Index = 1;
    }

    // Safety: falls Feeding-Frequency bei Kitten nicht gezeigt wird, soll required/validation nicht blocken
    const freqEls = form ? form.querySelectorAll('[name="feeding_frequency"]') : [];
    freqEls.forEach((el) => {
      if (ageCategory === "kitten") {
        try { el.required = false; } catch {}
        el.disabled = true;
      } else {
        el.disabled = false;
      }
    });
  } catch (e) {
    // ignore
  }
}

// Lebensphase für die Anzeige unter dem Slider
function getAgeLifeStage(age) {
  const n = parseInt(age, 10);
  if (!n || n < 1) return "";
  
  if (n >= 10) return "Senior";
  return "Adult";
}
    // --------------------------------------
  // Wählerischkeits-Skala (4 Stufen)
  // --------------------------------------

const PICKY_LEVELS = [
  {
    key: "0",
    description:
      "Die Mahlzeiten von Fellinora enthalten alle wichtigen Nährstoffe für ein artgerechtes Katzenleben."
  },
  {
    key: "1",
    description:
      "Unsere individuellen Portionen entstehen frisch und ausschließlich aus natürlichen Zutaten."
  },
  {
    key: "2",
    description:
      "Unsere Rezepte sind an die natürlichen Beutetiere der Katze angelehnt und erzielen dadurch eine besonders hohe Akzeptanz."
  },
  {
    key: "3",
    description:
      "Über 98 % hochwertige tierische Proteine machen Fellinora zu einer natürlich verführerischen Wahl für jede Katze."
  }
];

function setPickyLevel(index, opts = {}) {
  const { skipStepAdvance = false, skipDispatch = false } = opts;
  if (!pickyHiddenInput || !pickyOptions.length) return;

  const i = Math.min(
    Math.max(parseInt(index, 10) || 0, 0),
    PICKY_LEVELS.length - 1
  );
  const level = PICKY_LEVELS[i];

  // Wert im Hidden-Feld setzen
  pickyHiddenInput.value = level.key;

  // aktive Optik
  pickyOptions.forEach((btn, idx) => {
    btn.classList.toggle("is-active", idx === i);
  });

  // Infobox-Text + Sichtbarkeit
  if (pickyInfoBox && pickyInfoText) {
    pickyInfoText.textContent = level.description;
    pickyInfoBox.hidden = false;

    // Pfeil-Position berechnen: relativ zur Boxbreite
    const btn = pickyOptions[i];
    if (btn) {
      const btnRect  = btn.getBoundingClientRect();
      const boxRect  = pickyInfoBox.getBoundingClientRect();
      const centerX  = btnRect.left + btnRect.width / 2;

      // Wenn Step/Box noch hidden ist (Reload/Back), ist width=0 → nicht falsch setzen
      if (!boxRect.width) {
        pickyInfoBox.style.removeProperty("--picky-arrow-left");
      } else {
        const percent = ((centerX - boxRect.left) / boxRect.width) * 100;
        pickyInfoBox.style.setProperty("--picky-arrow-left", `${percent}%`);
      }
    }
  }

  // NEU: Fortschrittsbalken informieren
if (!skipDispatch) {
  try {
    const ev = new Event("change", { bubbles: true });
    pickyHiddenInput.dispatchEvent(ev);   // triggert form.onchange → updateProgressBars()
  } catch (e) {
    // Fallback, falls Event-Konstruktor nicht verfügbar
    if (typeof updateProgressBars === "function") {
      updateProgressBars();
    }
  }
}
// Step-4-Progression: nach Auswahl direkt zur Hauptfutterfrage
if (!skipStepAdvance) {
  if (currentStep4Index < 3) {
    currentStep4Index = 3;
    updateStep4Questions();
  }
}
}


// Initialisieren (beim Laden / Zurück-Navigation)
if (pickyHiddenInput && pickyOptions.length) {
  const existing = (pickyHiddenInput.value || "").trim();

  // Nur wenn es bereits einen gespeicherten Wert gibt (z.B. Browser-Back),
  // setzen wir die Skala entsprechend. Beim ersten Laden bleibt sie leer.
  if (existing) {
    const foundIndex   = PICKY_LEVELS.findIndex(l => l.key === existing);
    const initialIndex = foundIndex >= 0 ? foundIndex : 1;
    setPickyLevel(initialIndex);
  }

  // Reaktion auf User-Klicks
  pickyOptions.forEach(btn => {
    btn.addEventListener("click", () => {
      const idx = btn.dataset.index;
      setPickyLevel(idx);
    });
  });
}

// Expose: nach Step-Anzeige Pfeil neu ausrichten (ohne Change-Events)
window.__catQuizRealignPickyArrow = function () {
  if (!pickyHiddenInput || !pickyOptions.length || !pickyInfoBox) return;
  if (pickyInfoBox.hidden) return;
  const key = (pickyHiddenInput.value || "").trim();
  if (!key) return;
  const idx = PICKY_LEVELS.findIndex(l => l.key === key);
  if (idx < 0) return;
  const btn = pickyOptions[idx];
  if (!btn) return;
  const boxRect = pickyInfoBox.getBoundingClientRect();
  if (!boxRect.width) return;
  const btnRect = btn.getBoundingClientRect();
  const centerX = btnRect.left + btnRect.width / 2;
  const percent = ((centerX - boxRect.left) / boxRect.width) * 100;
  pickyInfoBox.style.setProperty("--picky-arrow-left", `${percent}%`);
};


// --------------------------------------------------
// STEP 4 – Futterart: Infobox mit dynamischem Pfeil
// --------------------------------------------------
(function () {
  const foodFieldset = form.querySelector(".food-fieldset");
  if (!foodFieldset) return;

  const radios       = Array.from(foodFieldset.querySelectorAll('input[name="current_food"]'));
  const infoBox      = foodFieldset.querySelector(".food-info-box");
  const infoTextEl   = foodFieldset.querySelector(".food-info-box-text");
  const infoBoxInner = foodFieldset.querySelector(".food-info-box-inner");
  const row          = foodFieldset.querySelector(".food-row");

  if (!radios.length || !infoBox || !infoTextEl || !infoBoxInner || !row) return;

  const foodTexts = {
    nassfutter:
      "Unser Nassfutter wird schonend dampfgegart, sodass die natürlichen Nährstoffe bestmöglich erhalten bleiben.",
    trockenfutter:
      "Trockenfutter enthält wenig Feuchtigkeit und passt weniger gut zum natürlichen Fressverhalten von Katzen. Fellinora liefert dagegen viel Flüssigkeit und orientiert sich stärker an ihrer natürlichen Ernährung.",
    rohfleisch:
      "Rohfleisch orientiert sich am natürlichen Beutetier der Katze. Unsere Rezepte folgen demselben Ansatz und enthalten alle wichtigen Nährstoffe in sicherer und kontrollierter Form.",
    selbstgekocht:
      "Durch die Verwendung frischer Zutaten schmeckt unser Futter wie frisch gekocht."
  };

  function updateArrow(selectedRadio) {
    const pillInner = selectedRadio.closest(".food-pill")?.querySelector(".food-pill-inner");
    if (!pillInner) return;

    const rowRect  = row.getBoundingClientRect();
    if (!rowRect.width) {
      infoBoxInner.style.removeProperty("--food-arrow-left");
      return;
    }
    const pillRect = pillInner.getBoundingClientRect();

    const centerX  = pillRect.left + pillRect.width / 2;
    const percentX = rowRect.width
      ? ((centerX - rowRect.left) / rowRect.width) * 100
      : 50;

    infoBoxInner.style.setProperty("--food-arrow-left", `${percentX}%`);
  }

  function updateFoodInfoBox() {
    const selected = radios.find(r => r.checked);

    if (!selected) {
      infoBox.hidden = true;
      return;
    }

    const text = foodTexts[selected.value] || "";
    infoTextEl.textContent = text;
    infoBox.hidden = false;

    updateArrow(selected);
  }

  // Initial (z.B. Back-Button im Browser)
  updateFoodInfoBox();

  // Expose: nach Step-Anzeige Pfeil neu ausrichten (ohne Change-Events)
  window.__catQuizRealignFoodInfoBox = function () {
    // Nur wenn die Box aktuell sichtbar sein kann
    updateFoodInfoBox();
  };

  // Listener für Änderungen
  radios.forEach(radio => {
    radio.addEventListener("change", updateFoodInfoBox);
  });

  // Bei Resize Pfeil neu ausrichten
  window.addEventListener("resize", () => {
    const selected = radios.find(r => r.checked);
    if (selected && !infoBox.hidden) {
      updateArrow(selected);
    }
  });
})();



  // --------------------------------------------------
  // Name-Handling (Personalisierung)
  // --------------------------------------------------

function updateNameTexts() {
  const targets = Array.from(quizRoot.querySelectorAll(".js-name-text"));
  if (!targets.length) return;

  const name = (nameInput?.value || "").trim();

  targets.forEach(el => {
    const def = el.dataset.default || el.textContent;
    const tpl = el.dataset.template || "";

    if (name && tpl) {
      el.textContent = tpl.replace("%NAME%", name);
    } else {
      el.textContent = def;
    }
  });
}

// --------------------------------------
// Alter: Karten + Infobox
// --------------------------------------

const AGE_DESCRIPTIONS = {
  kitten: {
    title: "Kitten – hoher Energie- & Proteinbedarf",
    text: "Kitten haben einen etwa 4-mal höheren Energie- und Proteinbedarf als erwachsene Katzen. Wir passen Rezeptur und Futtermenge entsprechend an."
  },
  adult: {
    title: "Erwachsene Katze – ausgewogene Erhaltungsernährung",
    text: "Unsere Rezepte orientieren sich am typischen Beutetier deiner Katze und versorgen sie mit allen wichtigen Nährstoffen."
  },
  senior: {
    title: "Senior – schonende Rezeptur für ältere Katzen",
    text: "Für Senioren verwenden wir hochwertige Proteine, Ballaststoffe und z. B. Präbiotika für eine besonders schonende Verdauung."
  }
};

function updateAgeArrow(radio) {
  if (!ageInfoBox || !ageCardsRow) return;
  const option = radio.closest('.age-option');
  if (!option) return;

  const rowRect = ageCardsRow.getBoundingClientRect();
  if (!rowRect.width) {
    // Step evtl. noch hidden (Reload/Back) → Pfeil später neu berechnen
    ageInfoBox.style.removeProperty('--age-arrow-left');
    return;
  }
  const optRect = option.getBoundingClientRect();
  const centerX = optRect.left + optRect.width / 2;
  const percent = ((centerX - rowRect.left) / rowRect.width) * 100;
  ageInfoBox.style.setProperty('--age-arrow-left', `${percent}%`);
}

function setAgeCategory(category) {
  ageCategory = category;

  const cfg = AGE_DESCRIPTIONS[category];

  // Info-Box nur setzen, wenn sie existiert (wichtig bei Restore/hidden steps)
  if (ageInfoBox && ageInfoTitle && ageInfoText && cfg) {
    ageInfoTitle.textContent = cfg.title;
    ageInfoText.textContent  = cfg.text;
    ageInfoBox.hidden        = false;
  }

  // Eingabe-Kachel sichtbar machen, sobald eine Alterskarte gewählt wurde
  if (ageInputWrap) ageInputWrap.hidden = false;



  const isKitten = category === "kitten";

  if (ageInfoKitten) {
    ageInfoKitten.hidden = !isKitten;
  }
  if (ageInfoAdult) {
    ageInfoAdult.hidden = isKitten;
  }
  // Wrapper sichtbar machen
if (ageInputWrap) ageInputWrap.hidden = false;

// Geburtsmonat immer erstmal resetten
if (birthMonthCard) birthMonthCard.hidden = true;
if (birthMonthSelect) {
  if (!_isRestoringQuizState) birthMonthSelect.value = "";
  birthMonthSelect.disabled = true;
}

  if (ageMonthsInput) {
    ageMonthsInput.required = isKitten;

    // Grenzen: Kitten < 12 Monate -> 1–11
    ageMonthsInput.min = "1";
    ageMonthsInput.max = "11";
    if (isKitten && !ageMonthsInput.value) {
      ageMonthsInput.focus();
    }
  }

  if (ageYearsInput) {
    ageYearsInput.required = !isKitten;

    // Grenzen für Jahre-Eingabe je nach Kohorte setzen
    // Adult: 1–10 Jahre | Senior: 10–25 Jahre
    if (category === "adult") {
      ageYearsInput.min = "1";
      ageYearsInput.max = "10";
    } else if (category === "senior") {
      ageYearsInput.min = "10";
      ageYearsInput.max = "25";
    } else {
      // Fallback (sollte durch deaktiviertes Kitten praktisch nicht genutzt werden)
      ageYearsInput.min = "1";
      ageYearsInput.max = "25";
    }

    if (!isKitten && !ageYearsInput.value) {
      ageYearsInput.focus();
    }

    // Falls bereits ein Alter eingegeben ist, sofort prüfen und bei Konflikt leeren
    if (ageYearsInput.value) {
      const currentAge = parseInt(ageYearsInput.value, 10);

      if (category === "adult" && currentAge > 10) {
        ageYearsInput.value = "";
      } else if (category === "senior" && currentAge < 10) {
        ageYearsInput.value = "";
      }
    }
  }

// Geburtsmonat-Dropdown: nur für Adult/Senior, erst nach gültiger Jahreszahl anzeigen
// Geburtsmonat: nur für Adult/Senior, erst nach gültiger Jahreszahl anzeigen
if (birthMonthCard && birthMonthSelect) {
  if (isKitten) {
    birthMonthCard.hidden = true;
    birthMonthSelect.disabled = true;
    birthMonthSelect.required = false;
    birthMonthSelect.value = "";
  } else {
    const yearsOk = !!(ageYearsInput && ageYearsInput.value.trim()) && validateAge(false);
    birthMonthCard.hidden = !yearsOk;
    birthMonthSelect.disabled = !yearsOk;
    birthMonthSelect.required = yearsOk;
    if (!yearsOk) birthMonthSelect.value = "";
  }
}




  const selectedRadio = ageCategoryInputs.find(r => r.checked);
  if (selectedRadio) {
    updateAgeArrow(selectedRadio);
  }
}


// Listener für die 3 Alterskarten
if (ageCategoryInputs.length) {
ageCategoryInputs.forEach(radio => {
  radio.addEventListener("change", () => {
    setAgeCategory(radio.value);

    // HIER rein:
    scheduleSaveQuizState();
  });
});

}

function handleAgeNumberInput() {
  if (currentStep1Index !== 1) return;
  if (!ageCategory) return;

  const isKitten = ageCategory === "kitten";
  const activeInput = isKitten ? ageMonthsInput : ageYearsInput;
  if (!activeInput) return;

  const hasAgeValue = (activeInput.value || "").trim().length > 0;

  // Adult/Senior: Geburtsmonat-Karte erst zeigen, wenn Jahre gültig sind
  if (!isKitten && birthMonthCard && birthMonthSelect) {
    const yearsOk = hasAgeValue && validateAge(false);

    birthMonthCard.hidden = !yearsOk;
    birthMonthSelect.disabled = !yearsOk;
    birthMonthSelect.required = yearsOk;

    if (!yearsOk) birthMonthSelect.value = "";
  }

  // Wenn Alter gültig ist → weiter. Adult/Senior aber erst, wenn Monat gewählt ist.
  if (hasAgeValue && validateAge(false)) {
    if (isKitten) {
      currentStep1Index = 2;
      updateStep1Questions();
      updateNameTexts();

      try { syncNextButtonState(); } catch {}
      return;
    }

    // Adult/Senior: Monat erzwingen, sobald Karte sichtbar ist
    if (birthMonthCard && birthMonthSelect) {
      const monthVal = (birthMonthSelect.value || "").trim();
      if (!monthVal) {
        birthMonthSelect.focus();
        return;
      }
    }

    currentStep1Index = 2;
    updateStep1Questions();
    updateNameTexts();

    try { syncNextButtonState(); } catch {}
  }
}





if (ageMonthsInput) {
  ageMonthsInput.addEventListener("input", handleAgeNumberInput);
}
if (ageYearsInput) {
  ageYearsInput.addEventListener("input", handleAgeNumberInput);
}

if (birthMonthSelect) {
  birthMonthSelect.addEventListener("change", handleAgeNumberInput);
}


  if (nameInput) {
    nameInput.addEventListener("input", () => {
      updateNameTexts();
      const val = nameInput.value.trim();

      // Wenn Name sinnvoll ausgefüllt ist → nächste Frage
      if (val.length > 1 && currentStep1Index === 0) {
        currentStep1Index = 1; // Alter
        updateStep1Questions();
        scheduleSaveQuizState();
      }
    });

    nameInput.addEventListener("blur", updateNameTexts);
    updateNameTexts();

  }


// Geschlecht → Kastration sichtbar machen
if (sexInputs.length) {
  sexInputs.forEach(input => {
  input.addEventListener("change", () => {
    const lastIndex = step1Questions.length - 1;
    const targetIndex = Math.max(0, lastIndex - 1);
    if (currentStep1Index < targetIndex) {
      currentStep1Index = targetIndex;
      updateStep1Questions();
    }

    
    scheduleSaveQuizState();
  });
});

}
if (birthMonthSelect) {
  birthMonthSelect.addEventListener("change", () => {
    if (currentStep1Index === 1 && birthMonthSelect.value) {
      // Jetzt mit "normalem" validateAge prüfen (inkl Monat)
      if (validateAge(false)) {
        currentStep1Index = 2;
        updateStep1Questions();
      }
    }
    scheduleSaveQuizState();
  });
}

// Kastration → Infobox + alle restlichen Fragen anzeigen
function updateNeuteredInfo(value) {
  if (!neuteredInfoBox || !neuteredInfoTitle || !neuteredInfoText) return;

  const cfg = NEUTERED_TEXTS[value];
  if (!cfg) {
    neuteredInfoBox.hidden = true;
    return;
  }

  neuteredInfoTitle.textContent = cfg.title;
  neuteredInfoText.textContent  = cfg.text;
  neuteredInfoBox.hidden        = false;
}

if (neuteredInputs.length) {
  neuteredInputs.forEach(input => {
  input.addEventListener("change", () => {
    updateNeuteredInfo(input.value);

    currentStep1Index = step1Questions.length - 1;
    updateStep1Questions();

    // HIER rein:
    scheduleSaveQuizState();
  });
});

}

  // --------------------------------------------------
  // Schritt 4: Fragen nacheinander anzeigen
  // --------------------------------------------------

    // Infobox-Text unter den Allergy-Optionen updaten
  // → Box erst anzeigen, wenn mind. eine Option gewählt ist
  function updateAllergyInfoBox() {
    if (!allergyInfoBox || !allergyInfoBoxText) return;

    const selected = allergyInputs
      .filter(i => i.checked)
      .map(i => (i.value || "").toString().trim().toLowerCase());

    // Nichts ausgewählt → Box ausblenden
    if (!selected.length) {
      allergyInfoBox.hidden = true;
      return;
    }

    // Ab hier: irgendeine Allergie gewählt → Box anzeigen
    allergyInfoBox.hidden = false;

    const hasHuhn  = selected.includes("huhn");
    const hasFisch = selected.includes("fisch");

    if (hasHuhn && hasFisch) {
      allergyInfoBoxText.textContent =
        "Für diese Allergie haben wir momentan noch kein passendes Futter im Sortiment. Wir arbeiten jedoch bereits an geeigneten Rezepten, die schon bald verfügbar sein werden.";
    } else {
      allergyInfoBoxText.textContent =
        "Wir berücksichtigen die ausgewählte Allergie selbstverständlich bei der Zusammenstellung des passenden Futters.";
    }
  }


  // Allergien → nächste Frage in Step 4
  if (allergyInputs.length) {
    // Initialzustand (Back/Reload) → bei 0 Auswahl bleibt die Box versteckt
    updateAllergyInfoBox();

    allergyInputs.forEach(input => {
      input.addEventListener("change", () => {
        updateAllergyInfoBox();

        if (currentStep4Index <= 0) {
          if (isAdultCat()) {
            currentStep4Index = 1;
          } else {
            currentStep4Index = 2;
          }
          updateStep4Questions();
        }
      });
    });
  }




  // Fütterungshäufigkeit → Wählerischkeits-Frage
  if (feedingFreqInputs.length) {
    feedingFreqInputs.forEach(input => {
      input.addEventListener("change", () => {
        // Nur wenn wir uns wirklich auf der Frequenz-Frage befinden
        if (currentStep4Index === 1) {
          currentStep4Index = 2; // Wählerischkeitsfrage anzeigen
          updateStep4Questions();
        }
      });
    });
  }
// --------------------------------------
// Fütterungshäufigkeit – Infobox-Texte + Pfeil
// --------------------------------------
// --------------------------------------
// Fütterungshäufigkeit – Infobox-Texte + Pfeil
// --------------------------------------
(function () {
  const freqInputs = Array.from(
    document.querySelectorAll('input[name="feeding_frequency"]')
  );
  const infoBox = document.querySelector(".frequency-info-box");
  const row     = document.querySelector(".frequency-row");
  if (!freqInputs.length || !infoBox || !row) return;

  const textEl = infoBox.querySelector(".frequency-info-box-text");
  if (!textEl) return;

  const messages = {
    "2x": "Zwei Mahlzeiten pro Tag sind für viele Katzen geeignet, und wir berücksichtigen diese Angabe in unserer wissenschaftlich fundierten Futterempfehlung.",
    "3x": "Sehr gut! Auch in der Natur nehmen Katzen mehrere kleine Mahlzeiten über den Tag verteilt zu sich.",
    "4":  "Der Körper von Katzen ist auf mehrere kleine Mahlzeiten am Tag angepasst, sodass vier Fütterungen ihrem natürlichen Bedarf sehr gut entsprechen."
  };

  function updateArrow(selectedInput) {
    const label = selectedInput.closest(".frequency-pill");
    if (!label) return;

    const rowRect   = row.getBoundingClientRect();
    if (!rowRect.width) {
      infoBox.style.removeProperty("--frequency-arrow-left");
      return;
    }
    const labelRect = label.getBoundingClientRect();
    const centerX   = labelRect.left + labelRect.width / 2;
    const percent   = rowRect.width
      ? ((centerX - rowRect.left) / rowRect.width) * 100
      : 50;

    infoBox.style.setProperty("--frequency-arrow-left", `${percent}%`);
  }

  function updateFrequencyInfoBox() {
    const selected = freqInputs.find((input) => input.checked);
    if (!selected) {
      infoBox.hidden = true;
      return;
    }

    const msg = messages[selected.value];
    if (!msg) {
      infoBox.hidden = true;
      return;
    }

    textEl.textContent = msg;
    infoBox.hidden = false;
    updateArrow(selected);
  }

  // Initial (z. B. bei „Zurück“-Navigation)
  updateFrequencyInfoBox();

  // Expose: nach Step-Anzeige Pfeil neu ausrichten (ohne Change-Events)
  window.__catQuizRealignFrequencyInfoBox = function () {
    updateFrequencyInfoBox();
  };

  // Listener
  freqInputs.forEach((input) => {
    input.addEventListener("change", updateFrequencyInfoBox);
  });

  // Bei Resize Pfeil neu ausrichten
  window.addEventListener("resize", () => {
    const selected = freqInputs.find((i) => i.checked);
    if (selected && !infoBox.hidden) updateArrow(selected);
  });
})();





 
// --------------------------------------
// BCS-Infobox: Beschreibung + Pfeilposition
// --------------------------------------
(function () {
  const bcsDescriptions = {
    "1": "Rippen deutlich sichtbar und stark tastbar. Kein fühlbares oder sichtbares Fettgewebe. Taille und Magengrube sehr klar ausgeprägt.",
    "2": "Sehr dünne Fettschicht über den Rippen tastbar. Kaum tastbares Bauchfett. Taille deutlich sichtbar.",
    "3": "Fettgewebe über den Rippen leicht tastbar. Taille und Magengrube gut sichtbar. Minimales Bauchfett, Fettgewebe klar fühlbar.",
    "4": "Rippen unter einer Fettschicht nur gerade noch tastbar. Taille kaum erkennbar. Deutliche Rundung und spürbare Fettschicht am Bauch.",
    "5": "Rippen unter der Fettschicht nicht mehr tastbar. Ausgeprägte Bauchrundung mit deutlicher Fettschicht sichtbar. Taille nicht erkennbar"
  };

  const bcsRadios   = document.querySelectorAll('input[name="bcs"]');
  const infoBox     = document.querySelector('.bcs-info-box');
  const infoTitleEl = document.querySelector('.bcs-info-box-title');
  const infoTextEl  = document.querySelector('.bcs-info-box-text');
  const bcsRow      = document.querySelector('.bcs-row');
  const extraBox    = document.querySelector(".bcs-extra-box");

  if (!bcsRadios.length || !infoBox || !infoTextEl || !bcsRow) return;

  // Initial: Extra-Box nur zeigen, wenn bereits ein BCS selected ist (Back/Reload)
  if (extraBox) {
    extraBox.hidden = !Array.from(bcsRadios).some(r => r.checked);
  }

  function updateArrow(radio) {
    const option = radio.closest('.bcs-option');
    if (!option) return;

    const rowRect    = bcsRow.getBoundingClientRect();
    if (!rowRect.width) {
      infoBox.style.removeProperty('--bcs-arrow-left');
      return;
    }
    const optionRect = option.getBoundingClientRect();

    const centerX  = optionRect.left + optionRect.width / 2;
    const percentX = ((centerX - rowRect.left) / rowRect.width) * 100;

    infoBox.style.setProperty('--bcs-arrow-left', `${percentX}%`);
  }

  bcsRadios.forEach(function (radio) {
    // Initialzustand (falls bereits gewählt)
    if (radio.checked) {
      const value = radio.value;
      const text  = bcsDescriptions[value];
      if (text) {
        if (infoTitleEl) infoTitleEl.textContent = "Deine Auswahl " + value;
        infoTextEl.textContent = text;
        updateArrow(radio);
      }
    }

    radio.addEventListener('change', function () {
      const value = this.value;
      const text  = bcsDescriptions[value];
      if (!text) return;

      if (infoTitleEl) infoTitleEl.textContent = "Deine Auswahl " + value;
      infoTextEl.textContent = text;
      updateArrow(this);

      if (extraBox) extraBox.hidden = false; // <-- korrekt: erst nach Auswahl
    });
  });

  // Expose: nach Step-Anzeige Pfeil neu ausrichten (ohne Change-Events)
  window.__catQuizRealignBcsArrow = function () {
    const checked = Array.from(bcsRadios).find(r => r.checked);
    if (!checked || infoBox.hidden) return;
    updateArrow(checked);
  };

  window.addEventListener('resize', () => {
    const checked = Array.from(bcsRadios).find(r => r.checked);
    if (checked) updateArrow(checked);
  });
})();

// --------------------------------------
// Aktivität – Infobox wie BCS (Step 3)
// --------------------------------------
(function () {
  const activityRadios = Array.from(form.querySelectorAll('input[name="activity"]'));
  const activityInfoBox = form.querySelector('.activity-info-box');
  const activityInfoTitle = activityInfoBox?.querySelector('.activity-info-box-title');
  const activityInfoText  = activityInfoBox?.querySelector('.activity-info-box-text');
  const activityRow = form.querySelector('.bcs-row.activity-row');

  // Step 3 Zusatzfrage: Lebensweise (wird erst nach Aktivität eingeblendet)
  const lifestyleBlock  = form.querySelector(".lifestyle-question");
  const lifestyleRadios = Array.from(form.querySelectorAll('input[name="lifestyle"]'));
  const lifestyleTipBox = form.querySelector(".lifestyle-tip-box");

  if (!activityRadios.length || !activityInfoBox || !activityInfoText) return;

  function getCatNameSafe() {
    const v = (nameInput?.value || "").trim();
    return v || "Deine Katze";
  }

  function setPlaceholder() {
    if (activityInfoTitle) activityInfoTitle.textContent = "Aktivitätslevel";
    activityInfoText.textContent = "Je nach Bewegunggrad kann der Kalorienbedarf stark varieren - wir berückischtigen ihn in unserer Mengen berechnung";
    activityInfoBox.style.removeProperty("--activity-arrow-left");
  }

  function setLifestyleEnabled(enabled) {
    if (!lifestyleBlock || !lifestyleRadios.length) return;

    lifestyleBlock.hidden = !enabled;

    lifestyleRadios.forEach((r, idx) => {
      r.disabled = !enabled;
      // only one required per radio-group is enough
      r.required = enabled && idx === 0;
      if (!enabled) r.checked = false;
    });

    // Tip-Box immer mit-synchronisieren (wichtig für Restore/BFCache)
    updateLifestyleTipVisibility();
  }

  function updateLifestyleTipVisibility() {
    if (!lifestyleTipBox) return;
    const hasLifestyle = lifestyleRadios.some(r => r.checked);
    // Wenn Lebensweise-Block noch nicht aktiv ist, Box immer ausblenden
    lifestyleTipBox.hidden = !(hasLifestyle && lifestyleBlock && !lifestyleBlock.hidden);
  }

  function updateArrow(radio) {
    if (!activityRow) return;
    const label = radio.closest("label");
    if (!label) return;

    const rowRect = activityRow.getBoundingClientRect();
    if (!rowRect.width) {
      activityInfoBox.style.removeProperty("--activity-arrow-left");
      return;
    }
    const labelRect = label.getBoundingClientRect();
    const centerX = (labelRect.left + labelRect.right) / 2;
    const percentX = ((centerX - rowRect.left) / rowRect.width) * 100;

    activityInfoBox.style.setProperty("--activity-arrow-left", `${percentX}%`);
  }

  function updateActivityInfo() {
    const checked = activityRadios.find(r => r.checked);
    if (!checked) {
      setLifestyleEnabled(false);
      setPlaceholder();
      return;
    }

    setLifestyleEnabled(true);

    const name = getCatNameSafe();
    const isActive = checked.value === "aktiv";

    // Titel
    const titleText = isActive ? "Aktiv" : "Nicht aktiv";
    if (activityInfoTitle) activityInfoTitle.textContent = titleText;

    // TEXT: jetzt abhängig von der Auswahl
    activityInfoText.textContent = isActive
      ? `${name} ist ein richtiger Wirbelwind und bereit für jedes Abenteuer.`
      : `${name} spielt gelegentlich & betreibt ansonsten professionelles Relaxen.`;

    updateArrow(checked);
  }

  // Expose for restore (localStorage rehydrate does not trigger change events)
  window.__catQuizSyncActivityLifestyleUI = updateActivityInfo;

  activityRadios.forEach(r => r.addEventListener("change", updateActivityInfo));
  lifestyleRadios.forEach(r => r.addEventListener("change", () => {
    updateLifestyleTipVisibility();
    try { scheduleSaveQuizState(); } catch {}
    try { syncNextButtonState(); } catch {}
    try { updateProgressBars(); } catch {}
  }));
  nameInput?.addEventListener("input", updateActivityInfo);

  updateActivityInfo();
  updateLifestyleTipVisibility();

  window.addEventListener("resize", () => {
    const checked = activityRadios.find(r => r.checked);
    if (checked) updateArrow(checked);
  });
})();

function initDiseaseSection() {
  const step5 = document.querySelector('.quiz-step[data-step="5"]');
  if (!step5) return;

  const fieldset = step5.querySelector(".disease-fieldset");
  if (!fieldset) return;

  const wrap = fieldset.querySelector(".disease-wrap");
  const yesNoInputs = Array.from(fieldset.querySelectorAll('input[name="has_disease"]'));
  const diseaseInputs = Array.from(fieldset.querySelectorAll('input[name="disease"]'));

  const infoBox = fieldset.querySelector(".disease-info-box");
  const infoText = fieldset.querySelector(".disease-info-box-text");

  const customWrap = fieldset.querySelector(".disease-custom");
  const customTextarea = fieldset.querySelector('textarea[name="disease_custom"]');

  const healthInputs = Array.from(step5.querySelectorAll('input[name="health_focus"]'));

  // Wenn du die Disease-Frage wirklich erst NACH einer Health-Auswahl zeigen willst:
  function updateDiseaseFieldsetVisibility() {
    const anyHealthSelected = healthInputs.some(i => i.checked);
    fieldset.hidden = !anyHealthSelected;

    // Wenn Health wieder leer wird: Disease komplett zurücksetzen
    if (!anyHealthSelected) {
      yesNoInputs.forEach(r => (r.checked = false));
      if (wrap) wrap.hidden = true;
      diseaseInputs.forEach(i => (i.checked = false));
      if (customTextarea) customTextarea.value = "";
      if (customWrap) customWrap.hidden = true;
      if (infoBox) infoBox.hidden = true;
      if (infoText) infoText.textContent = "";
      lastSelectedKey = "";
    }
  }

  const DISEASE_TEXTS = {
    verstopfung:
      "Fellinora kann bei Verstopfung gefüttert werden und enthält Flohsamenschalen. Bei anhaltenden oder wiederkehrenden Beschwerden sollte jedoch tierärztlicher Rat eingeholt werden.",
    arthritis:
      "Fellinora kann bei Arthritis problemlos gefüttert werden. In Absprache mit dem Tierarzt können zusätzlich geeignete Supplemente eingesetzt werden.",
    bauchspeicheldruesenentzuendung:
      "Bei einer Bauchspeicheldrüsenentzündung sollte Fellinora nur nach tierärztlicher Rücksprache gefüttert werden.",
    blasenentzuendung:
      "Fellinora kann bei einer Blasenentzündung grundsätzlich gefüttert werden. Bei wiederkehrenden Beschwerden oder Verdacht auf Harnsteine sollte jedoch tierärztlicher Rat eingeholt werden.",
    ckd:
      "Bei chronischer Nierenerkrankung sollte Fellinora nur nach tierärztlicher Rücksprache gefüttert werden. Oft ist eine spezielle Nierendiät erforderlich.",
    diabetes:
      "Fellinora kann bei Diabetes gefüttert werden, da es einen hohen Proteinanteil und geringe Kohlenhydratmengen enthält. Die Fütterung sollte dennoch immer mit dem Tierarzt abgestimmt werden.",
    durchfall:
      "Fellinora kann bei Durchfall weiter gefüttert werden, da es Präbiotika enthält, die die normale Verdauungsfunktion unterstützt. Bei anhaltendem oder wiederkehrendem Durchfall sollte jedoch tierärztlicher Rat eingeholt werden.",
    epilepsie:
      "Fellinora kann bei Epilepsie gefüttert werden. Anpassungen der Ernährung sollten jedoch immer mit dem Tierarzt abgestimmt werden.",
    gastritis:
      "Bei Gastritis sollte Fellinora nur nach tierärztlicher Rücksprache gefüttert werden. Oft wird eine besonders schonende Ernährung empfohlen.",
    harnwegserkrankung:
      "Fellinora kann bei Harnwegserkrankungen gefüttert werden und enthält Cranberry, jedoch sollte bei bestehenden Problemen immer tierärztlicher Rat eingeholt werden.",
    ibd:
      "Bei IBD sollte Fellinora nur nach tierärztlicher Rücksprache gefüttert werden. Oft sind speziell abgestimmte Diäten erforderlich.",
    katzenasthma:
      "Fellinora kann bei Katzenasthma grundsätzlich gefüttert werden. Die Behandlung und mögliche Anpassungen sollten jedoch immer tierärztlich begleitet werden.",
    lebererkrankung:
      "Bei Lebererkrankungen sollte Fellinora nur nach tierärztlicher Rücksprache gefüttert werden. Häufig sind speziell leberschonende Diäten erforderlich.",
    schilddruesenueberfunktion:
      "Bei Schilddrüsenüberfunktion sollte Fellinora nur nach tierärztlicher Rücksprache gefüttert werden. Die Ernährung muss häufig individuell auf die Erkrankung abgestimmt werden.",
    andere:
      "Fellinora enthält alle wichtigen Nährstoffe und kann bei vielen Erkrankungen gefüttert werden. Bei spezifischen medizinischen Bedürfnissen sollte jedoch tierärztlicher Rat eingeholt werden."
  };

  let lastSelectedKey = "";

  function clearDiseaseSelection() {
    diseaseInputs.forEach(i => (i.checked = false));
    if (customTextarea) customTextarea.value = "";
    if (customWrap) customWrap.hidden = true;
    if (infoBox) infoBox.hidden = true;
    if (infoText) infoText.textContent = "";
    lastSelectedKey = "";
  }

  function updateWrapVisibility() {
    const val = (fieldset.querySelector('input[name="has_disease"]:checked') || {}).value || "";
    if (!wrap) return;

    if (val === "ja") {
      wrap.hidden = false;
    } else {
      wrap.hidden = true;
      clearDiseaseSelection();
    }
  }

  function updateCustomVisibility() {
    if (!customWrap) return;
    const otherChecked = diseaseInputs.some(i => i.value === "andere" && i.checked);
    customWrap.hidden = !otherChecked;
  }

  function updateInfoBox() {
    if (!infoBox || !infoText) return;

    const anyChecked = diseaseInputs.some(i => i.checked);
    if (!anyChecked) {
      infoBox.hidden = true;
      infoText.textContent = "";
      return;
    }

    let key = lastSelectedKey;
    const stillChecked = diseaseInputs.some(i => i.checked && i.value === key);
    if (!stillChecked) {
      const first = diseaseInputs.find(i => i.checked);
      key = first ? first.value : "";
    }

    if (!key) {
      infoBox.hidden = true;
      infoText.textContent = "";
      return;
    }

    infoText.textContent = DISEASE_TEXTS[key] || "";
    infoBox.hidden = false;
  }

  // Health -> Disease-Fieldset sichtbar schalten
  healthInputs.forEach(i => i.addEventListener("change", () => {
    updateDiseaseFieldsetVisibility();
  }));

  // Ja/Nein (WICHTIG: richtige Variable yesNoInputs!)
  yesNoInputs.forEach(r => r.addEventListener("change", () => {
    updateWrapVisibility();
  }));

  // Erkrankungen
  diseaseInputs.forEach(chk => {
    chk.addEventListener("change", () => {
      lastSelectedKey = chk.value;
      updateCustomVisibility();
      updateInfoBox();
    });
  });

  // Initial
  updateDiseaseFieldsetVisibility();
  updateWrapVisibility();
  updateCustomVisibility();
  updateInfoBox();
}



  // --------------------------------------------------
  // Step-Navigation / Validierung
  // --------------------------------------------------

  function updateProgress(index) {
    if (!progressSteps.length) return;
    const logicalIndex = Math.min(index, progressSteps.length - 1);

    progressSteps.forEach((el, i) => {
      el.classList.toggle("is-active", i === logicalIndex);
    });
  }

/* ============================================================
   NEW: 6-step progress bars (grey segments with progressive fill)
   - Erwartetes Markup:
     <div class="quiz-progress-bars">
       <span class="quiz-bar"><span class="quiz-bar-fill"></span></span>
       ...
     </div>
   ============================================================ */
function setProgressBarFill(barEl, pct) {
  const clamped = Math.max(0, Math.min(100, Number(pct) || 0));

  // Standard: barEl ist .quiz-bar → wir holen uns das Kind .quiz-bar-fill
  const fillEl =
    (barEl.classList && barEl.classList.contains("quiz-bar-fill"))
      ? barEl
      : (barEl.querySelector && barEl.querySelector(".quiz-bar-fill"));

  if (!fillEl) return;

  // Breite/Füllstand setzen
  fillEl.style.width   = clamped + "%";
  fillEl.style.display = "block";
  fillEl.style.height  = "100%";

  // Weicher Übergang
  if (!fillEl.style.transition) {
    fillEl.style.transition = "width 0.2s ease";
  }

  // Volle Steps markieren (für lila Farbe im CSS)
  const wrapper = barEl.closest(".quiz-bar") || barEl;
  if (wrapper && wrapper.classList) {
    if (clamped >= 99.9) {
      wrapper.classList.add("is-complete");
    } else {
      wrapper.classList.remove("is-complete");
    }
  }
}



  function fieldAnswered(stepEl, fieldName, { type } = {}) {
    if (!stepEl) return false;

    const els = Array.from(stepEl.querySelectorAll(`[name="${fieldName}"]`));
    if (!els.length) return false;

    // Explicit type override for groups
    const inferredType = type || (els[0].type || "").toLowerCase();

    if (inferredType === "checkbox") {
      return els.some(el => el.checked);
    }

    if (inferredType === "radio") {
      return els.some(el => el.checked);
    }

    // text/number/hidden/select
    return els.some(el => (el.value || "").trim().length > 0);
  }

function calcCurrentStepProgressPct(stepIndex) {
  // stepIndex ist hier LOGISCH: 0..5 => Step 1..6
  const expectedStepNo = String(Number(stepIndex) + 1);

  // Robust gegen Step 0 im steps-Array:
  let stepEl = steps?.[stepIndex];
  if (!stepEl || String(stepEl?.dataset?.step) !== expectedStepNo) {
    stepEl = quizRoot.querySelector(`.quiz-step[data-step="${expectedStepNo}"]`);
  }

  if (!stepEl) return 0;


  let checks = [];
  // optionaler Zusatz-Check: Allergien in Schritt 3
  let optionalAllergySelected = false;

  if (stepIndex === 0) {
    // Schritt 1: Basisdaten
    checks = [
      // Name: mindestens 2 Zeichen
      () => !!(nameInput && nameInput.value.trim().length > 1),

      // Geschlecht (Radio)
      () => sexInputs && sexInputs.some(r => r.checked),

      // Alter: Kategorie + passende Zahlenangabe (Monate oder Jahre)
      () => {
        if (!ageCategoryInputs || !ageCategoryInputs.length) return false;

        const selected = ageCategoryInputs.find(r => r.checked);
        if (!selected) return false;

        const cat = selected.value;
        if (cat === "kitten") {
          return !!(ageMonthsInput && ageMonthsInput.value.trim());
        }
        // adult / senior → Jahre
        return !!(ageYearsInput && ageYearsInput.value.trim());
      },

      // Kastriert / nicht kastriert
      () => neuteredInputs && neuteredInputs.some(r => r.checked),

      // Rasse: entweder Hidden-Feld (Mischling-Button) ODER Textfeld
      () => {
        const hiddenVal = (breedHiddenInput && breedHiddenInput.value.trim()) || "";
        const textVal   = (breedTextInput && breedTextInput.value.trim()) || "";
        return !!(hiddenVal || textVal);
      }
    ];

  } else if (stepIndex === 1) {
    // Schritt 2: Gewicht & Körperzustand
    checks = [
      () => fieldAnswered(stepEl, "weight"),
      () =>
        fieldAnswered(stepEl, "bcs", { type: "radio" }) ||
        fieldAnswered(stepEl, "bcs")
    ];

  } else if (stepIndex === 2) {
    // Schritt 3: Aktivität + Lebensweise
    checks = [
      () => fieldAnswered(stepEl, "activity", { type: "radio" }),
      () => fieldAnswered(stepEl, "lifestyle", { type: "radio" })
    ];

  } else if (stepIndex === 3) {
    // Schritt 4: Ernährung (bei dir Schritt 3 im UI)
    // Basis-Checks (Pflichtfragen für diesen Step)
    checks = [
      () => fieldAnswered(stepEl, "feeding_frequency", { type: "radio" }),
      () => fieldAnswered(stepEl, "picky_level"),
      () => fieldAnswered(stepEl, "current_food", { type: "radio" })
    ];

    // NEU: Allergien als optionaler Progress-Boost
    const allergyEls = allergyInputs.length
      ? allergyInputs
      : Array.from(stepEl.querySelectorAll('input[name="allergy_protein"]'));

    optionalAllergySelected = allergyEls.some(i => i.checked);

  } else if (stepIndex === 4) {
    // Schritt 5: Gesundheit
    checks = [
      () => fieldAnswered(stepEl, "health_focus", { type: "checkbox" })
    ];

    // Optionales „Krankheiten?“-Ja/Nein
    if (
      stepEl.querySelector('[name="disease_has"]') ||
      stepEl.querySelector('[name="has_disease"]')
    ) {
      checks.push(
        () =>
          fieldAnswered(stepEl, "disease_has", { type: "radio" }) ||
          fieldAnswered(stepEl, "has_disease", { type: "radio" })
      );
    }

  } else if (stepIndex === 5) {
    // Schritt 6: Tierschutz
    checks = [
      () => fieldAnswered(stepEl, "social_partner", { type: "radio" })
    ];

    const customRadio = stepEl.querySelector(
      '[name="social_partner"][value="custom"]'
    );
    const customArea = stepEl.querySelector('[name="social_custom"]');

    if (customRadio && customArea) {
      // Falls „custom“ gewählt ist, Textfeld nicht leer
      checks.push(
        () =>
          !customRadio.checked ||
          (customArea.value || "").trim().length > 0
      );
    }
  }

  // Nur Checks behalten, die nicht crashen (Felder existieren)
  const activeChecks = checks.filter(fn => {
    try {
      fn();
      return true;
    } catch {
      return false;
    }
  });

  if (!activeChecks.length) return 0;

  let done = 0;
  activeChecks.forEach(fn => {
    try {
      if (fn()) done += 1;
    } catch {}
  });

  // Basis-Anzahl der Fragen im Step
  let total = activeChecks.length;

  // Schritt 3 (Ernährung): wenn Allergien angeklickt wurden,
  // zählen sie als zusätzlicher „Teil-Fortschritt“
  if (stepIndex === 3 && optionalAllergySelected) {
    total += 1;
    done  += 1;
  }

  return Math.round((done / total) * 100);
}


function updateProgressBars() {
  let bars = Array.from(quizRoot.querySelectorAll(".quiz-progress-bars .quiz-bar"));

  if (!bars.length) {
    const candidates = [
      ".quiz-progress-bars .progress-bar",
      ".quiz-progress-bars .progress-segment",
      ".progress-bars .progress-bar",
      ".progress-bars .progress-segment",
      ".js-progress-bars .progress-bar",
      ".js-progress-bars .progress-segment",
      ".quiz-progress-bar",
      ".progress-step",
      ".quiz-progress-bars .quiz-bar"
    ];

    for (const sel of candidates) {
      const found = Array.from(document.querySelectorAll(sel));
      if (found.length) { bars = found; break; }
    }
  }

  if (!bars.length) return;

  const totalSteps = 6; // Balken für Step 1–6
  bars = bars.slice(0, totalSteps);

  const idx = Number(currentStep) || 0;
  const activeStepEl = steps?.[idx];
  const stepNo = Number(activeStepEl?.dataset?.step ?? idx); // data-step bevorzugen

  // Ergebnis / nach Step 6 → alles voll
  if (stepNo > totalSteps) {
    bars.forEach(barEl => setProgressBarFill(barEl, 100));
    const pb = quizRoot.querySelector(".quiz-progress-bars[role='progressbar'], .quiz-progress-bars[aria-valuenow]");
    if (pb) pb.setAttribute("aria-valuenow", "100");
    return;
  }

  // Step 0: Balken bleibt komplett leer
  if (stepNo === 0) {
    bars.forEach(barEl => setProgressBarFill(barEl, 0));
    const pb = quizRoot.querySelector(".quiz-progress-bars[role='progressbar'], .quiz-progress-bars[aria-valuenow]");
    if (pb) pb.setAttribute("aria-valuenow", "0");
    return;
  }

  // Logischer Balken-Index: Step 1 => 0, Step 2 => 1, ...
  const logical = Math.max(0, Math.min(totalSteps - 1, stepNo - 1));

  // Fortschritt innerhalb des aktuellen Steps: IMMER schrittweise über calcCurrentStepProgressPct
  const currentPct = calcCurrentStepProgressPct(logical);

  bars.forEach((barEl, i) => {
    let pct = 0;
    if (i < logical) pct = 100;
    else if (i > logical) pct = 0;
    else pct = currentPct;

    setProgressBarFill(barEl, pct);
  });

  // aria-valuenow (optional)
  const pb = quizRoot.querySelector(".quiz-progress-bars[role='progressbar'], .quiz-progress-bars[aria-valuenow]");
  if (pb) {
    const overall = Math.round(((logical) + (currentPct / 100)) / totalSteps * 100);
    pb.setAttribute("aria-valuenow", String(overall));
  }
}




// --------------------------------------
// Fix: Safari/Reload Race – Ergebnis/Abo nach Layout-Paint erneut rendern
// --------------------------------------
function forceRenderForStep(stepNo) {
  try {
    if (stepNo === 8) {
      updateResultSummary();
    } else if (stepNo === 9) {
      updateSubscriptionOverview();
    }
  } catch (e) {
    console.warn("[Quiz] forceRenderForStep failed:", e);
  }
}

function scheduleStepRerender(stepNo) {
  if (stepNo !== 7 && stepNo !== 8) return;

  // 1) nach dem nächsten Paint (dein existing helper)
  deferStepRender(() => forceRenderForStep(stepNo));

  // 2) Safari braucht manchmal noch einen Tick extra
  setTimeout(() => forceRenderForStep(stepNo), 180);
}

// Zusätzlich: nach vollständigem Window-Load nochmal “kicken”
window.addEventListener("load", () => {
  try {
    const stepNo = Number(steps?.[currentStep]?.dataset?.step);
    if (stepNo === 7 || stepNo === 8) scheduleStepRerender(stepNo);
  } catch {}
});



const STEP9_NAV_PORTAL_ID = "cat-quiz-step9-nav-portal";
let step9NavPlaceholder = null;
let step9NavOriginalParent = null;
let step9NavOriginalNextSibling = null;

function getStep9NavElement() {
  const step9 = quizRoot && quizRoot.querySelector
    ? quizRoot.querySelector('.quiz-step[data-step="9"]')
    : null;
  return step9 && step9.querySelector ? step9.querySelector('.quiz-nav') : null;
}

function getOrCreateStep9NavPortal() {
  let portal = document.getElementById(STEP9_NAV_PORTAL_ID);
  if (portal) return portal;

  portal = document.createElement('div');
  portal.id = STEP9_NAV_PORTAL_ID;
  portal.setAttribute('aria-hidden', 'true');
  document.body.appendChild(portal);
  return portal;
}

function moveStep9NavToPortal() {
  const nav = getStep9NavElement();
  if (!nav) return;

  const portal = getOrCreateStep9NavPortal();
  if (!step9NavPlaceholder) {
    step9NavPlaceholder = document.createComment('cat-quiz-step9-nav-placeholder');
  }

  if (!step9NavOriginalParent || nav.parentNode !== portal) {
    step9NavOriginalParent = nav.parentNode;
    step9NavOriginalNextSibling = nav.nextSibling;
  }

  if (nav.parentNode !== portal) {
    if (nav.parentNode && step9NavPlaceholder.parentNode !== nav.parentNode) {
      nav.parentNode.insertBefore(step9NavPlaceholder, nav);
    }
    portal.appendChild(nav);
  }

  nav.classList.add('quiz-nav--step9-floating');
  document.documentElement.classList.add('cat-quiz-step9-nav-active');
  document.body.classList.add('cat-quiz-step9-nav-active');
}

function restoreStep9NavFromPortal() {
  const portal = document.getElementById(STEP9_NAV_PORTAL_ID);
  const nav = portal && portal.querySelector ? portal.querySelector('.quiz-nav--step9-floating') : null;
  if (nav) {
    if (step9NavPlaceholder && step9NavPlaceholder.parentNode) {
      step9NavPlaceholder.parentNode.insertBefore(nav, step9NavPlaceholder);
      step9NavPlaceholder.parentNode.removeChild(step9NavPlaceholder);
    } else if (step9NavOriginalParent) {
      step9NavOriginalParent.insertBefore(nav, step9NavOriginalNextSibling || null);
    }
    nav.classList.remove('quiz-nav--step9-floating');
  }

  if (portal && portal.parentNode) portal.parentNode.removeChild(portal);
  document.documentElement.classList.remove('cat-quiz-step9-nav-active');
  document.body.classList.remove('cat-quiz-step9-nav-active');
}

function syncStep9NavPortal() {
  try {
    const step9 = quizRoot && quizRoot.querySelector
      ? quizRoot.querySelector('.quiz-step[data-step="9"]')
      : null;
    const isStep9Active = !!(step9 && !step9.hidden);
    if (isStep9Active) {
      moveStep9NavToPortal();
    } else {
      restoreStep9NavFromPortal();
    }
  } catch (e) {
    console.warn('[CatQuiz] syncStep9NavPortal failed:', e);
  }
}

function showStep(index) {
  try { hideAllPopovers(); } catch {}
  const previousStep = steps?.[currentStep] || null;
  const previousStepNo = previousStep && previousStep.dataset ? Number(previousStep.dataset.step) : NaN;

  steps.forEach((s, i) => {
    s.hidden = i !== index;
  });
  currentStep = index;

  // pro-Tab merken, wo der User ist (für echte Reloads)
  if (!_isRestoringQuizState) {
    saveSessionStep(index);
  }

  updateProgress(index);

  // 6-bar progress UI whenever step changes
  updateProgressBars();

  const stepEl = steps[index];
  const stepNo = stepEl && stepEl.dataset ? Number(stepEl.dataset.step) : NaN;

  syncStep9NavPortal();

  // Titel passend zum Step setzen (data-title am Step)
  // (kein "stilles" swallowen mehr – wenn was schiefgeht, siehst du es in der Konsole)
  try {
    setQuizTitleForStep(stepEl);
  } catch (e) {
    console.warn("[CatQuiz] setQuizTitleForStep failed:", e);
  }

  // Step 4 (Allergien optional): beim Betreten sicherstellen, dass der Flow nicht hängen bleibt
  if (stepNo === 4) {
    ensureStep4StartIndex();
    updateStep4Questions();
  }

  // Step 6.75/6.85: Kochplan/BARF – UI nach Back/Reload synchronisieren
  if (stepNo === 6.75) {
    try { updateCookPlanQuestions(); } catch {}
  }
  if (stepNo === 6.85) {
    try { updateBarfPlanQuestions(); } catch {}
  }
  if (stepNo === 7.5) {
    if (previousStepNo === 6.5) stepEl.dataset.ownfoodStartAtMode = "1";
    try { initOwnfoodDetailedFlowStep(); } catch {}
  }
  if (stepNo === 10 && window.CatQuizUpsell?.refreshStep) {
    try { window.CatQuizUpsell.refreshStep({ quizRoot, form }); } catch (e) {
      console.warn("[CatQuiz] upsell refresh failed:", e);
    }
  }
if (stepNo === 6.75) initFamiliarityInfobox(stepEl, "cook");
if (stepNo === 6.85) initFamiliarityInfobox(stepEl, "barf");
  // Robust: nicht über stepNo gehen, sondern über "ist Result/Abo DOM im Step?"
  const hasResult =
    !!(stepEl && stepEl.querySelector && stepEl.querySelector("#result-summary"));
  const hasAbo =
    !!(stepEl && stepEl.querySelector && stepEl.querySelector("#subscription-box-image"));

  // Helper: nach dem Paint rendern (verhindert Reload/Layout-Races)
  const runAfterPaint = (fn) => {
    try {
      if (typeof window.deferStepRender === "function") {
        window.deferStepRender(fn);
      } else {
        requestAnimationFrame(() => requestAnimationFrame(fn));
      }
    } catch (e) {
      setTimeout(fn, 0);
    }
  };

  // Ergebnis/Abo immer "scheduled" rendern (Reload-fix)
  if (hasResult || hasAbo) {
    // 1) direkt nach Paint
    runAfterPaint(() => {
      // Schutz gegen schnelles weiterklicken
      if (currentStep !== index) return;
      if (hasResult) updateResultSummary();
      if (hasAbo) updateSubscriptionOverview();
    });

    // 2) Safari/Reload braucht manchmal noch einen Tick extra
    setTimeout(() => {
      if (currentStep !== index) return;
      if (hasResult) updateResultSummary();
      if (hasAbo) updateSubscriptionOverview();
    }, 180);
  }

  try { syncNextButtonState(); } catch {}

  // Reload/Back-Fix: Pfeilpositionen (Infoboxen mit Dreieck) nach dem Paint neu berechnen
  runAfterPaint(() => {
    if (currentStep !== index) return;
    const stepNow = steps[index];
    const stepNowNo = stepNow && stepNow.dataset ? Number(stepNow.dataset.step) : NaN;

    // Step 1: Alter
    if (stepNowNo === 1) {
      const selected = Array.isArray(ageCategoryInputs)
        ? ageCategoryInputs.find(r => r.checked)
        : null;
      if (selected) updateAgeArrow(selected);
    }

    // Step 2: BCS
    if (stepNowNo === 2 && typeof window.__catQuizRealignBcsArrow === "function") {
      window.__catQuizRealignBcsArrow();
    }

    // Step 3: Aktivität (inkl. Lebensweise)
    if (stepNowNo === 3 && typeof window.__catQuizSyncActivityLifestyleUI === "function") {
      window.__catQuizSyncActivityLifestyleUI();
    }

    // Step 4: Frequenz / Wählerisch / Futter
    if (stepNowNo === 4) {
      if (typeof window.__catQuizRealignFrequencyInfoBox === "function") {
        window.__catQuizRealignFrequencyInfoBox();
      }
      if (typeof window.__catQuizRealignPickyArrow === "function") {
        window.__catQuizRealignPickyArrow();
      }
      if (typeof window.__catQuizRealignFoodInfoBox === "function") {
        window.__catQuizRealignFoodInfoBox();
      }
    }
  });

  // Persistenz: beim Restore nicht sofort wieder überschreiben
  if (!_isRestoringQuizState) scheduleSaveQuizState();
}


window.addEventListener('resize', () => {
  try { syncStep9NavPortal(); } catch {}
}, { passive: true });

window.addEventListener('pageshow', () => {
  try { syncStep9NavPortal(); } catch {}
});


  function validateStep(index) {
    const step = steps[index];
    const stepNo = Number(step?.dataset?.step);
    const required = step.querySelectorAll("[required]");

    for (const field of required) {
      if (field.disabled) continue; // wichtig für ausgegraute Rasse

      if (field.type === "radio") {
        const group = step.querySelectorAll(`input[name="${field.name}"]`);
        if (!Array.from(group).some(r => r.checked)) return false;
      } else if (!field.value) {
        return false;
      }
    }

    // Sonderfall: Gewicht – Max 8 kg (Step 2)
    if (stepNo === 2) {
      if (!validateWeight(false)) return false;
    }

    // Sonderfall: Fütterungshäufigkeit – nur für erwachsene Katzen Pflicht
    const freqQuestion = step.querySelector(".step4-question--frequency");
    if (freqQuestion && !freqQuestion.hidden && isAdultCat()) {
      const freqInputs = freqQuestion.querySelectorAll('input[name="feeding_frequency"]');
      const hasFreq = Array.from(freqInputs).some(opt => opt.checked);
      if (!hasFreq) {
        return false;
      }
    }

    // Sonderfall: Gesundheit – mindestens eine Funktion auswählen
    const healthFieldset = step.querySelector(".health-fieldset");
    if (healthFieldset) {
      const healthOptions = healthFieldset.querySelectorAll('input[name="health_focus"]');
      if (!Array.from(healthOptions).some(opt => opt.checked)) {
        return false;
      }
    }

    return true;
  }


  function isStepReadyForNext(stepIndex) {
  const stepEl = steps?.[stepIndex];
  const stepNo = Number(stepEl?.dataset?.step);

  // Step 0 hat keinen Einfluss -> Weiter immer möglich
  if (stepNo === 0) return true;

  // Step 1: erst wenn alle Subfragen durch sind
  if (stepNo === 1) {
    const last = Math.max(0, step1Questions.length - 1);
    if (currentStep1Index < last) return false;
  }

  // Step 4: erst wenn alle Subfragen durch sind (Kitten-Logik bleibt wie gehabt)
  if (stepNo === 4) {
    const last = Math.max(0, step4Questions.length - 1);
    if (currentStep4Index < last) return false;
  }


  // Step 6.75: Kochplan – erst wenn alle Subfragen durch sind
  if (stepNo === 6.75) {
    const stepEl = steps?.[stepIndex];
    const days = Number(stepEl?.querySelector('input[name="cook_days"]:checked')?.value || 0);
    const needsWet = Number.isFinite(days) && days > 0 && days < 7;
    const last = needsWet ? 2 : 1;
    if (currentCookStepIndex < last) return false;
  }

  // Step 6.85: BARF – erst wenn alle Subfragen durch sind
  if (stepNo === 6.85) {
    const stepEl = steps?.[stepIndex];
    const days = Number(stepEl?.querySelector('input[name="barf_days"]:checked')?.value || 0);
    const needsWet = Number.isFinite(days) && days > 0 && days < 7;
    const last = needsWet ? 2 : 1;
    if (currentBarfStepIndex < last) return false;
  }

  // Standard: required/sonderfälle
  return validateStep(stepIndex);
}

function syncNextButtonState() {
  const stepEl = steps?.[currentStep];
  if (!stepEl) return;

  const ok = isStepReadyForNext(currentStep);

  const nextBtns = Array.from(stepEl.querySelectorAll(".quiz-nav .btn-next"));
  nextBtns.forEach((btn) => {
    btn.disabled = !ok;
    if (!ok) btn.setAttribute("aria-disabled", "true");
    else btn.removeAttribute("aria-disabled");
  });
}


function validateAge(showAlert = true, options = {}) {
  const requireBirthMonth = options.requireBirthMonth !== false;

  if (!ageCategoryInputs.length) return true;

  const selected = ageCategoryInputs.find(r => r.checked);
  if (!selected) {
    if (showAlert) alert("Bitte wähle, ob deine Katze ein Kitten, erwachsen oder Senior ist.");
    return false;
  }

  const category = selected.value;

  // ----------------------------
  // Kitten: Monate 1–11
  // ----------------------------
  if (category === "kitten") {
    const raw = ((ageMonthsInput && ageMonthsInput.value) || "").trim();
    if (!raw) {
      if (showAlert) alert("Bitte gib das Alter deines Kittens in Monaten an.");
      ageMonthsInput && ageMonthsInput.focus();
      return false;
    }
    if (!/^[0-9]+$/.test(raw)) {
      if (showAlert) alert("Bitte gib das Alter in ganzen Monaten (ohne Komma oder Punkt) ein.");
      ageMonthsInput && ageMonthsInput.focus();
      return false;
    }
    const val = parseInt(raw, 10);
    if (val < 1 || val > 11) {
      if (showAlert) alert("Für Kitten kannst du 1–11 Monate angeben.");
      ageMonthsInput && ageMonthsInput.focus();
      return false;
    }
    return true;
  }

  // ----------------------------
  // Adult & Senior: Jahre
  // ----------------------------
  const raw = ((ageYearsInput && ageYearsInput.value) || "").trim();
  if (!raw) {
    if (showAlert) alert("Bitte gib das Alter deiner Katze in Jahren an.");
    ageYearsInput && ageYearsInput.focus();
    return false;
  }
  if (!/^[0-9]+$/.test(raw)) {
    if (showAlert) alert("Bitte gib das Alter deiner Katze als ganze Zahl in Jahren ein.");
    ageYearsInput && ageYearsInput.focus();
    return false;
  }

  const age = parseInt(raw, 10);

  // Grenzen abhängig von Auswahl
  if (category === "adult") {
    if (age < 1 || age > 10) {
      if (showAlert) alert("Für erwachsene Katzen kannst du 1–10 Jahre angeben.");
      ageYearsInput && ageYearsInput.focus();
      return false;
    }
  } else if (category === "senior") {
    if (age < 10 || age > 25) {
      if (showAlert) alert("Für Senioren kannst du 10–25 Jahre angeben.");
      ageYearsInput && ageYearsInput.focus();
      return false;
    }
  } else {
    // Fallback (sollte nicht passieren)
    if (age < 1 || age > 25) {
      if (showAlert) alert("Bitte gib ein Alter zwischen 1 und 25 Jahren an.");
      ageYearsInput && ageYearsInput.focus();
      return false;
    }
  }

  // ----------------------------
  // Geburtsmonat nur erzwingen,
  // wenn die Monats-Karte sichtbar/aktiv ist
  // ----------------------------
  const monthIsVisible =
    !birthMonthCard || birthMonthCard.hidden === false;

  const shouldRequireMonth =
    requireBirthMonth &&
    birthMonthSelect &&
    !birthMonthSelect.disabled &&
    monthIsVisible;

  if (shouldRequireMonth) {
    const m = (birthMonthSelect.value || "").trim();
    if (!m) {
      if (showAlert) alert("Bitte wähle den Geburtsmonat aus.");
      birthMonthSelect.focus();
      return false;
    }
  }

  return true;
}



// --------------------------------------------------
  // Antworten sammeln
// --------------------------------------------------

function getAnswers() {
  const fd = new FormData(form);

  // --- Alter sauber auslesen ---
  const ageCategory = (fd.get("age_category") || "").toString();       // "kitten" | "adult" | "senior" | ""
  const rawMonths   = (fd.get("age_months")   || "").toString().trim();
  const rawYears    = (fd.get("age_years")    || "").toString().trim();
  const birthMonth = (fd.get("birth_month") || "").toString().trim();

  let ageYears   = 0;
  let ageMonths  = 0;
  let isYoungCat = false;

  if (ageCategory === "kitten") {
    isYoungCat = true;
    if (rawMonths) {
      ageMonths = parseInt(rawMonths, 10) || 0;
      ageYears  = ageMonths / 12; // falls die Berechnung eine Jahreszahl benötigt
    }
  } else if (rawYears) {
    ageYears = parseInt(rawYears, 10) || 0;
  }

  // NEU: automatische Mahlzeitenanzahl für Kitten
  let kittenMealsPerDay = null;
  if (ageCategory === "kitten" && ageMonths) {
    // 2–5 Monate  → 4 Mahlzeiten
    // 6–9 Monate  → 3 Mahlzeiten
    // 10–12 Monate → 2 Mahlzeiten
    if (ageMonths <= 5) {
      kittenMealsPerDay = 4;
    } else if (ageMonths <= 9) {
      kittenMealsPerDay = 3;
    } else {
      kittenMealsPerDay = 2;
    }
  }

  return {
    name:           (fd.get("name") || "").trim(),

    ageYears:       ageYears,
    ageMonths:      ageMonths,
    ageCategory:    ageCategory,
    birthMonth: birthMonth,
    isYoungCat:     isYoungCat,
    kittenMealsPerDay: kittenMealsPerDay, // NEU
    foodChoice: (fd.get("food_choice") || "").toString().trim(),
    ownFoodFeedMode: (fd.get("ownfood_feed_mode_step") || "").toString().trim().toLowerCase(),
    ownFoodWetComposition: sanitizeOpenTextValue(fd.get("ownfood_wet_composition_step") || "", { maxLen: 5000 }),
    ownFoodWetAdditives: sanitizeOpenTextValue(fd.get("ownfood_wet_additives_step") || "", { maxLen: 5000 }),
    ownFoodWetGramsPerDay: normalizeNum(fd.get("ownfood_wet_grams_step")),
    ownFoodDryComposition: sanitizeOpenTextValue(fd.get("ownfood_dry_composition_step") || "", { maxLen: 5000 }),
    ownFoodDryAdditives: sanitizeOpenTextValue(fd.get("ownfood_dry_additives_step") || "", { maxLen: 5000 }),
    ownFoodDryGramsPerDay: normalizeNum(fd.get("ownfood_dry_grams_step")),
    ownFoodSnacksHas: (fd.get("ownfood_snacks_has_step") || "").toString().trim().toLowerCase(),
    ownFoodSnackType: sanitizeOpenTextValue(fd.get("ownfood_snack_type_step") || "", { maxLen: 500 }),
    ownFoodSnackAmount: normalizeNum(fd.get("ownfood_snack_amount_step")),
    ownFoodNotes: sanitizeOpenTextValue(fd.get("ownfood_notes_step") || "", { maxLen: 4000 }),
    cookFamiliarity: (fd.get("cook_familiarity") || "").toString().trim(),
    cookDays: parseInt((fd.get("cook_days") || "").toString().trim(), 10) || 0,
    cookWetME: parseFloat((fd.get("cookwet_me") || "").toString().trim()) || 0,
    barfFamiliarity: (fd.get("barf_familiarity") || "").toString().trim(),
    barfDays: parseInt((fd.get("barf_days") || "").toString().trim(), 10) || 0,
    barfWetME: parseFloat((fd.get("barfwet_me") || "").toString().trim()) || 0,
    weightKg:       parseFloat(fd.get("weight")) || 0,
    sex:            fd.get("sex") || "",
    neuteredStatus: fd.get("neutered") || "",
    breed:          (fd.get("breed") || "").trim(),
    // sichtbares Feld (Fallback), falls hidden "breed" aus irgendeinem Grund leer bleibt
    breedText:      (fd.get("breed_text") || "").toString().trim(),
    activity:       fd.get("activity") || "",
    lifestyle:      fd.get("lifestyle") || "",
    bcs: (function() {
      const raw = fd.get("bcs");
      const val = parseInt(raw, 10);
      if (val >= 1 && val <= 5) return val;
      return 3;
    })(),
    allergyProteins:  fd.getAll("allergy_protein"),
    currentFood:      (fd.get("current_food") || "").trim(),
    pickyLevel:       fd.get("picky_level") || "",
    feedingFrequency: (fd.get("feeding_frequency") || "").toString().trim(),
    healthFocuses:    fd.getAll("health_focus"),
    // Erkrankungen (Step 5)
    hasDisease:       (fd.get("has_disease") || "").toString().trim(),
    diseases:         fd.getAll("disease"),
    diseaseCustom:    (fd.get("disease_custom") || "").toString().trim(),
    socialPartner:    fd.get("social_partner") || "",
    socialCustom:     (fd.get("social_custom") || "").toString().trim(),
    intervalDays:     parseInt(fd.get("interval"), 10) || 30,
    addPlan:          true
  };
}
CatQuiz.main = CatQuiz.main || {};
CatQuiz.main.getAnswers = getAnswers;
   // --------------------------------------------------
  // Allergie-Logik (nur Huhn & Fisch relevant)
  //
  // WICHTIG:
  // - "Rind" bleibt als Checkbox im UI bestehen,
  //   spielt aber in der Empfehlungslogik KEINE Rolle.
  // --------------------------------------------------
  function mapAllergiesForPlan(answers) {
    const proteins = Array.isArray(answers.allergyProteins)
      ? answers.allergyProteins
      : [];

    // Nur Huhn & Fisch an die Logik weiterreichen,
    // "rind" komplett ignorieren.
    const filtered = proteins.filter(p => p === "huhn" || p === "fisch");

    return {
      ...answers,
      allergyProteins: filtered
    };
  }

function renderClaimChips(claims) {
  if (!Array.isArray(claims) || !claims.length) return "";

  const items = claims.map((c) => `
    <li class="claim-chip">
      <img class="claim-chip-icon" src="${(c.icon && c.icon()) || ""}" alt="" aria-hidden="true">
      <span class="claim-chip-text">${c.text}</span>
    </li>
  `).join("");

  return `<ul class="result-claimChips">${items}</ul>`;
}

function renderProductCard(productKey, { amountHtml = "" } = {}) {
  const p = PRODUCTS[productKey];
  if (!p) return "";

  const imgSrc = (p.img && p.img()) || "";

  const badgeHtml = p.badgeText
  ? `<div class="result-free-badge" aria-hidden="true"><span>${p.badgeText}</span></div>`
  : "";

  // --- Cat overlay wie bei Huhn, jetzt auch für Huhn&Forelle ---
let catOverlaySrc = "";
if (productKey === "huhn" && IMG_KATZE_FUTTERCARD) {
  catOverlaySrc = IMG_KATZE_FUTTERCARD;
} else if (productKey === "huhnForelle" && IMG_KATZE_FORELLECARD) {
  catOverlaySrc = IMG_KATZE_FORELLECARD;
}

const catOverlayHtml = catOverlaySrc
  ? `<img class="result-product-cat result-product-cat--${productKey}" src="${catOverlaySrc}" alt="" aria-hidden="true">`
  : "";

const isFood = (productKey === "huhn" || productKey === "huhnForelle");

// Link nur, wenn irgendein Datensatz existiert
const hasModalData =
  !!(INGREDIENTS_DATA?.[productKey] || ANALYTICS_DATA?.[productKey] || MICRONUTRIENTS_DATA?.[productKey]);

const ingredientsLinkHtml = (isFood && hasModalData)
  ? `<button type="button"
             class="result-product-link js-open-ingredients"
             data-product="${productKey}">
       Inhaltsstoffe
     </button>`
  : "";

return `
  <div class="result-product-card result-product-card--${productKey}">
    ${catOverlayHtml}
    ${badgeHtml}

    <div class="result-product-header">
      <div class="result-product-header-row">
        <div class="result-product-name">${p.title || ""}</div>
        ${ingredientsLinkHtml}
      </div>
    </div>

    <div class="result-product-top">
      <img src="${imgSrc}" alt="${p.alt || ""}">
    </div>

    <div class="result-product-bottom">
      ${amountHtml}
      ${renderClaimChips(p.claims)}
    </div>
  </div>
`;

}

function cqRenderComputedFoodCard(food, { amountHtml = "" } = {}) {
  const productKey = cqGetKnownProductKey(food);
  if (productKey) return renderProductCard(productKey, { amountHtml });

  const title = String(food?.label || food?.code || "Futter");
  const imgSrc = IMG_HUHN_CARD || IMG_HUHN || "";

  return `
    <div class="result-product-card result-product-card--generic-food">
      <div class="result-product-header">
        <div class="result-product-header-row">
          <div class="result-product-name">${title}</div>
        </div>
      </div>
      <div class="result-product-top">
        <img src="${imgSrc}" alt="${title}">
      </div>
      <div class="result-product-bottom">
        ${amountHtml}
      </div>
    </div>
  `;
}

function renderIngredientRay(images, opts = {}) {
  const arr = Array.isArray(images) ? images.filter((x) => typeof x === "string" && x.trim()) : [];
  if (!arr.length) return "";

  const autoplay = opts.autoplay !== false; // default: true
  const itemsHtml = arr.map((src) => `
    <div class="ingredient-ray__item" aria-hidden="true">
      <img class="ingredient-ray__img" src="${src}" alt="" loading="lazy">
    </div>
  `).join("");

  // Für einen sauberen Endlos-Loop brauchen wir 2x die gleiche Reihe
  const trackHtml = autoplay ? (itemsHtml + itemsHtml) : itemsHtml;

  return `
    <div class="ingredient-ray ${autoplay ? "ingredient-ray--auto" : ""}" aria-label="Funktionelle Zutaten">
      <div class="ingredient-ray__viewport">
        <div class="ingredient-ray__track">
          ${trackHtml}
        </div>
      </div>
    </div>
  `;
}

function mountIngredientRayIntoResult() {
  try {
    if (!resultBox) return;
    if (!Array.isArray(INGREDIENT_RAY_IMAGES) || !INGREDIENT_RAY_IMAGES.length) return;

    // Host (einmalig)
    let host = resultBox.querySelector(".result-ingredient-ray-host");
    if (!host) {
      host = document.createElement("div");
      host.className = "result-ingredient-ray-host";
    }

    host.innerHTML = renderIngredientRay(INGREDIENT_RAY_IMAGES);

    // ✅ NEU: Im Ownfood-Layout den Rayburst VOR "Tu deiner Katze..." platzieren
    const benefits = resultBox.querySelector(".ownfood-benefits");
    if (benefits && benefits.parentNode) {
      // falls host schon woanders hängt -> zuerst lösen
      if (host.parentNode && host.parentNode !== benefits.parentNode) host.remove();
      benefits.parentNode.insertBefore(host, benefits);
      return;
    }

    // Fallback: sonst wie bisher ans Ende der Resultpage
    if (!host.parentNode) {
      resultBox.appendChild(host);
    } else if (host.parentNode !== resultBox) {
      host.remove();
      resultBox.appendChild(host);
    }
  } catch (e) {
    // silent
  }
}

function mountProduktionAfterRay() {
  try {
    if (!resultBox) return;

    const answers = (typeof getAnswers === "function") ? getAnswers() : {};
    const choice = String(answers.foodChoice || "").toLowerCase();
    const isOwnFoodMode = (choice === "other");
    const isRecipeFlowMode = (choice === "cook" || choice === "barf");

    // Nur im normalen Fellinora-Flow anzeigen.
    if (isOwnFoodMode || isRecipeFlowMode) {
      const old = resultBox.querySelector(".result-produktion-host");
      if (old) old.remove();
      return;
    }

    const rayHost = resultBox.querySelector(".result-ingredient-ray-host");
    if (!rayHost || !rayHost.parentNode) return;

    let host = resultBox.querySelector(".result-produktion-host");
    if (!host) {
      host = document.createElement("div");
      host.className = "result-produktion-host";
    }

    const cards = [
      {
        number: "1.",
        img: IMG_DAMPFGARUNG_1,
        alt: "Ohne künstliche Zusatz- und Aromastoffe",
        title: "Ohne künstliche Zusatz- und Aromastoffe",
        text: "Du weißt genau, was im Napf landet: keine versteckten Zusätze, nur ehrliche Zutaten.",
      },
      {
        number: "2.",
        img: IMG_DAMPFGARUNG_2,
        alt: "Erhalt der natürlichen Nährstoffe",
        title: "Erhalt der natürlichen Nährstoffe",
        text: "Schonend zubereitet, damit wichtige Vitamine und Nährstoffe bestmöglich erhalten bleiben.",
      },
      {
        number: "3.",
        img: IMG_DAMPFGARUNG_3,
        alt: "Natürlicher Eigengeschmack mit hoher Akzeptanz",
        title: "Natürlicher Eigengeschmack mit hoher Akzeptanz",
        text: "Schmeckt deiner Katze von Natur aus – ganz ohne künstliche Tricks oder Lockstoffe.",
      },
    ];

    host.innerHTML = `
      <section class="fellinora-process" aria-label="So entsteht der individuelle Ernährungsplan">
        <h2 class="fellinora-process__title">schonend dampfgegartes Nassfutter</h2>
        <div class="fellinora-process__grid">
          ${cards.map((card) => `
            <article class="fellinora-process-card">
              <div class="fellinora-process-card__media">
                ${card.img ? `<img class="fellinora-process-card__img" src="${card.img}" alt="${card.alt}" loading="lazy" decoding="async">` : ""}
                <span class="fellinora-process-card__number" aria-hidden="true">${card.number}</span>
              </div>
              <div class="fellinora-process-card__body">
                <h3 class="fellinora-process-card__title">${card.title}</h3>
                <p class="fellinora-process-card__text">${card.text}</p>
              </div>
            </article>
          `).join("")}
        </div>
      </section>
    `;

    // Exakt NACH dem Rayburst einfügen
    rayHost.insertAdjacentElement("afterend", host);
  } catch (e) {
    // silent
  }
}

function renderCommunityMarqueeRow(images, reverse = false) {
  const safe = Array.isArray(images) ? images.filter(Boolean) : [];

  // Wenn keine Bilder gesetzt sind (z.B. Dataset fehlt), trotzdem Layout rendern,
  // damit du Header/Platzhalter siehst.
  const base = safe.length ? safe : Array.from({ length: 10 }, () => "");

  // Wichtig: doppeln für seamless loop (wie Rayburst)
  const doubled = base.concat(base);

  const itemsHtml = doubled.map((src) => {
    if (!src) {
      return `<div class="community-marquee__item community-marquee__item--placeholder" aria-hidden="true"></div>`;
    }
    return `
      <div class="community-marquee__item">
        <img src="${src}" alt="Community Katze" loading="lazy" decoding="async">
      </div>
    `;
  }).join("");

  return `
    <div class="community-marquee__row ${reverse ? "community-marquee__row--reverse" : ""}">
      <div class="community-marquee__track">
        ${itemsHtml}
      </div>
    </div>
  `;
}

function mountCommunitySection() {
  try {
    if (!resultBox) return;

    const answers = (typeof getAnswers === "function") ? getAnswers() : {};
const choice = String(answers.foodChoice || "").toLowerCase();
const isOwnFoodMode = (choice === "other");
const isCookRecipeMode = (choice === "cook");
const isBarfRecipeMode = (choice === "barf");
const isRecipeFlowMode = isCookRecipeMode || isBarfRecipeMode;

    if (isOwnFoodMode) {
      const old = resultBox.querySelector(".community-section-host");
      if (old) old.remove();
      return;
    }

    const imgs = (Array.isArray(COMMUNITY_IMAGES) && COMMUNITY_IMAGES.length)
      ? COMMUNITY_IMAGES
      : Array.from({ length: 10 }, () => "");

    // 2 Reihen: oben erste Hälfte, unten zweite Hälfte (Fallback: wenn zu wenig, nimm alle)
    const mid = Math.ceil(imgs.length / 2);
    const row1 = imgs.slice(0, mid);
    const row2 = imgs.slice(mid);

    const row1Imgs = row1.length ? row1 : imgs;
    const row2Imgs = row2.length ? row2 : imgs;

    let host = resultBox.querySelector(".community-section-host");
    if (!host) {
      host = document.createElement("section");
      host.className = "community-section-host";
    }

    host.innerHTML = `
      <div class="community-section">
        <h2 class="community-section__title">
          Werde Teil der Community und ernähre deine Katze wie ein Familienmitglied <span aria-hidden="true">❤️</span>
        </h2>

        <div class="community-marquee" aria-hidden="true">
          ${renderCommunityMarqueeRow(row1Imgs, false)}
          ${renderCommunityMarqueeRow(row2Imgs, true)}
        </div>
      </div>
    `;

if (isRecipeFlowMode) {
  const faqHost = resultBox.querySelector(".result-faq-host");
  if (faqHost) {
    faqHost.insertAdjacentElement("afterend", host);
    return;
  }

  const benefitsBlock = resultBox.querySelector(".ownfood-benefits");
  if (benefitsBlock) {
    benefitsBlock.insertAdjacentElement("afterend", host);
    return;
  }
}

    // Position: IM Fellinora-Flow direkt unter der programmierten Wissenschaft-Section.
    const scienceSection = resultBox.querySelector(".science-section");
    if (scienceSection) {
      scienceSection.insertAdjacentElement("afterend", host);
      return;
    }

    // Fallback: direkt unter die gesamte Benefits-Section
    const wissenschaftBlock = resultBox.querySelector(".ownfood-benefits");
    if (wissenschaftBlock) {
      wissenschaftBlock.insertAdjacentElement("afterend", host);
      return;
    }

    // Fallback: vor FAQ
    const faqHost = resultBox.querySelector(".result-faq-host");
    if (faqHost && faqHost.parentNode) {
      faqHost.parentNode.insertBefore(host, faqHost);
      return;
    }

    resultBox.appendChild(host);
  } catch (e) {
    // silent
  }
}

function reorderCookResultSections() {
  try {
    if (!resultBox) return;

    const answers = (typeof getAnswers === "function") ? getAnswers() : {};
    const choice = String(answers.foodChoice || "").toLowerCase();
    if (choice !== "cook" && choice !== "barf") return;

    const benefits = resultBox.querySelector(".ownfood-benefits");
    const faqHost = resultBox.querySelector(".result-faq-host");
    const communityHost = resultBox.querySelector(".community-section-host");
    const testimonials = resultBox.querySelector(".fellinora-testimonials");

    if (benefits && faqHost) {
      benefits.insertAdjacentElement("afterend", faqHost);
    }

    if (faqHost && communityHost) {
      faqHost.insertAdjacentElement("afterend", communityHost);
    }

    if (communityHost && testimonials) {
      communityHost.insertAdjacentElement("afterend", testimonials);
    } else if (faqHost && testimonials) {
      faqHost.insertAdjacentElement("afterend", testimonials);
    }
  } catch (e) {
    // silent
  }
}

function escapeHtml(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
function normalizeFaqItems(raw) {
  // 1) Array direkt
  if (Array.isArray(raw)) return raw;

  // 2) JSON-String (kommt oft aus Theme-/Config-Injection)
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.items)) return parsed.items;
    } catch {}
  }

  // 3) Objekt-Formate
  if (raw && typeof raw === "object") {
    if (Array.isArray(raw.items)) return raw.items;
    if (Array.isArray(raw.faq)) return raw.faq;
  }

  return [];
}

function normalizeFaqItems(raw) {
  // 1) Array direkt
  if (Array.isArray(raw)) return raw;

  // 2) JSON-String (kommt oft aus Theme-/Config-Injection)
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.items)) return parsed.items;
    } catch {}
  }

  // 3) Objekt-Formate
  if (raw && typeof raw === "object") {
    if (Array.isArray(raw.items)) return raw.items;
    if (Array.isArray(raw.faq)) return raw.faq;
  }

  return [];
}
function mountFaqIntoResult() {
  try {
    if (!resultBox) return;

    // robuster (nutzt deine vorhandene normalizeFaqItems-Funktion)
    const itemsLive = normalizeFaqItems(CatQuiz?.config?.FAQ_ITEMS);
    if (!itemsLive.length) return;

    let host = resultBox.querySelector(".result-faq-host");
    if (!host) {
      host = document.createElement("div");
      host.className = "result-faq-host";
      resultBox.appendChild(host);
    }

    host.innerHTML = renderFaqSection(sanitizeFaqItems(itemsLive));
    const faqRoot = host.querySelector(".result-faq");
    if (faqRoot) initFaqAccordion(faqRoot);
  } catch (e) {
    // optional zum Debuggen:
    // console.warn("[FAQ] render failed", e);
  }
}

// Fix für typische UTF-8→Latin1 Mojibake (z.B. "Ã¤" statt "ä").
// Wenn nichts Auffälliges drin ist, geben wir den Original-String zurück.
function fixMojibake(input) {
  if (input == null) return "";
  const s = String(input);

  if (!/[ÃÂâ€]/.test(s)) return s;

  try {
    const repaired = decodeURIComponent(escape(s));
    if (repaired && repaired !== s) return repaired;
  } catch {}

  try {
    const bytes = Uint8Array.from(s, ch => (ch.charCodeAt(0) & 0xff));
    const repaired = new TextDecoder("utf-8", { fatal: false }).decode(bytes);
    if (repaired && repaired !== s) return repaired;
  } catch {}

  return s;
}

function sanitizeFaqItems(items) {
  const arr = Array.isArray(items) ? items : [];
  return arr.map(it => ({
    ...it,
    q: fixMojibake(it?.q),
    a: fixMojibake(it?.a),
  }));
}

function formatFaqAnswer(text) {
  const safe = escapeHtml(text);
  // Absätze per \n\n, Zeilenumbruch per \n
  const parts = safe.split(/\n\s*\n/).map(p => p.replace(/\n/g, "<br>"));
  return parts.map(p => `<p class="faq-a-p">${p}</p>`).join("");
}

function renderFaqSection(items) {
  const arr = Array.isArray(items) ? items : [];
  if (!arr.length) return "";

  return `
    <section class="result-faq" aria-label="FAQ">
      <div class="result-faq-title">Häufige Fragen</div>

      <div class="faq-shell">
        <ul class="faq-list">
          ${arr.map((it, idx) => {
            const q = escapeHtml(it?.q);
            const aHtml = formatFaqAnswer(it?.a);
            const id = `faq-${idx}`;
            return `
              <li class="faq-item" data-faq-index="${idx}">
                <button class="faq-q" type="button" aria-expanded="false" aria-controls="${id}">
                  <span class="faq-q-text">${q}</span>
                  <span class="faq-icon" aria-hidden="true"></span>
                </button>

                <div id="${id}" class="faq-a" hidden>
                  <div class="faq-a-inner">
                    ${aHtml}
                  </div>
                </div>
              </li>
            `;
          }).join("")}
        </ul>
      </div>
    </section>
  `;
}

function closeFaqItem(itemEl) {
  if (!itemEl) return;
  const btn = itemEl.querySelector(".faq-q");
  const panel = itemEl.querySelector(".faq-a");
  if (!btn || !panel) return;

  itemEl.classList.remove("is-open");
  btn.setAttribute("aria-expanded", "false");

  // smooth close
  panel.style.maxHeight = panel.scrollHeight + "px";
  // next frame -> collapse
  requestAnimationFrame(() => {
    panel.style.maxHeight = "0px";
  });

  const onEnd = (e) => {
    if (e.target !== panel) return;
    panel.hidden = true;
    panel.removeEventListener("transitionend", onEnd);
  };
  panel.addEventListener("transitionend", onEnd);
}

function openFaqItem(itemEl) {
  if (!itemEl) return;
  const btn = itemEl.querySelector(".faq-q");
  const panel = itemEl.querySelector(".faq-a");
  if (!btn || !panel) return;

  itemEl.classList.add("is-open");
  btn.setAttribute("aria-expanded", "true");

  panel.hidden = false;
  panel.style.maxHeight = "0px";
  requestAnimationFrame(() => {
    panel.style.maxHeight = panel.scrollHeight + "px";
  });
}

function initFaqAccordion(rootEl) {
  if (!rootEl) return;
  if (rootEl.__faqInitDone) return;
  rootEl.__faqInitDone = true;

  rootEl.addEventListener("click", (e) => {
    const btn = e.target.closest(".faq-q");
    if (!btn) return;

    e.preventDefault();

    const item = btn.closest(".faq-item");
    if (!item) return;

    const isOpen = item.classList.contains("is-open");

    // immer nur eins offen
    rootEl.querySelectorAll(".faq-item.is-open").forEach((openItem) => {
      if (openItem !== item) closeFaqItem(openItem);
    });

    if (isOpen) closeFaqItem(item);
    else openFaqItem(item);
  });
}

// =====================================================
// Inhaltsstoffe Modal (Single Source of Truth)
//  - Zusammensetzung: INGREDIENTS_DATA
//  - Analytische Werte: ANALYTICS_DATA (+ NFE berechnet)
//  - Zusatzstoffe: MICRONUTRIENTS_DATA
// =====================================================
let _ingredientsModal = { overlayEl: null, isOpen: false, lastFocusEl: null };

function ensureIngredientsModal() {
  if (_ingredientsModal.overlayEl) return _ingredientsModal.overlayEl;

  const overlay = document.createElement("div");
  overlay.className = "ingredients-modal-overlay";
  overlay.setAttribute("aria-hidden", "true");

  overlay.innerHTML = `
    <div class="ingredients-modal" role="dialog" aria-modal="true" aria-label="Inhaltsstoffe">
      <button type="button" class="ingredients-modal-close" aria-label="Schließen">×</button>

      <div class="ingredients-modal-grid">
        <div class="ingredients-modal-media">
          <img class="ingredients-modal-image" alt="" />
        </div>

        <div class="ingredients-modal-body">
          <div class="ingredients-modal-header">
            <h3 class="ingredients-modal-title"></h3>
          </div>

          <div class="ingredients-modal-tabs" role="tablist">
            <button type="button" class="ingredients-modal-tab is-active" data-tab="composition">Zusammensetzung:</button>
            <button type="button" class="ingredients-modal-tab" data-tab="analytics">Analytische Werte:</button>
            <button type="button" class="ingredients-modal-tab" data-tab="additives">Zusatzstoffe:</button>
            <button type="button" class="ingredients-modal-tab" data-tab="feeding">Fütterungsempfehlungen</button>
          </div>

          <div class="ingredients-modal-panels">
            <div class="ingredients-modal-panel is-active" data-tab="composition"></div>
            <div class="ingredients-modal-panel" data-tab="analytics"></div>
            <div class="ingredients-modal-panel" data-tab="additives"></div>
            <div class="ingredients-modal-panel" data-tab="feeding"></div>
          </div>

          <div class="ingredients-modal-footer">
            <div class="ingredients-modal-footer-text">
              Die Rezepte von Fellinora orientieren sich an der<br>natürlichen Beute von Katzen
            </div>
            <div class="ingredients-modal-footer-heart">♥</div>
          </div>
        </div>
      </div>
    </div>
  `;

  // Close handlers
  overlay.querySelector(".ingredients-modal-close")?.addEventListener("click", closeIngredientsModal);
  overlay.addEventListener("click", (e) => { if (e.target === overlay) closeIngredientsModal(); });

  // Tabs
  overlay.querySelector(".ingredients-modal-tabs")?.addEventListener("click", (e) => {
    const btn = e.target?.closest?.(".ingredients-modal-tab");
    if (!btn) return;
    setIngredientsModalTab(btn.dataset.tab);
  });

  // ESC
  document.addEventListener("keydown", (e) => {
    if (_ingredientsModal.isOpen && e.key === "Escape") closeIngredientsModal();
  });

  document.body.appendChild(overlay);
  _ingredientsModal.overlayEl = overlay;
  return overlay;
}

function setIngredientsModalTab(tab) {
  const overlay = _ingredientsModal.overlayEl;
  if (!overlay) return;

  overlay.querySelectorAll(".ingredients-modal-tab").forEach(b =>
    b.classList.toggle("is-active", b.dataset.tab === tab)
  );
  overlay.querySelectorAll(".ingredients-modal-panel").forEach(p =>
    p.classList.toggle("is-active", p.dataset.tab === tab)
  );
}

// "10,5 %" -> 10.5
function parsePercentToNumber(str) {
  const s = String(str || "").replace("%", "").trim().replace(",", ".");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
}

function calcNfeFromAnalyticsRows(rows) {
  const safe = Array.isArray(rows) ? rows : [];
  const get = (needle) => {
    const r = safe.find(x => String(x?.name || "").toLowerCase().includes(needle));
    return r ? parsePercentToNumber(r.amount) : NaN;
  };

  const protein  = get("protein");
  const fat      = get("fett");
  const ash      = get("asche");
  const fiber    = get("faser");
  const moisture = get("feucht");

  const vals = [protein, fat, ash, fiber, moisture];
  if (vals.some(v => !Number.isFinite(v))) return null;

  const nfe = 100 - (protein + fat + ash + fiber + moisture);
  return Math.max(0, nfe);
}

function renderCompositionFromIngredients(rows) {
  const safe = Array.isArray(rows) ? rows : [];
  if (!safe.length) return `<div class="ingredients-modal-center">Inhalte folgen.</div>`;

  // Canva-like: als kompakter Text (aus Ingredient + Amount)
  const parts = safe.map(r => `${r.ingredient} ${r.amount}`.trim());
  return `<div class="ingredients-modal-center">${parts.join(", ")}</div>`;
}

function renderAnalyticsKv(rows) {
  const safe = Array.isArray(rows) ? rows : [];
  if (!safe.length) return `<div class="ingredients-modal-center">Inhalte folgen.</div>`;

  const nfe = calcNfeFromAnalyticsRows(safe);
  const extra = Number.isFinite(nfe)
    ? [{ name: "Nfe (Kohlenhydrate)", amount: `${nfe.toFixed(1).replace(".", ",")} %` }]
    : [];

  const all = [...safe.map(r => ({ name: r.name, amount: r.amount })), ...extra];

  return `
    <div class="ingredients-modal-kv">
      ${all.map((r, idx) => `
        <div class="ingredients-modal-kv-row">
          <div class="ingredients-modal-kv-label">${r.name}:</div>
          <div class="ingredients-modal-kv-value">${r.amount}</div>
        </div>
        ${idx < all.length - 1 ? `<div class="ingredients-modal-kv-sep"></div>` : ``}
      `).join("")}
    </div>
  `;
}

function renderAdditivesFromMicros(rows) {
  const safe = Array.isArray(rows) ? rows : [];
  if (!safe.length) return `<div class="ingredients-modal-center">Inhalte folgen.</div>`;

  // Canva-like: “Nährstoff Menge, …”
  const parts = safe.map(r => `${r.nutrient} ${r.amount}`.trim());
  return `
    <div class="ingredients-modal-lead">Damit deine Katze die Nährstoffe hat die sie braucht!</div>
    <div class="ingredients-modal-center">${parts.join(", ")}</div>
  `;
}

function renderFeedingRecommendations(productKey) {
  const cfg = FEEDING_RECOMMENDATIONS_DATA?.[productKey];
  const rows = Array.isArray(cfg?.rows) ? cfg.rows : [];

  const leftHeader  = cfg?.leftHeader  || "Idealgewicht:";
  const rightHeader = cfg?.rightHeader || "Gramm pro Tag";

  if (!rows.length) {
    return `<div class="ingredients-modal-center">Inhalte folgen.</div>`;
  }

  return `
    <div class="ingredients-modal-feeding">
      <div class="ingredients-modal-feeding-header">
        <div class="ingredients-modal-feeding-left">${leftHeader}</div>
        <div class="ingredients-modal-feeding-right">${rightHeader}</div>
      </div>

      ${rows.map(r => `
        <div class="ingredients-modal-feeding-row">
          <div class="ingredients-modal-feeding-left">${r.weight || ""}</div>
          <div class="ingredients-modal-feeding-right">${r.grams || ""}</div>
        </div>
      `).join("")}
    </div>
  `;
}

function openIngredientsModal(productKey, initialTab = "composition") {
  const overlay = ensureIngredientsModal();

  // Datenquellen (Single Source)
  const ing = INGREDIENTS_DATA?.[productKey] || [];
  const ana = ANALYTICS_DATA?.[productKey] || [];
  const mic = MICRONUTRIENTS_DATA?.[productKey] || [];

  // UI Meta
  const meta = MODAL_META?.[productKey] || {};
  const title = meta.title || `Katzenliebe ${String(PRODUCTS?.[productKey]?.title || "").replace(/&amp;/g, "&")}:`;
  const headerRight = meta.headerRight || "";

  // Image (modal specific -> fallback product image)
  const imgEl = overlay.querySelector(".ingredients-modal-image");
  const fallbackImg = (PRODUCTS?.[productKey]?.img && PRODUCTS[productKey].img()) || "";
  const modalImg =
    (productKey === "huhn" ? IMG_MODAL_HUHN : (productKey === "huhnForelle" ? IMG_MODAL_HUHN_FORELLE : "")) || fallbackImg;

  if (imgEl) {
    imgEl.src = modalImg || "";
    imgEl.alt = title;
  }

  overlay.querySelector(".ingredients-modal-title").textContent = title;
  overlay.querySelector('.ingredients-modal-panel[data-tab="composition"]').innerHTML = renderCompositionFromIngredients(ing);
  overlay.querySelector('.ingredients-modal-panel[data-tab="analytics"]').innerHTML   = renderAnalyticsKv(ana);
  overlay.querySelector('.ingredients-modal-panel[data-tab="additives"]').innerHTML   = renderAdditivesFromMicros(mic);
  overlay.querySelector('.ingredients-modal-panel[data-tab="feeding"]').innerHTML =
  renderFeedingRecommendations(productKey);

  document.documentElement.classList.add("modal-open");
  document.body.classList.add("modal-open");

  _ingredientsModal.isOpen = true;
  _ingredientsModal.lastFocusEl = document.activeElement;

  overlay.classList.add("is-open");
  overlay.setAttribute("aria-hidden", "false");

  setIngredientsModalTab(initialTab);
  overlay.querySelector(".ingredients-modal-close")?.focus?.();
}

function closeIngredientsModal() {
  const overlay = _ingredientsModal.overlayEl;
  if (!overlay) return;

  overlay.classList.remove("is-open");
  overlay.setAttribute("aria-hidden", "true");

  _ingredientsModal.isOpen = false;
  document.documentElement.classList.remove("modal-open");
  document.body.classList.remove("modal-open");

  try { _ingredientsModal.lastFocusEl?.focus?.(); } catch {}
}

quizRoot.addEventListener("click", (e) => {
  const btn = e.target?.closest?.(".js-open-ingredients");
  if (!btn) return;
  e.preventDefault();
  openIngredientsModal(btn.dataset.product, "composition");
});


function renderClaimsHuhnForelle() {
  return `
    <ul class="result-claimChips">
      <li class="claim-chip">
        <img class="claim-chip-icon" src="${ICON_HARNWEGE}" alt="" aria-hidden="true">
        <span class="claim-chip-text">Mit Cranberry für gesunde Harnwege</span>
      </li>

      <li class="claim-chip">
        <img class="claim-chip-icon" src="${ICON_MEAT}" alt="" aria-hidden="true">
        <span class="claim-chip-text">96 % Fleisch, Innereien &amp; Hühnerbrühe</span>
      </li>

      <li class="claim-chip">
        <img class="claim-chip-icon" src="${ICON_SATT}" alt="" aria-hidden="true">
        <span class="claim-chip-text">Mit einer Nährstoffdichte die satt macht</span>
      </li>

      <li class="claim-chip">
        <img class="claim-chip-icon" src="${ICON_OMEGA3}" alt="" aria-hidden="true">
        <span class="claim-chip-text">Mit Omega-3-Fettsäuren für Haut &amp; Fell</span>
      </li>
    </ul>
  `;
}


const fmt1 = (n) => (Number.isFinite(n) ? n.toFixed(1).replace(".", ",") : "–");

function fmtDE(n, decimals = 0) {
  if (!Number.isFinite(n)) return "–";
  return Number(n).toFixed(decimals).replace(".", ",");
}

// =====================================================
// STEP 8 – OWNFOOD Bewertungsblock (unter Result-Layout)
// =====================================================

const OWNFOOD_EVAL_FIELDS = {
  protein:  "ownfood_protein",
  fat:      "ownfood_fat",
  ash:      "ownfood_ash",
  fiber:    "ownfood_fiber",
  moisture: "ownfood_moisture",
};

function normalizeNumLocal(v) {
  if (v == null) return NaN;
  const s = String(v).trim().replace(",", ".");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
}

function formatPct(raw) {
  const s = (raw ?? "").toString().trim();
  if (!s) return "–";
  const n = normalizeNumLocal(s);
  if (!Number.isFinite(n)) return "–";
  const rounded = Math.round(n * 10) / 10; // 1 Nachkommastelle
  const out = (Math.abs(rounded - Math.round(rounded)) < 1e-9)
    ? String(Math.round(rounded))
    : String(rounded);
  return out.replace(".", ",");
}
function updateOwnFoodHealthplanBlockOnResult(answers) {
  const block = quizRoot.querySelector("#ownfood-healthplan-block");
  if (!block) return;

  const choiceFromDom =
    (form.querySelector('input[name="food_choice"]:checked')?.value || "")
      .toString()
      .trim()
      .toLowerCase();

  const choiceFromAnswers =
    String(answers?.foodChoice || "").toLowerCase();

  const isOwnFood = (choiceFromDom || choiceFromAnswers) === "other";

  block.hidden = !isOwnFood;
}


function updateOwnFoodEvalBlockOnResult(answers) {
  const block = quizRoot.querySelector("#ownfood-eval-block");
  if (!block) return;

  const choiceFromDom =
    (form.querySelector('input[name="food_choice"]:checked')?.value || "")
      .toString()
      .trim()
      .toLowerCase();

  const choiceFromAnswers =
    String(answers?.foodChoice || "").toLowerCase();

  const isOwnFood = (choiceFromDom || choiceFromAnswers) === "other";

  block.hidden = !isOwnFood;
  if (!isOwnFood) return;

  for (const [key, fieldName] of Object.entries(OWNFOOD_EVAL_FIELDS)) {
    const input = form.querySelector(`[name="${fieldName}"]`);
    const el = block.querySelector(`.ownfood-val[data-field="${key}"]`);
    if (el) el.textContent = formatPct(input?.value);
  }
}
function updateOwnFoodFeedingplanBlockOnResult(answers) {
  const block = quizRoot.querySelector("#ownfood-feedingplan-block");
  if (!block) return;

  const choiceFromDom =
    (form.querySelector('input[name="food_choice"]:checked')?.value || "")
      .toString()
      .trim()
      .toLowerCase();

  const choiceFromAnswers =
    String(answers?.foodChoice || "").toLowerCase();

  const shouldShow = (choiceFromDom || choiceFromAnswers) === "other";
  block.hidden = !shouldShow;
}

function getResultFlowChoice(answers = {}) {
  const choiceFromDom =
    (form.querySelector('input[name="food_choice"]:checked')?.value || "")
      .toString()
      .trim()
      .toLowerCase();

  const choiceFromAnswers =
    String(answers?.foodChoice || "")
      .trim()
      .toLowerCase();

  return choiceFromDom || choiceFromAnswers;
}
function updateResultSummary() {
  if (!resultBox) return;

  const answers     = getAnswers();
  const planAnswers = mapAllergiesForPlan(answers);
  const base        = computeBasePlan(planAnswers);

  if (!base || base.error === "both_allergic") {
    resultBox.innerHTML = `
      <p>Mit den gewählten Angaben konnte kein Ergebnis berechnet werden. Bitte gehe einen Schritt zurück und überprüfe deine Eingaben (insbesondere Allergien und Gewicht).</p>
    `;
    return;
  }

  const activityLabels = {
    nicht_aktiv: "Eher ruhig / wenig aktiv",
    aktiv: "Aktiv / bewegt sich viel",
  };

  const kcalRounded = Math.round(base.kcal);
  const resultFoods = cqGetFoodsFromBase(base);
  const gTotal = Math.round(cqSumFoodMetric(resultFoods, "gramsPerDay", 6));

  let neuterLabel = "–";
  if (answers.neuteredStatus === "kastriert") neuterLabel = "kastriert";
  if (answers.neuteredStatus === "nicht_kastriert") neuterLabel = "nicht kastriert";

  const fmt1 = (n) => (Number.isFinite(n) ? n.toFixed(1).replace(".", ",") : "–");
  const weightPill = (answers.weightKg && answers.weightKg > 0) ? `${fmt1(answers.weightKg)} kg` : "–";
  const sexPill = answers.sex ? String(answers.sex) : "–";
  const agePill = (() => {
    if (answers.isYoungCat) return answers.ageMonths ? `${answers.ageMonths} Mon.` : "Kitten";
    return answers.ageYears ? `${answers.ageYears} Jahre` : "–";
  })();
  const activityPill = (() => {
    if (answers.activity === "aktiv") return "aktiv";
    if (answers.activity === "nicht_aktiv") return "nicht aktiv";
    return "–";
  })();
  const statusPill = neuterLabel || "–";

  const BCS_DIAGNOSIS = {
    1: "Starkes Untergewicht",
    2: "Leichtes Untergewicht",
    3: "Idealgewicht",
    4: "Übergewicht",
    5: "Starkes Übergewicht",
  };
  const diagnosisLabel = BCS_DIAGNOSIS[Number(answers.bcs)] || "–";

  const dailyNeeds = buildDailyNeeds({
    weightKg: answers.weightKg,
    currentFood: answers.currentFood,
    waterMlPerKg: 50,
  });

  const waterMl = dailyNeeds.waterMl;
  const waterMlRounded = Number.isFinite(waterMl) ? Math.round(waterMl / 10) * 10 : NaN;
  const waterPill = Number.isFinite(waterMlRounded) ? `ca. ${fmtDE(waterMlRounded, 0)} ml / Tag` : "–";
  const proteinG = dailyNeeds.proteinG;
  const proteinPill = Number.isFinite(proteinG) ? `${fmtDE(proteinG, 1)} g / Tag` : "–";
  const taurineMg = dailyNeeds.taurineMg;
  const taurineMgRounded = Number.isFinite(taurineMg) ? Math.round(taurineMg / 5) * 5 : NaN;
  const taurinePill = Number.isFinite(taurineMgRounded) ? `ca. ${fmtDE(taurineMgRounded, 0)} mg / Tag` : "–";

  const productCount = resultFoods.length;
  const foodsHtml = resultFoods
    .map((food) => cqRenderComputedFoodCard(food, {
      amountHtml: `<div class="result-product-amount">${fmtDE(Math.round(Number(food.gramsPerDay || 0)), 0)} g / Tag</div>`
    }))
    .join("");

const ingredientRayHtml = renderIngredientRay(INGREDIENT_RAY_IMAGES);

const catNameForBubble = (answers.name || "").trim() || "NAME";

const doktorKatzeHtml = IMG_DOKTOR_KATZE
  ? `
    <aside class="result-mascot" aria-label="Doktor Katze Empfehlung">
      <div class="result-mascot-bubble">
        Meine Empfehlung für:<br>
        <span class="result-mascot-name">${catNameForBubble}</span>
      </div>
      <img class="result-mascot-img" src="${IMG_DOKTOR_KATZE}" alt="Doktor Katze" />
    </aside>
  `
  : "";

  // --- HTML: Plans unten (immer) ---
  const plansHtml =
    renderProductCard("extraCard1") +
    renderProductCard("extraCard2");

  const foodsClass = productCount === 1
    ? "result-products__foods result-products__foods--single"
    : "result-products__foods";



  // =========================
  // Ernährungsempfehlungen (NEU)
  // =========================
  const recoLines = getNutritionRecoLines(answers);
  const recoTitleName = answers.name || "deiner Katze";

  const recoHtml = `
    <div class="result-reco-title">
      Ernährungsempfehlungen für ${recoTitleName}:
    </div>

    <div class="reco-shell">
      <div class="reco-card" aria-label="Ernährungsempfehlungen">
        <ul class="reco-list">
          ${recoLines.map(line => `<li class="reco-item">${line}</li>`).join("")}
        </ul>
      </div>
    </div>
  `;

  // --- Render ---
const normalizedFoodChoice = getResultFlowChoice(answers);
const isOwnFoodMode = normalizedFoodChoice === "other";
const isCookRecipeMode = normalizedFoodChoice === "cook";
const isBarfRecipeMode = normalizedFoodChoice === "barf";
const isRecipeFlowMode = isCookRecipeMode || isBarfRecipeMode;
const useOwnfoodTopLayout = isOwnFoodMode || isRecipeFlowMode;

  const productsColumnHtml = useOwnfoodTopLayout ? "" : `
      <!-- Links: Produkte -->
      <div class="result-column result-column--products">
        <div class="result-products-title">

        </div>

        <div class="result-products">
          <div class="${foodsClass}">
            ${foodsHtml}
          </div>

          <div class="result-products__plans">
            ${plansHtml}
          </div>
        </div>
      </div>
  `;

  const clipboardColumnHtml = `
      <!-- Rechts: Ernährungsbedarfe + Empfehlungen + DoktorKatze rechts daneben -->
      <div class="result-column result-column--clipboard">
        <div class="result-clipboard-row">

          <div class="result-clipboard-main">
            <div class="result-needs-title">
              Persönliche Ernährungsbedarfe von ${answers.name || "deiner Katze"}:
            </div>

            <div class="needs-shell">
              <div class="needs-card" aria-label="Ernährungsbedarfe">
                <div class="needs-pills-row" role="list" aria-label="Stammdaten">
                  <div class="needs-pill" role="listitem" title="Gewicht">${weightPill}</div>
                  <div class="needs-pill" role="listitem" title="Geschlecht">${sexPill}</div>
                  <div class="needs-pill" role="listitem" title="Alter">${agePill}</div>
                  <div class="needs-pill" role="listitem" title="Aktivität">${activityPill}</div>
                  <div class="needs-pill" role="listitem" title="Status">${statusPill}</div>
                </div>

                <div class="needs-diagnosis" aria-label="Diagnose nach BCS">
                  ${diagnosisLabel}
                </div>

                <div class="needs-metrics" aria-label="Nährstoff- und Wasserbedarf">
                  <div class="needs-metrics-labels">
                    <div class="needs-metric-label">Kalorienbedarf</div>
                    <div class="needs-metric-label">Proteinbedarf</div>
                    <div class="needs-metric-label">Taurinbedarf</div>
                    <div class="needs-metric-label">Wasserbedarf</div>
                  </div>

                  <div class="needs-metrics-values">
                    <div class="needs-metric-value">${kcalRounded} kcal / Tag</div>
                    <div class="needs-metric-value" id="needs-protein">${proteinPill}</div>
                    <div class="needs-metric-value" id="needs-taurine">${taurinePill}</div>
                    <div class="needs-metric-value">${waterPill}</div>
                  </div>
                </div>
              </div>
            </div>

            ${recoHtml}
          </div>

          ${doktorKatzeHtml}
        </div>
      </div>
  `;

  const layoutClass = useOwnfoodTopLayout ? "result-layout result-layout--ownfood" : "result-layout";

const recipeResultsHtml =
  (isCookRecipeMode && window.CatQuizRecipeResults?.renderResultSection)
    ? window.CatQuizRecipeResults.renderResultSection({ answers, form, quizRoot })
    : (isBarfRecipeMode && window.CatQuizBarfRecipeResults?.renderResultSection)
      ? window.CatQuizBarfRecipeResults.renderResultSection({ answers, form, quizRoot })
      : "";

  const testimonialsHtml =
  (!isOwnFoodMode && IMG_TESTIMONIAL_LISA && IMG_TESTIMONIAL_EMMA)
    ? `
      <section class="fellinora-testimonials" id="fellinora-testimonials" aria-label="Erfahrungsberichte">
        <div class="fellinora-testimonials__grid">
          <figure class="fellinora-polaroid fellinora-polaroid--lisa">
            <div class="fellinora-polaroid__frame">
              <img src="${IMG_TESTIMONIAL_LISA}" alt="Lisa B. mit Katze" loading="lazy" decoding="async">
            </div>
            <figcaption class="fellinora-polaroid__name">Lisa B.</figcaption>
          </figure>

          <div class="fellinora-bubble fellinora-bubble--top">
            Dank Fellinora weiß ich was meine Katze wirklich braucht
          </div>

          <div class="fellinora-bubble fellinora-bubble--bottom">
            Endlich bekommt meine Katze eine Ernährung, die zu ihren Bedürfnissen passt
          </div>

          <figure class="fellinora-polaroid fellinora-polaroid--emma">
            <div class="fellinora-polaroid__frame">
              <img src="${IMG_TESTIMONIAL_EMMA}" alt="Emma K. mit Katze" loading="lazy" decoding="async">
            </div>
            <figcaption class="fellinora-polaroid__name">Emma K.</figcaption>
          </figure>
        </div>
      </section>
    `
    : "";
  // --- Render ---
resultBox.innerHTML = `
  <div class="${layoutClass}">
    ${productsColumnHtml}
    ${clipboardColumnHtml}
  </div>
  
  <!-- OWNFOOD: wissenschaftliche Bewertung (nur wenn food_choice="other") -->
  <section id="ownfood-eval-block" class="ownfood-eval" hidden>
    <div class="ownfood-eval__grid">
      <!-- Title sitzt AUF der weißen Gesamtkarte -->
      <h3 class="ownfood-eval__title">
  Wissenschaftlich fundierte Bewertung des aktuellen Futters von
  <span class="js-name-text" data-default="Name" data-template="%NAME%">Name</span>
</h3>

<div class="ownfood-eval__subtitle">
  <span class="ownfood-eval__arrow" aria-hidden="true">
    <svg viewBox="0 0 48 16" width="48" height="16" focusable="false" aria-hidden="true">
      <path d="M0 4h30V0l18 8-18 8v-4H0V4z" fill="#dfecc7"></path>
    </svg>
  </span>

  <div class="ownfood-eval__subtitleText">
    Finde heraus, ob das Futter zu den Bedürfnissen von
    <span class="js-name-text" data-default="Name" data-template="%NAME%">Name</span>
    passt.
  </div>
</div>
<!-- 1) Rohprotein -->
<div class="ownfood-eval-card">
  <div class="ownfood-eval-card__inner">
    <div class="ownfood-eval-card__head">
      Rohprotein %
      <button
        type="button"
        class="ownfood-info-btn"
        aria-label="Info Rohprotein"
        data-info-title="Rohprotein"
        data-info-text="Ein hoher Proteinwert ist wichtig, damit Muskeln, Organe und Immunsystem optimal versorgt sind."
      >i</button>
    </div>

    <div class="ownfood-eval-label">Dein Futter:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--purple">
      <span class="ownfood-val" data-field="protein">–</span> %
    </div>

    <div class="ownfood-eval-label">Idealwert:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--green">?</div>

    <div class="ownfood-eval-label">Empfehlung:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--red">?</div>
  </div>
</div>

<!-- 2) Rohfett -->
<div class="ownfood-eval-card">
  <div class="ownfood-eval-card__inner">
    <div class="ownfood-eval-card__head">
      Rohfett %
      <button
        type="button"
        class="ownfood-info-btn"
        aria-label="Info Rohfett"
        data-info-title="Rohfett"
        data-info-text="Fett spielt eine zentrale Rolle im Stoffwechsel und hilft, Energie gleichmäßig über den Tag bereitzustellen."
      >i</button>
    </div>

    <div class="ownfood-eval-label">Dein Futter:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--purple">
      <span class="ownfood-val" data-field="fat">–</span> %
    </div>

    <div class="ownfood-eval-label">Idealwert:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--green">?</div>

    <div class="ownfood-eval-label">Empfehlung:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--red">?</div>
  </div>
</div>

<!-- 3) Rohasche -->
<div class="ownfood-eval-card">
  <div class="ownfood-eval-card__inner">
    <div class="ownfood-eval-card__head">
      Rohasche %
      <button
        type="button"
        class="ownfood-info-btn"
        aria-label="Info Rohasche"
        data-info-title="Rohasche"
        data-info-text="Ein angemessener Rohaschewert ist wichtig, weil er zeigt, dass deine Katze mit den nötigen Mineralstoffen versorgt wird."
      >i</button>
    </div>

    <div class="ownfood-eval-label">Dein Futter:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--purple">
      <span class="ownfood-val" data-field="ash">–</span> %
    </div>

    <div class="ownfood-eval-label">Idealwert:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--green">?</div>

    <div class="ownfood-eval-label">Empfehlung:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--red">?</div>
  </div>
</div>

<!-- 4) Rohfaser -->
<div class="ownfood-eval-card">
  <div class="ownfood-eval-card__inner">
    <div class="ownfood-eval-card__head">
      Rohfaser %
      <button
        type="button"
        class="ownfood-info-btn"
        aria-label="Info Rohfaser"
        data-info-title="Rohfaser"
        data-info-text="Ein zu hoher Rohfasergehalt kann die Verdaulichkeit sowie die Energieaufnahme des Futters verringern."
      >i</button>
    </div>

    <div class="ownfood-eval-label">Dein Futter:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--purple">
      <span class="ownfood-val" data-field="fiber">–</span> %
    </div>

    <div class="ownfood-eval-label">Idealwert:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--green">?</div>

    <div class="ownfood-eval-label">Empfehlung:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--red">?</div>
  </div>
</div>

<!-- 5) Feuchtigkeit -->
<div class="ownfood-eval-card">
  <div class="ownfood-eval-card__inner">
    <div class="ownfood-eval-card__head">
      Feuchtigkeit %
      <button
        type="button"
        class="ownfood-info-btn"
        aria-label="Info Feuchtigkeit"
        data-info-title="Feuchtigkeit"
        data-info-text="Ein hoher Feuchtigkeitswert sorgt dafür, dass deine Katze ausreichend Flüssigkeit aufnimmt."
      >i</button>
    </div>

    <div class="ownfood-eval-label">Dein Futter:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--purple">
      <span class="ownfood-val" data-field="moisture">–</span> %
    </div>

    <div class="ownfood-eval-label">Idealwert:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--green">?</div>

    <div class="ownfood-eval-label">Empfehlung:</div>
    <div class="ownfood-eval-pill ownfood-eval-pill--red">?</div>
  </div>
</div>

<!-- Popover (Inhalt wird per JS gesetzt) -->
<div class="ownfood-info-panel" hidden>
  <div class="ownfood-info-panel-inner">
    <div class="ownfood-info-heading"></div>
    <p class="ownfood-info-text"></p>
  </div>
</div>
  </section>

  <!-- OWNFOOD: Gesundheitsplan (nur wenn food_choice="other") -->
  <section id="ownfood-healthplan-block" class="ownfood-healthplan" hidden>
    <div class="ownfood-healthplan__frame">

      <div class="ownfood-healthplan__badge">
        Ernährungsberatung
      </div>

      <div class="ownfood-healthplan__grid">
<div class="ownfood-healthplan__left" aria-hidden="true">
  ${HEALTHPLAN_IMG
    ? `<img class="ownfood-healthplan__image" src="${HEALTHPLAN_IMG}" alt="" loading="lazy">`
    : `<div class="ownfood-healthplan__imagePlaceholder"></div>`
  }
</div>



        <div class="ownfood-healthplan__right">
          <div class="ownfood-healthplan__header">
<h3 class="ownfood-healthplan__title">
  Gib deiner Katze die Ernährung, die sie braucht!</span>
</h3>

            <!-- Logo wird später als PNG eingefügt -->
            <div class="ownfood-healthplan__logoPlaceholder" aria-label="Logo Platzhalter"></div>
          </div>

          <div class="ownfood-healthplan__card">
            <ol class="ownfood-healthplan__list">
              <li>Berechnung des individuellen Nährstoffbedarfs deiner Katze z. B. Kalorien, Eiweiß, Wasser, Taurin und Fett</li>
              <li>Prüfung, ob dein aktuelles Futter den Bedarf deiner Katze wirklich deckt</li>
              <li>Konkrete Ernährungsempfehlungen von unseren Experten für deine Katze</li>
              <li>Frühes Erkennen möglicher Gewichtsprobleme durch professionelle Analyse</li>
            </ol>
          </div>
        </div>
      </div>

    </div>
  </section>
    <!-- OWNFOOD: Futterplan (nur wenn food_choice="other") -->
  <section id="ownfood-feedingplan-block" class="ownfood-feedingplan" hidden>
    <div class="ownfood-feedingplan__frame">
      <!-- Logo wird später als PNG eingefügt -->
      <div class="ownfood-feedingplan__logoPlaceholder" aria-label="Logo Platzhalter"></div>

      <div class="ownfood-feedingplan__badge">
        Individueller Ernärhungsplan
      </div>

      <div class="ownfood-feedingplan__grid">
        <!-- LINKS: Title + Card -->
        <div class="ownfood-feedingplan__left">
          <h3 class="ownfood-feedingplan__title">
           Der persönliche </br> Futterplan für <span class="js-name-text" data-default="Name" data-template="%NAME%">Name</span>
          </h3>

          <div class="ownfood-feedingplan__card">
<ul class="ownfood-feedingplan__list">
  <li>Passend berechnete Futtermengen nach dem tatsächlichen Kalorienbedarf deiner Katze.</li>
  <li>Wissenschaftlich fundierte Empfehlungen für artgerechte Futterzeiten.</li>
  <li>Ausgedruckter 4-Wochen-Futterplan, der dir bequem nach Hause geschickt wird.</li>
  <li>Monatliche Anpassung des Futterplans an die aktuellen Bedürfnisse deiner Katze.</li>
</ul>
          </div>
        </div>

<!-- RECHTS: Bildfläche -->
<div class="ownfood-feedingplan__right" aria-hidden="true">
  ${FEEDINGPLAN_IMG
    ? `<img class="ownfood-feedingplan__image" src="${FEEDINGPLAN_IMG}" alt="" loading="lazy">`
    : `<div class="ownfood-feedingplan__imagePlaceholder"></div>`
  }
</div>

    </div>
  </section>
${recipeResultsHtml}
<!-- BENEFITS STRIP (unterhalb Futterplankarte) -->
<section class="ownfood-benefits">
  <h3 class="ownfood-benefits__headline">
    Tu deiner Katze jeden Tag etwas Gutes mit<br>
    der richtigen Ernährung!
  </h3>

  <div class="ownfood-benefits__grid">
    <!-- 1 -->
    <div class="ownfood-benefits__item">
      <div class="ownfood-benefits__img ownfood-benefits__img--1" aria-hidden="true"></div>
      <div class="ownfood-benefits__pill">
        <span class="ownfood-benefits__lines" aria-hidden="true"></span>
        <span class="ownfood-benefits__text">Bedarfsgerechte Versorgung<br>deiner Katze</span>
      </div>
    </div>

    <!-- 2 -->
    <div class="ownfood-benefits__item">
      <div class="ownfood-benefits__img ownfood-benefits__img--2" aria-hidden="true"></div>
      <div class="ownfood-benefits__pill">
        <span class="ownfood-benefits__lines" aria-hidden="true"></span>
        <span class="ownfood-benefits__text">Unterstützt ein gesundes<br>Körpergewicht</span>
      </div>
    </div>

    <!-- 3 -->
    <div class="ownfood-benefits__item">
      <div class="ownfood-benefits__img ownfood-benefits__img--3" aria-hidden="true"></div>
      <div class="ownfood-benefits__pill">
        <span class="ownfood-benefits__lines" aria-hidden="true"></span>
        <span class="ownfood-benefits__text">Ernährungsberatung von<br>Experten</span>
      </div>
    </div>

    <!-- 4 -->
    <div class="ownfood-benefits__item">
      <div class="ownfood-benefits__img ownfood-benefits__img--4" aria-hidden="true"></div>
      <div class="ownfood-benefits__pill">
        <span class="ownfood-benefits__lines" aria-hidden="true"></span>
        <span class="ownfood-benefits__text">Für mehr Energie, Lebensfreude<br>und Abenteuerlust</span>
      </div>
    </div>
  </div>

  <section class="science-section" aria-labelledby="science-section-title">
    <h3 class="science-title" id="science-section-title">
      Wissenschaftlich und studienbasiertes Konzept
    </h3>

    <div class="science-container">
      <div class="science-left">
        <div class="vet-profile">
          <img src="${IMG_VET_KATHI}" alt="Tierärztin Kathi D." loading="lazy">
          <p class="vet-name">Tierärztin<br><strong>Kathi D.</strong></p>
        </div>

        <div class="speech-box">
          <p>
            So individuell wie jede Katze ist auch ihr Ernährungsbedarf.
            Fellinora digitalisiert die Ernährungsberatung und hilft dir,
            die passende Ernährung für deine Katze zu finden.
          </p>
        </div>
      </div>

      <div class="science-right">
        <div class="badge">Über 200 Studien</div>

        <ul class="science-points">
          <li>Nach aktuellen wissenschaftlichen Erkenntnissen</li>
          <li>Mit Tierärzten in Deutschland entwickelt</li>
          <li>Von Katzeneltern für Katzeneltern</li>
        </ul>
      </div>
    </div>
  </section>
</section>
${testimonialsHtml}
`;
updateNameTexts();
updateOwnFoodEvalBlockOnResult(answers);
updateOwnFoodHealthplanBlockOnResult(answers);
updateOwnFoodFeedingplanBlockOnResult(answers);

if (window.CatQuizRecipeResults?.mountResultSection) {
  try {
    window.CatQuizRecipeResults.mountResultSection({ answers, form, quizRoot });
  } catch (e) {
    console.warn("[CatQuiz] recipe result section mount failed:", e);
  }
}

if (window.CatQuizBarfRecipeResults?.mountResultSection) {
  try {
    window.CatQuizBarfRecipeResults.mountResultSection({ answers, form, quizRoot });
  } catch (e) {
    console.warn("[CatQuiz] BARF recipe result section mount failed:", e);
  }
}

}



// --------------------------------------------------
// Pricing ausgelagert nach quiz-pricing.js
//  - enthält: PRICING-State + Variant-Price Fetch + Total/Tag-Preise
//  - exportiert weiterhin die gleichen Funktionsnamen (ensurePricingLoaded, getSubscriptionPricing, ...)
// --------------------------------------------------
const PRICING = CatQuiz.data?.PRICING;
function normalizeDonationKey(raw) {
  const v = String(raw || "").trim().toLowerCase();

  if (v === "straßenkatzen" || v === "strassenkatzen") return "strassenkatzen";
  if (v === "tierheim" || v === "tierheime") return "tierheime";
  if (v === "wildkatzen" || v === "wildkatze") return "wildkatzen";

  // alles andere (z.B. "custom", "alle drei", leer) -> all
  return "all";
}

function getDonationCopyByKey(key) {
  const dict = CatQuiz.labels?.DONATION_COPY;
  return (dict && dict[key]) || (dict && dict.all) || "";
}


/* Testbox pro Tag = individuelle Tagesmenge × 1-kg-Preis × (1 − Rabatt)

Testbox Total = benötigte Anzahl 100g-Pouches (gerundet) × 100g-Preis × (1 − Rabatt)

Unten „Testbox pro Tag“ = exakt derselbe Wert wie oben

„Monatsbox pro Tag“ = berechnete Tagesmenge (full/half) × 1-kg-Preis (ohne Rabatt)*/

function updateSubscriptionOverview() {
  // --------------------------------------------------
  // STEP 9: Ownfood (food_choice="other") => neue Top-Cards statt Trial+PlanPicker
  // --------------------------------------------------

  const step9El = quizRoot.querySelector('.quiz-step[data-step="9"]');
  if (!step9El) return;

  // Antworten nur EINMAL holen (wird unten wieder gebraucht)
  const answers = getAnswers();

  const choiceFromDom =
    (form.querySelector('input[name="food_choice"]:checked')?.value || "")
      .toString()
      .trim()
      .toLowerCase();

  const choiceFromAnswers = String(answers?.foodChoice || "").toLowerCase();
  const normalizedChoice = (choiceFromDom || choiceFromAnswers);
  const isOwnFood = normalizedChoice === "other";
  const isCookFlow = normalizedChoice === "cook";
  const isBarfFlow = normalizedChoice === "barf";
  const isRecipeFlow = isCookFlow || isBarfFlow;
  const submitBtn =
    step9El.querySelector(".btn-next") ||
    step9El.querySelector(".btn-submit") ||
    form.querySelector(".btn-next") ||
    form.querySelector(".btn-submit");

  if (submitBtn) {
    if (!submitBtn.dataset.originalText) {
      submitBtn.dataset.originalText = submitBtn.textContent.trim();
    }

    submitBtn.textContent = (isOwnFood || isRecipeFlow)
      ? "Zum Checkout"
      : submitBtn.dataset.originalText;
  }

  const subHeroEl     = step9El.querySelector(".subscription-hero");
  const subSummaryEl  = step9El.querySelector(".subscription-summary");
  const trialCardEl   = step9El.querySelector(".trial-box-card");
  const planPickerEl  = step9El.querySelector(".plan-picker");
  const subscriptionPricesEl = step9El.querySelector(".subscription-prices");

  // --------------------------------------------------
  // Ownfood Cards einmalig in DOM injizieren (MUSS vor dem Toggle passieren!)
  // --------------------------------------------------
  function ensureOwnFoodCards() {
  const existingLeft  = step9El.querySelector("#ownfood-plan-card");
  const existingRight = step9El.querySelector("#ownfood-addon-card");

  // Wenn Cards schon existieren: Bilder trotzdem updaten und dann raus
  if (existingLeft && existingRight) {
    const planImgEl  = existingLeft.querySelector(".ownfood-plan-card__media img");
    const addonImgEl = existingRight.querySelector(".ownfood-addon-card__img img");

    if (planImgEl && typeof IMG_OWNFOOD_PLAN_CARD !== "undefined" && IMG_OWNFOOD_PLAN_CARD) {
      planImgEl.src = IMG_OWNFOOD_PLAN_CARD;
    }
    if (addonImgEl && typeof IMG_OWNFOOD_ADDON_CARD !== "undefined" && IMG_OWNFOOD_ADDON_CARD) {
      addonImgEl.src = IMG_OWNFOOD_ADDON_CARD;
    }
    return;
  }

  const displayName = answers?.name || "deine Katze";

  const left = document.createElement("section");
  left.className = "ownfood-plan-card";
  left.id = "ownfood-plan-card";
  left.hidden = true;

  const heroImg = IMG_OWNFOOD_PLAN_CARD; // KEIN Doktor-Katze-Fallback

  left.innerHTML = `
  <div class="ownfood-plan-card__media">
    <img src="${heroImg}" alt="4 Wochen Ernährungskonzept" loading="eager" decoding="async">
  </div>

  <div class="ownfood-plan-card__body">
    <h4 class="ownfood-plan-card__title">
      Das 4 Wochen Ernährungskonzept für <span data-ownfood-name>${displayName}</span>:
    </h4>

    <div class="ownfood-plan-card__tagline">
      <span>Weil deine Katze nur das Beste verdient</span>
    </div>

    <ul class="ownfood-plan-card__bullets">
      <li><span class="ownfood-plan-card__check" aria-hidden="true">✅</span><span>Individuelle Futtermenge + Futterzeiten</span></li>
      <li><span class="ownfood-plan-card__check" aria-hidden="true">✅</span><span>Gesundheitsplan mit Nährstoffberechnungen</span></li>
      <li><span class="ownfood-plan-card__check" aria-hidden="true">✅</span><span>Bewertung deines aktuellen Futters</span></li>
      <li><span class="ownfood-plan-card__check" aria-hidden="true">✅</span><span>Ernährungsempfehlung persönlich für deine Katze</span></li>
    </ul>

    <div class="ownfood-plan-card__price">
      <span class="ownfood-plan-card__price-label">Preis pro Monat nur:</span>

      <span class="ownfood-plan-card__price-values">
        <strong id="ownfood-plan-price-month">9,99 €</strong>
        <span class="ownfood-plan-card__price-old">anstatt 14,99 €</span>
      </span>

      <span class="ownfood-plan-card__badge" aria-hidden="true">
        <span>20%</span><span>Rabatt</span>
      </span>
    </div>

    <div class="ownfood-plan-card__rows">
      <div class="ownfood-plan-card__row ownfood-plan-card__row--mail">
        <span class="ownfood-plan-card__row-icon" aria-hidden="true">✉️</span>
        <span>Jeden Monat ausgedruckt nach Hause geschickt</span>
      </div>

      <div class="ownfood-plan-card__row ownfood-plan-card__row--heart">
        <span class="ownfood-plan-card__row-icon" aria-hidden="true">❤️</span>
        <span class="ownfood-plan-card__donation">Du unterstützt mit der Bestellung Katzen in Not</span>
      </div>
    </div>
  </div>
`;

    // (2) Rechte Card: Optional Probierbox
    const right = document.createElement("section");
    right.className = "ownfood-addon-card";
    right.id = "ownfood-addon-card";
    right.hidden = true;

const addonImg = IMG_OWNFOOD_ADDON_CARD;

right.innerHTML = `
  <div class="ownfood-addon-card__header">
    <div class="ownfood-addon-card__headline">
      Füge das passende Futter zum Ernährungskonzept für <span data-ownfood-name>${displayName}</span> hinzu
    </div>

<span class="ownfood-addon-card__heart" aria-hidden="true">&#10084;&#65039;</span>
  </div>

  <div class="ownfood-addon-card__body">
    <div class="ownfood-addon-card__grid">
      <div class="ownfood-addon-card__img">
        <div class="ownfood-addon-card__badge" aria-hidden="true">
          <span>20%</span>
          <span>Rabatt</span>
        </div>
        <img src="${addonImg}" alt="Fellinora Probierbox" loading="lazy" decoding="async">
      </div>

      <div class="ownfood-addon-card__copy">
        <div class="ownfood-addon-card__title">Schonend dampfgegartes Futter<br>von Fellinora</div>

<ul class="ownfood-addon-card__bullets">
    <li>
      <span class="ownfood-addon-card__icon" aria-hidden="true">
        ${iconImg(ICON_FLEISCH)}
      </span>
      <span class="ownfood-addonCardText">95 % Fleisch, Innereien und Brühe</span>
    </li>

    <li>
      <span class="ownfood-addon-card__icon" aria-hidden="true">
        ${iconImg(ICON_MAUS)}
      </span>
      <span class="ownfood-addonCardText">Rezepte inspiriert von den natürlichen Beutetieren von Katzen</span>
    </li>

    <li>
      <span class="ownfood-addon-card__icon" aria-hidden="true">
        ${iconImg(ICON_VERDAUUNG)}
      </span>
      <span class="ownfood-addonCardText">Präbiotika-Formel für die Verdauung</span>
    </li>

    <li>
      <span class="ownfood-addon-card__icon" aria-hidden="true">
        ${iconImg(ICON_WOW)}
      </span>
      <span class="ownfood-addonCardText">Natürliche Zutaten, die du sehen kannst</span>
    </li>
  </ul>
      </div>
    </div>

    <div class="ownfood-addon-card__row ownfood-addon-card__meals" id="ownfood-addon-meals">
      – Mahlzeiten abgestimmt an <span data-ownfood-name>${displayName}</span>
    </div>

    <div class="ownfood-addon-card__row ownfood-addon-card__price">
      <span>Futterkosten pro Tag</span>
      <strong id="ownfood-addon-price-per-day">–</strong>
    </div>

    <button type="button" class="ownfood-addon-card__btn" id="ownfood-addon-add" disabled>
      Hinzufügen
    </button>

    <div class="ownfood-addon-card__total">
      Total: <span id="ownfood-addon-total">–</span>
    </div>
  </div>
`;

    if (subHeroEl) subHeroEl.appendChild(left);
    if (subSummaryEl) subSummaryEl.appendChild(right);
  }

  ensureOwnFoodCards();

  function ensureRecipeFlowPlanCard() {
    let recipeCard = step9El.querySelector("#recipe-flow-plan-card");
    if (recipeCard) return recipeCard;

    recipeCard = document.createElement("section");
    recipeCard.className = "ownfood-plan-card recipe-flow-plan-card";
    recipeCard.id = "recipe-flow-plan-card";
    recipeCard.hidden = true;

    if (subHeroEl) subHeroEl.appendChild(recipeCard);
    return recipeCard;
  }

  function ensureRecipeFlowAddonCard() {
    let addonCard = step9El.querySelector("#recipe-flow-addon-card");
    if (addonCard) return addonCard;

    addonCard = document.createElement("section");
    addonCard.className = "ownfood-addon-card recipe-flow-addon-card";
    addonCard.id = "recipe-flow-addon-card";
    addonCard.hidden = true;

    if (subSummaryEl) subSummaryEl.appendChild(addonCard);
    return addonCard;
  }

  const recipeCardEl = ensureRecipeFlowPlanCard();
  const recipeAddonCardEl = ensureRecipeFlowAddonCard();

  if (recipeCardEl) {
    const displayName = answers?.name || "deine Katze";
    const flowLabel = isBarfFlow ? "BARF" : "Kochplan";
    const flowTitle = isBarfFlow
      ? `${displayName}'s individueller BARFplan`
      : `${displayName}'s individueller Kochplan`;
    const heroImg = IMG_OWNFOOD_PLAN_CARD || IMG_FUTTERPLAN || IMG_HUHN_FORELLE || IMG_HUHN || "";

    const flowBullets = isBarfFlow
      ? [
          "3 individuell berechnete Rezepte",
          "Gesundheitsplan mit Nährstoffberechnung",
          `abgestimmt auf ${displayName}'s Bedürfnisse`,
          "exakt berechnete Nährstoffmengen"
        ]
      : [
          "3 individuell berechnete Rezepte",
          "Gesundheitsplan mit Nährstoffberechnung",
          `abgestimmt auf ${displayName}'s Bedürfnisse`,
          "exakt berechnete Nährstoffmengen"
        ];

    recipeCardEl.innerHTML = `
      <div class="ownfood-plan-card__media">
        <img src="${heroImg}" alt="${flowLabel} Abo" loading="eager" decoding="async">
      </div>

      <div class="ownfood-plan-card__body">
        <h4 class="ownfood-plan-card__title">${flowTitle}</h4>

        <ul class="ownfood-plan-card__bullets">
          ${flowBullets.map((line) => `<li><span class="ownfood-plan-card__check" aria-hidden="true">✅</span><span>${line}</span></li>`).join("")}
        </ul>

        <div class="ownfood-plan-card__price">
          <span class="ownfood-plan-card__price-label">Preis pro Monat nur:</span>
          <span class="ownfood-plan-card__price-values">
            <strong id="recipe-flow-plan-price-month">9,99 €</strong>
            <span class="ownfood-plan-card__price-old">anstatt 14,99 €</span>
          </span>
          <span class="ownfood-plan-card__badge" aria-hidden="true">
            <span>20%</span><span>Rabatt</span>
          </span>
        </div>

        <div class="ownfood-plan-card__rows">
          <div class="ownfood-plan-card__row ownfood-plan-card__row--mail">
            <span class="ownfood-plan-card__row-icon" aria-hidden="true">✉️</span>
            <span>Jeden Monat ausgedruckt nach Hause geschickt</span>
          </div>

          <div class="ownfood-plan-card__row ownfood-plan-card__row--heart">
            <span class="ownfood-plan-card__row-icon" aria-hidden="true">❤️</span>
            <span class="ownfood-plan-card__donation">Du unterstützt mit der Bestellung Katzen in Not</span>
          </div>
        </div>
      </div>
    `;
  }

  // --------------------------------------------------
// Donation-Text dynamisch je nach Auswahl setzen (konstante Sätze)
// --------------------------------------------------
const donationKey = normalizeDonationKey(answers?.socialPartner);
const donationText = getDonationCopyByKey(donationKey);

// Trial-Card (Fellinora)
const trialDonationTextEl = step9El.querySelector(".trial-box-card__donation-text");
if (trialDonationTextEl && donationText) trialDonationTextEl.textContent = donationText;

// Ownfood-Plan-Card
const ownDonationEl = step9El.querySelector(".ownfood-plan-card__donation");
if (ownDonationEl && donationText) ownDonationEl.textContent = donationText;

  const ownLeftEl  = step9El.querySelector("#ownfood-plan-card");
  const ownRightEl = step9El.querySelector("#ownfood-addon-card");

  // --------------------------------------------------
  // Toggle: Ownfood/Recipe-Fows => eigene Card zeigen; Fellinora => Standard-Abo zeigen
  // --------------------------------------------------
  if (trialCardEl)  trialCardEl.hidden  = (isOwnFood || isRecipeFlow);
  if (planPickerEl) planPickerEl.hidden = (isOwnFood || isRecipeFlow);

const planTipEl = step9El.querySelector(".plan-picker__tip-card");
if (planTipEl) planTipEl.hidden = (isOwnFood || isRecipeFlow);
  // Pricing-Block nur im klassischen Fellinora-Flow zeigen
  if (subscriptionPricesEl) subscriptionPricesEl.hidden = (isOwnFood || isRecipeFlow);

  if (ownLeftEl) ownLeftEl.hidden = !isOwnFood;
  if (ownRightEl) ownRightEl.hidden = !isOwnFood;
  if (recipeCardEl) recipeCardEl.hidden = !isRecipeFlow;
  if (recipeAddonCardEl) recipeAddonCardEl.hidden = !isRecipeFlow;

  // --------------------------------------------------
  // RECIPE FLOWS: Optionales Fellinora-Futter nur bei expliziter Auswahl hinzufügen
  // --------------------------------------------------
  if (isRecipeFlow) {
    const displayName = answers?.name || "deine Katze";
    const TRIAL_DAYS = 7;
    const planAnswers = mapAllergiesForPlan(answers);
    const base = computeBasePlan(planAnswers);

    let addonHidden = form.querySelector('input[name="recipe_flow_addon_selected"]');
    if (!addonHidden) {
      addonHidden = document.createElement("input");
      addonHidden.type = "hidden";
      addonHidden.name = "recipe_flow_addon_selected";
      addonHidden.value = "0";
      form.appendChild(addonHidden);
    }

    if (!recipeAddonCardEl) return;

    const addonImg = IMG_OWNFOOD_ADDON_CARD || IMG_HUHN_FORELLE_CARD || IMG_HUHN_FORELLE || IMG_HUHN || "";
    recipeAddonCardEl.innerHTML = `
      <div class="ownfood-addon-card__header">
        <div class="ownfood-addon-card__headline">
          Füge das passende Futter zum Ernährungskonzept für <span data-ownfood-name>${displayName}</span> hinzu
        </div>
        <span class="ownfood-addon-card__heart" aria-hidden="true">&#10084;&#65039;</span>
      </div>

      <div class="ownfood-addon-card__body">
        <div class="ownfood-addon-card__grid">
          <div class="ownfood-addon-card__img">
            <div class="ownfood-addon-card__badge" aria-hidden="true">
              <span>20%</span>
              <span>Rabatt</span>
            </div>
            <img src="${addonImg}" alt="Fellinora Futteroption" loading="lazy" decoding="async">
          </div>

          <div class="ownfood-addon-card__copy">
            <div class="ownfood-addon-card__title">Schonend dampfgegartes Futter<br>von Fellinora</div>

            <ul class="ownfood-addon-card__bullets">
              <li>
                <span class="ownfood-addon-card__icon" aria-hidden="true">${iconImg(ICON_FLEISCH)}</span>
                <span class="ownfood-addonCardText">95 % Fleisch, Innereien und Brühe</span>
              </li>
              <li>
                <span class="ownfood-addon-card__icon" aria-hidden="true">${iconImg(ICON_MAUS)}</span>
                <span class="ownfood-addonCardText">Rezepte inspiriert von den natürlichen Beutetieren von Katzen</span>
              </li>
              <li>
                <span class="ownfood-addon-card__icon" aria-hidden="true">${iconImg(ICON_VERDAUUNG)}</span>
                <span class="ownfood-addonCardText">Präbiotika-Formel für die Verdauung</span>
              </li>
              <li>
                <span class="ownfood-addon-card__icon" aria-hidden="true">${iconImg(ICON_WOW)}</span>
                <span class="ownfood-addonCardText">Natürliche Zutaten, die du sehen kannst</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="ownfood-addon-card__row ownfood-addon-card__meals" id="recipe-flow-addon-meals">– Mahlzeiten abgestimmt an <span data-ownfood-name>${displayName}</span></div>
        <div class="ownfood-addon-card__row ownfood-addon-card__price">
          <span>Futterkosten pro Tag</span>
          <strong id="recipe-flow-addon-price-per-day">–</strong>
        </div>
        <button type="button" class="ownfood-addon-card__btn" id="recipe-flow-addon-add" disabled>Hinzufügen</button>
        <div class="ownfood-addon-card__total">Total: <span id="recipe-flow-addon-total">–</span></div>
      </div>
    `;

    const mealsEl = recipeAddonCardEl.querySelector('#recipe-flow-addon-meals');
    const perDayEl = recipeAddonCardEl.querySelector('#recipe-flow-addon-price-per-day');
    const totalEl = recipeAddonCardEl.querySelector('#recipe-flow-addon-total');
    const addBtn = recipeAddonCardEl.querySelector('#recipe-flow-addon-add');

    if (!base || base.error === "both_allergic") {
      if (addBtn) addBtn.disabled = true;
      if (mealsEl) mealsEl.innerHTML = `– Mahlzeiten abgestimmt an <span data-ownfood-name>${displayName}</span>`;
      if (perDayEl) perDayEl.textContent = "–";
      if (totalEl) totalEl.textContent = "–";
      return;
    }

    const trialPlan = computeIntervalPlan(base, TRIAL_DAYS) || {};
    const trialFoods = cqGetFoodsFromPlan(trialPlan);
    const totalUnits = Math.max(0, Math.round(cqSumFoodMetric(trialFoods, "units", 0)));

    if (mealsEl) {
      const label = totalUnits === 1 ? "Mahlzeit" : "Mahlzeiten";
      mealsEl.innerHTML = `${totalUnits} ${label} abgestimmt an <span data-ownfood-name>${displayName}</span>`;
    }

    const pricing = getSubscriptionPricing({ base, trialPlan, trialDays: TRIAL_DAYS });
    if (!pricing?.pricesOk) {
      if (perDayEl) perDayEl.textContent = "–";
      if (totalEl) totalEl.textContent = "–";
      ensurePricingLoaded({ force: true }).then(() => {
        const stepEl = quizRoot.querySelector('.quiz-step[data-step="9"]');
        if (stepEl && !stepEl.hidden) updateSubscriptionOverview();
      }).catch(() => {});
    } else {
      if (perDayEl) perDayEl.textContent = formatEURFromCents(pricing.trialPerDayCents);
      if (totalEl) totalEl.textContent = formatEURFromCents(pricing.trialTotalCents);
    }

    function updateRecipeAddonButtonState() {
      const selected = addonHidden.value === "1";
      const hasItems = totalUnits > 0;
      if (!addBtn) return;
      if (!hasItems) {
        addBtn.disabled = true;
        addBtn.textContent = "Nicht verfügbar";
        addBtn.setAttribute("aria-pressed", "false");
        recipeAddonCardEl.classList.remove("is-selected");
        return;
      }
      addBtn.disabled = false;
      addBtn.textContent = selected ? "Hinzugefügt" : "Hinzufügen";
      addBtn.setAttribute("aria-pressed", selected ? "true" : "false");
      recipeAddonCardEl.classList.toggle("is-selected", selected);
    }

    updateRecipeAddonButtonState();

    if (addBtn && !addBtn.dataset.bound) {
      addBtn.dataset.bound = "1";
      addBtn.addEventListener("click", () => {
        if (totalUnits <= 0) {
          updateRecipeAddonButtonState();
          return;
        }
        addonHidden.value = addonHidden.value === "1" ? "0" : "1";
        updateRecipeAddonButtonState();
        try { scheduleSaveQuizState(); } catch (e) {}
      });
    }

    return;
  }

  // --------------------------------------------------
  // OWNFOOD: Optional-Card mit 7-Tage Menge + Einmalkauf Add-to-cart
  // --------------------------------------------------
  if (isOwnFood) {
    const mealsEl  = step9El.querySelector("#ownfood-addon-meals");
    const perDayEl = step9El.querySelector("#ownfood-addon-price-per-day");
    const totalEl  = step9El.querySelector("#ownfood-addon-total");
    const addBtn   = step9El.querySelector("#ownfood-addon-add");

    const displayName = answers?.name || "deine Katze";
    const TRIAL_DAYS = 7;

    const planAnswers = mapAllergiesForPlan(answers);
    const base        = computeBasePlan(planAnswers);

    if (!base || base.error === "both_allergic") {
      if (addBtn) addBtn.disabled = true;
      if (mealsEl) mealsEl.innerHTML = `– Mahlzeiten abgestimmt an <span data-ownfood-name>${displayName}</span>`;
      if (perDayEl) perDayEl.textContent = "–";
      if (totalEl) totalEl.textContent = "–";
      return;
    }

    const trialPlan = computeIntervalPlan(base, TRIAL_DAYS) || {};
    const trialFoods = cqGetFoodsFromPlan(trialPlan);
    const totalUnits = Math.max(0, Math.round(cqSumFoodMetric(trialFoods, "units", 0)));

    if (mealsEl) {
      const n = totalUnits;
      const label = (n === 1) ? "Mahlzeit" : "Mahlzeiten";
      mealsEl.innerHTML = `${n} ${label} abgestimmt an <span data-ownfood-name>${displayName}</span>`;
    }

    // Preise sicherstellen (falls PRICING noch nicht geladen)
    const pricing = getSubscriptionPricing({ base, trialPlan, trialDays: TRIAL_DAYS });

    if (!pricing?.pricesOk) {
      if (perDayEl) perDayEl.textContent = "–";
      if (totalEl) totalEl.textContent = "–";

      ensurePricingLoaded({ force: true })
        .then(() => {
          const stepEl = quizRoot.querySelector('.quiz-step[data-step="9"]');
          if (stepEl && !stepEl.hidden) updateSubscriptionOverview();
        })
        .catch(() => {});
    } else {
      // Hinweis: Trial-Preise sind bereits rabattiert (Save-the-Cat / trialBox)
      if (perDayEl) perDayEl.textContent = formatEURFromCents(pricing.trialPerDayCents);
      if (totalEl)  totalEl.textContent  = formatEURFromCents(pricing.trialTotalCents);
    }


// Optionales Add-on (Probiersbox) im Ownfood-Flow:
// WICHTIG: Der Klick auf "Hinzufügen" ändert nur den Auswahlzustand.
// In den Warenkorb gelegt wird erst beim großen CTA unten (Form-Submit).
let addonHidden = form.querySelector('input[name="ownfood_addon_selected"]');
if (!addonHidden) {
  addonHidden = document.createElement("input");
  addonHidden.type = "hidden";
  addonHidden.name = "ownfood_addon_selected";
  addonHidden.value = "0";
  form.appendChild(addonHidden);
}

const addonSelected = addonHidden.value === "1";

if (addBtn) {
  if (totalUnits <= 0) {
    addBtn.disabled = true;
    addBtn.textContent = "Nicht verfügbar";
    addBtn.setAttribute("aria-pressed", "false");
  } else {
    addBtn.disabled = false;
    addBtn.textContent = addonSelected ? "Hinzugefügt" : "Hinzufügen";
    addBtn.setAttribute("aria-pressed", addonSelected ? "true" : "false");
  }
}

if (ownRightEl) ownRightEl.classList.toggle("is-selected", addonSelected);

    // Click-Handler nur einmal binden
    if (addBtn && !addBtn.dataset.bound) {
      addBtn.dataset.bound = "1";

// Ownfood Addon: Klick auf "Hinzufügen" toggelt NUR den Zustand.
// In den Warenkorb gelegt wird erst beim großen CTA unten (Form-Submit).



function updateOwnfoodAddonButtonState() {
  const selected = addonHidden.value === "1";
  const hasItems = totalUnits > 0;

  if (!hasItems) {
    addBtn.disabled = true;
    addBtn.textContent = "Nicht verfügbar";
    addBtn.setAttribute("aria-pressed", "false");
    if (ownRightEl) ownRightEl.classList.remove("is-selected");
    return;
  }

  addBtn.disabled = false; // bewusst: toggle bleibt möglich
  addBtn.textContent = selected ? "Hinzugefügt" : "Hinzufügen";
  addBtn.setAttribute("aria-pressed", selected ? "true" : "false");
  if (ownRightEl) ownRightEl.classList.toggle("is-selected", selected);
}

// Initialer UI-State
updateOwnfoodAddonButtonState();

addBtn.addEventListener("click", () => {
  // Wenn aktuell keine Items berechnet werden, nichts toggeln
  const hasItemsNow = totalUnits > 0;
  if (!hasItemsNow) {
    updateOwnfoodAddonButtonState();
    return;
  }

  // Toggle Auswahl
  addonHidden.value = (addonHidden.value === "1") ? "0" : "1";

  // UI updaten
  updateOwnfoodAddonButtonState();

  // Optional: State speichern, falls du das nutzt
  try { scheduleSaveQuizState(); } catch (e) {}
});
}

    // Ownfood soll NICHT den normalen Abo-Rendering-Code weiter unten ausführen
    return;
  }

  // --------------------------------------------------
  // Bestehende Abo-Logik (Bild/Copy/Preise) – nur Fellinora Flow
  // --------------------------------------------------

  const imgEl      = quizRoot.querySelector("#subscription-box-image");
  const weeklyEl   = quizRoot.querySelector("#subscription-weekly");
  const portionsEl = quizRoot.querySelector("#subscription-portions");
  const dailyEl    = quizRoot.querySelector("#subscription-daily");

  // Preis-Targets (können fehlen -> dann einfach skip)
  const trialPerDayInlineEl = quizRoot.querySelector("#trial-price-per-day-inline");
  const trialTotalInlineEl  = quizRoot.querySelector("#trial-total-price-inline");
  const priceTrialPerDayEl  = quizRoot.querySelector("#price-trial-per-day");
  const priceMonthPerDayEl  = quizRoot.querySelector("#price-month-per-day");

  // Nur Bild ist wirklich kritisch – Texte können fehlen
  if (!imgEl) return;

  // Safari reload race
  try {
    imgEl.removeAttribute("srcset");
    imgEl.removeAttribute("sizes");
  } catch {}

  const planAnswers = mapAllergiesForPlan(answers);
  const base = computeBasePlan(planAnswers);

  if (!base || base.error) return;

  const baseFoods = cqGetFoodsFromBase(base);
  const dailyTotal = Math.round(cqSumFoodMetric(baseFoods, "gramsPerDay", 6));
  const TRIAL_DAYS = 7;
  const weeklyTotal = dailyTotal * TRIAL_DAYS;
  const displayName = answers.name || "deine Katze";

  const singleFood = baseFoods.length === 1 ? baseFoods[0] : null;
  const singleProductKey = cqGetKnownProductKey(singleFood);
  const srcSingle = singleProductKey === "huhn"
    ? (IMG_HUHN || IMG_HUHN_CARD)
    : (singleProductKey === "huhnForelle"
      ? (IMG_HUHN_FORELLE_CARD || IMG_HUHN_FORELLE || IMG_HUHN)
      : (IMG_HUHN_FORELLE_CARD || IMG_HUHN_FORELLE || IMG_HUHN));
  const srcMix = IMG_HUHN_FORELLE_CARD || IMG_HUHN_FORELLE || IMG_HUHN;

  function kickImageLoad() {
    try {
      imgEl.loading = "eager";
      imgEl.decoding = "async";
      imgEl.fetchPriority = "high";
      const s = imgEl.getAttribute("src");
      if (s) { imgEl.setAttribute("src", ""); imgEl.setAttribute("src", s); }
      if (imgEl.decode) imgEl.decode().catch(() => {});
    } catch {}
  }

  if (singleFood && srcSingle) {
    imgEl.src = srcSingle;
    imgEl.alt = `Deine ${singleFood.label}-Box`;
    kickImageLoad();
  } else if (srcMix) {
    imgEl.src = srcMix;
    imgEl.alt = `Deine gemischte Box`;
    kickImageLoad();
  }

  if (weeklyEl) {
    weeklyEl.textContent =
      `Wir liefern dir im 7-Tage-Testpaket insgesamt ca. ${weeklyTotal} g Futter.`;
  }

  if (portionsEl) {
    portionsEl.textContent =
      `Das entspricht ${TRIAL_DAYS} individuellen Tagesportionen à ${dailyTotal} g.`;
  }

  if (dailyEl) {
    dailyEl.textContent =
      `Eine Tagesportion für ${displayName} beträgt damit ca. ${dailyTotal} g – ` +
      `berechnet auf Basis deiner Quizdaten.`;
  }

  const trialPlan = computeIntervalPlan(base, TRIAL_DAYS);
  // --- Trial Bullet: "Futter für X Portionen" dynamisch setzen ---
const mealsBulletEl = quizRoot.querySelector("#trial-meals-bullet");
if (mealsBulletEl) {
  const totalUnits = Math.max(0, Math.round(cqSumFoodMetric(cqGetFoodsFromPlan(trialPlan), "units", 0)));
  if (totalUnits > 0) {
    const label = (totalUnits === 1) ? "hochwertige Mahlzeit" : "hochwertige Mahlzeiten";
    mealsBulletEl.textContent = `Versorgt deine Katze mit ${totalUnits} ${label}`;
  }
}
  const pricing = getSubscriptionPricing({ base, trialPlan, trialDays: TRIAL_DAYS });

  if (!pricing?.pricesOk) {
    if (trialPerDayInlineEl) trialPerDayInlineEl.textContent = "–";
    if (trialTotalInlineEl)  trialTotalInlineEl.textContent  = "–";
    if (priceTrialPerDayEl)  priceTrialPerDayEl.textContent  = "–";
    if (priceMonthPerDayEl)  priceMonthPerDayEl.textContent  = "–";

    ensurePricingLoaded()
      .then(() => {
        const stepEl = quizRoot.querySelector('.quiz-step[data-step="9"]');
        if (stepEl && !stepEl.hidden) updateSubscriptionOverview();
      })
      .catch(() => {});
    return;
  }

  if (trialPerDayInlineEl) trialPerDayInlineEl.textContent = formatEURFromCents(pricing.trialPerDayCents);
  if (trialTotalInlineEl)  trialTotalInlineEl.textContent  = formatEURFromCents(pricing.trialTotalCents);

  if (priceTrialPerDayEl)  priceTrialPerDayEl.textContent  = formatEURFromCents(pricing.trialPerDayCents);
  if (priceMonthPerDayEl)  priceMonthPerDayEl.textContent  = formatEURFromCents(pricing.monthPerDayCents);
}











// Plan-Buttons: followup_plan setzen + Preise neu rechnen
quizRoot.addEventListener("click", (e) => {
  const btn = e.target.closest?.(".plan-option[data-plan]");
  if (!btn) return;

  const mode = (btn.dataset.plan === "half") ? "half" : "full";
  const field = form.querySelector('[name="followup_plan"]');
  if (field) field.value = mode;

  // UI-State togglen
  quizRoot.querySelectorAll(".plan-option[data-plan]").forEach(b => {
    const on = (b.dataset.plan === mode);
    b.classList.toggle("is-selected", on);
    b.setAttribute("aria-pressed", on ? "true" : "false");
  });

  updateSubscriptionOverview();
});


// --------------------------------------------------
// STEP 9: Folgeabo-Plan (100% vs 50/50) + Own-Food Modal
// --------------------------------------------------

const FOLLOWUP_PLAN_FIELD = "followup_plan";
const OWNFOOD_FIELDS = {
  protein:  "ownfood_protein",
  fat:      "ownfood_fat",
  ash:      "ownfood_ash",
  fiber:    "ownfood_fiber",
  moisture: "ownfood_moisture",
  me:       "ownfood_me",
  grams:    "ownfood_grams_per_day"
};

function qField(name) {
  return form.querySelector(`[name="${name}"]`);
}

function normalizeNum(v) {
  if (v == null) return NaN;
  const s = String(v).trim().replace(",", ".");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
}

function getFollowupPlanMode() {
  const v = (qField(FOLLOWUP_PLAN_FIELD)?.value || "").trim();
  return (v === "half") ? "half" : "full";
}

function setFollowupPlanMode(mode) {
  const el = qField(FOLLOWUP_PLAN_FIELD);
  if (!el) return;
  el.value = (mode === "half") ? "half" : "full";
  syncFollowupPlanUI();
  try { scheduleSaveQuizState(); } catch {}
}

function hasValidOwnFoodHidden() {
  const a = readOwnFoodFromHidden();
  return a.ok;
}

function syncFollowupPlanUI() {
  const mode = getFollowupPlanMode();

  const btns = Array.from(quizRoot.querySelectorAll(".plan-option[data-plan]"));
  btns.forEach(btn => {
    const isOn = btn.dataset.plan === mode;
    btn.classList.toggle("is-selected", isOn);
    btn.setAttribute("aria-pressed", isOn ? "true" : "false");
  });

  // Status-Text für 50/50
  const status = quizRoot.querySelector('.plan-option__status[data-status="half"]');
  if (status) {
    status.textContent = hasValidOwnFoodHidden()
      ? "Analytische Werte gespeichert"
      : "Analytische Werte erforderlich";
  }
}

// ---------- Own-Food Modal (ähnlich Ingredients Modal) ----------
let ownFoodOverlay = null;
let ownFoodLastFocus = null;

function ensureOwnFoodModal() {
  if (ownFoodOverlay) return ownFoodOverlay;

  const overlay = document.createElement("div");
  overlay.className = "ingredients-modal-overlay ownfood-modal-overlay";

  overlay.innerHTML = `
    <div class="ingredients-modal ownfood-modal" role="dialog" aria-modal="true" aria-label="Analytische Werte deines Futters">
      <button type="button" class="ingredients-modal-close ownfood-modal-close" aria-label="Schließen">×</button>

      <div class="ownfood-modal-inner">
        <h3 class="ownfood-modal-title">Analytische Werte deines Futters</h3>
        <p class="ownfood-modal-lead">
          Damit wir bei 50/50 die richtige Menge Fellinora und Fremdfutter berechnen können,
          brauchen wir die Werte deines Futters (in %).
        </p>

        <div class="ownfood-modal-grid">
          <div class="ownfood-field">
            <div class="ownfood-label">Protein (%)</div>
            <input class="ownfood-input" name="__ownfood_protein" type="number" min="0" max="100" step="0.1" inputmode="decimal" placeholder="z. B. 10.5">
            <div class="ownfood-hint">Angabe in %</div>
          </div>

          <div class="ownfood-field">
            <div class="ownfood-label">Fett (%)</div>
            <input class="ownfood-input" name="__ownfood_fat" type="number" min="0" max="100" step="0.1" inputmode="decimal" placeholder="z. B. 5.0">
            <div class="ownfood-hint">Angabe in %</div>
          </div>

          <div class="ownfood-field">
            <div class="ownfood-label">Rohasche (%)</div>
            <input class="ownfood-input" name="__ownfood_ash" type="number" min="0" max="100" step="0.1" inputmode="decimal" placeholder="z. B. 2.2">
            <div class="ownfood-hint">Angabe in %</div>
          </div>

          <div class="ownfood-field">
            <div class="ownfood-label">Rohfaser (%)</div>
            <input class="ownfood-input" name="__ownfood_fiber" type="number" min="0" max="100" step="0.1" inputmode="decimal" placeholder="z. B. 0.3">
            <div class="ownfood-hint">Angabe in %</div>
          </div>

          <div class="ownfood-field">
            <div class="ownfood-label">Feuchtigkeit (%)</div>
            <input class="ownfood-input" name="__ownfood_moisture" type="number" min="0" max="100" step="0.1" inputmode="decimal" placeholder="z. B. 79.0">
            <div class="ownfood-hint">Angabe in %</div>
          </div>
        </div>

        <div class="ownfood-error" hidden></div>

        <div class="ownfood-actions">
          <button type="button" class="ownfood-btn ownfood-btn--ghost" data-ownfood-action="cancel">Abbrechen</button>
          <button type="button" class="ownfood-btn ownfood-btn--primary" data-ownfood-action="save">Übernehmen</button>
        </div>

        <div class="ownfood-footnote">
          Hinweis: Bitte Werte als Prozentangaben eintragen. Die Kohlenhydrate werden intern überschlägig berechnet.
        </div>
      </div>
    </div>
  `;

  // Close handlers
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeOwnFoodModal();
  });

  overlay.querySelector(".ownfood-modal-close")?.addEventListener("click", closeOwnFoodModal);

  overlay.querySelector('[data-ownfood-action="cancel"]')?.addEventListener("click", () => {
    closeOwnFoodModal();
  });

  overlay.querySelector('[data-ownfood-action="save"]')?.addEventListener("click", () => {
    const res = readOwnFoodFromModal();
    if (!res.ok) {
      showOwnFoodError(res.error || "Bitte prüfe deine Eingaben.");
      return;
    }

    // ME berechnen + in Hidden schreiben
    const me = calcME(res.data);
    const meSafe = (Number.isFinite(me) && me > 0) ? me : NaN;
    if (!Number.isFinite(meSafe)) {
      showOwnFoodError("Aus den Werten konnte keine gültige Energie berechnet werden.");
      return;
    }

    writeOwnFoodToHidden(res.data, meSafe);

    // Jetzt darf 50/50 wirklich aktiv werden
    setFollowupPlanMode("half");
    closeOwnFoodModal();
  });

  // ESC
  document.addEventListener("keydown", (e) => {
    if (!ownFoodOverlay) return;
    if (!ownFoodOverlay.classList.contains("is-open")) return;
    if (e.key === "Escape") closeOwnFoodModal();
  });

  document.body.appendChild(overlay);
  ownFoodOverlay = overlay;
  return overlay;
}

function openOwnFoodModal(optionalMsg) {
  const overlay = ensureOwnFoodModal();
  ownFoodLastFocus = document.activeElement;

  // Prefill aus Hidden (falls vorhanden)
  const existing = readOwnFoodFromHidden();
  const setVal = (name, v) => {
    const el = overlay.querySelector(`input[name="${name}"]`);
    if (el) el.value = (v != null && v !== "") ? String(v).replace(",", ".") : "";
  };

  if (existing.ok) {
    setVal("__ownfood_protein",  existing.data.protein);
    setVal("__ownfood_fat",      existing.data.fat);
    setVal("__ownfood_ash",      existing.data.ash);
    setVal("__ownfood_fiber",    existing.data.fiber);
    setVal("__ownfood_moisture", existing.data.moisture);
  } else {
    setVal("__ownfood_protein",  "");
    setVal("__ownfood_fat",      "");
    setVal("__ownfood_ash",      "");
    setVal("__ownfood_fiber",    "");
    setVal("__ownfood_moisture", "");
  }

  hideOwnFoodError();
  if (optionalMsg) showOwnFoodError(optionalMsg);

  overlay.classList.add("is-open");
  document.documentElement.classList.add("modal-open");
  document.body.classList.add("modal-open");

  // Fokus
  const first = overlay.querySelector('input[name="__ownfood_protein"]');
  first?.focus?.();
}

function closeOwnFoodModal() {
  if (!ownFoodOverlay) return;
  ownFoodOverlay.classList.remove("is-open");
  document.documentElement.classList.remove("modal-open");
  document.body.classList.remove("modal-open");

  try { ownFoodLastFocus?.focus?.(); } catch {}
}

function initOwnfoodInfo() {
  // Deprecated: Ownfood-Info-Buttons nutzen das gleiche Popover-Verhalten wie Tierschutz
  // (siehe form.addEventListener('click'...) Handler).
  return;
}

function showOwnFoodError(msg) {
  const box = ownFoodOverlay?.querySelector(".ownfood-error");
  if (!box) return;
  box.textContent = msg;
  box.hidden = false;
}

function hideOwnFoodError() {
  const box = ownFoodOverlay?.querySelector(".ownfood-error");
  if (!box) return;
  box.hidden = true;
  box.textContent = "";
}

function validateOwnFoodData(d) {
  const req = ["protein", "fat", "ash", "fiber", "moisture"];
  for (const k of req) {
    const v = d[k];
    if (!Number.isFinite(v)) return { ok: false, error: "Bitte alle Felder ausfüllen (nur Zahlen)." };
    if (v < 0 || v > 100) return { ok: false, error: "Werte müssen zwischen 0 und 100 liegen." };
  }

  const sum = d.protein + d.fat + d.ash + d.fiber + d.moisture;
  if (sum > 100) return { ok: false, error: "Die Summe der Werte darf 100% nicht überschreiten." };

  return { ok: true };
}

function readOwnFoodFromHidden() {
  const d = {
    protein:  normalizeNum(qField(OWNFOOD_FIELDS.protein)?.value),
    fat:      normalizeNum(qField(OWNFOOD_FIELDS.fat)?.value),
    ash:      normalizeNum(qField(OWNFOOD_FIELDS.ash)?.value),
    fiber:    normalizeNum(qField(OWNFOOD_FIELDS.fiber)?.value),
    moisture: normalizeNum(qField(OWNFOOD_FIELDS.moisture)?.value),
  };
  const v = validateOwnFoodData(d);
  if (!v.ok) return { ok: false, error: v.error };
  return { ok: true, data: d };
}

function readOwnFoodFromModal() {
  const overlay = ensureOwnFoodModal();
  const d = {
    protein:  normalizeNum(overlay.querySelector('input[name="__ownfood_protein"]')?.value),
    fat:      normalizeNum(overlay.querySelector('input[name="__ownfood_fat"]')?.value),
    ash:      normalizeNum(overlay.querySelector('input[name="__ownfood_ash"]')?.value),
    fiber:    normalizeNum(overlay.querySelector('input[name="__ownfood_fiber"]')?.value),
    moisture: normalizeNum(overlay.querySelector('input[name="__ownfood_moisture"]')?.value),
  };
  const v = validateOwnFoodData(d);
  if (!v.ok) return { ok: false, error: v.error };
  return { ok: true, data: d };
}

function writeOwnFoodToHidden(d, meKcalPerG) {
  qField(OWNFOOD_FIELDS.protein).value  = String(d.protein);
  qField(OWNFOOD_FIELDS.fat).value      = String(d.fat);
  qField(OWNFOOD_FIELDS.ash).value      = String(d.ash);
  qField(OWNFOOD_FIELDS.fiber).value    = String(d.fiber);
  qField(OWNFOOD_FIELDS.moisture).value = String(d.moisture);
  qField(OWNFOOD_FIELDS.me).value       = String(meKcalPerG);

  try { scheduleSaveQuizState(); } catch {}
  syncFollowupPlanUI();
}

function sanitizeOpenTextValue(value, opts = {}) {
  const maxLen = Number(opts.maxLen || 0);
  const keepNewlines = opts.keepNewlines !== false;

  let out = String(value ?? "");
  out = out.replace(/\u0000/g, "");
  out = out.replace(/<\s*\/?\s*script\b[^>]*>/gi, " ");
  out = out.replace(/<[^>]*>/g, " ");
  out = out.replace(/javascript\s*:/gi, "");
  out = out.replace(/\bon\w+\s*=/gi, "");

  if (keepNewlines) {
    out = out.replace(/\r\n?/g, "\n");
    out = out
      .split("\n")
      .map((line) => line.replace(/[ \t]{2,}/g, " ").trim())
      .join("\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  } else {
    out = out.replace(/\s+/g, " ").trim();
  }

  if (maxLen > 0) out = out.slice(0, maxLen);
  return out;
}

const OWNFOOD_FLOW = {
  initialized: false,
  stepEl: null,
  sequence: ["mode"],
  cursor: 0,
};

function getOwnfoodFlowStep() {
  return form.querySelector('.quiz-step[data-step="7.5"]');
}

function ownfoodFlowMode(stepEl = getOwnfoodFlowStep()) {
  return String(
    stepEl?.querySelector('input[name="ownfood_feed_mode_step"]:checked')?.value || ""
  )
    .trim()
    .toLowerCase();
}

function ownfoodFlowKinds(mode = ownfoodFlowMode()) {
  if (mode === "nass") return ["wet"];
  if (mode === "trocken") return ["dry"];
  if (mode === "beides") return ["wet", "dry"];
  return [];
}

function ownfoodFlowLabel(kind) {
  return kind === "dry" ? "Trockenfutter" : "Nassfutter";
}

function ownfoodFlowSequence(mode = ownfoodFlowMode()) {
  const keys = ["mode"];
  ownfoodFlowKinds(mode).forEach((kind) => {
    keys.push(`${kind}-composition`);
  });
  keys.push("snacks");
  return keys;
}

function ownfoodFlowReadAnalytics(kind) {
  const prefix = kind === "dry" ? "ownfood_dry" : "ownfood_wet";
  const d = {
    protein: normalizeNum(form.querySelector(`input[name="${prefix}_protein_step"]`)?.value),
    fat: normalizeNum(form.querySelector(`input[name="${prefix}_fat_step"]`)?.value),
    ash: normalizeNum(form.querySelector(`input[name="${prefix}_ash_step"]`)?.value),
    fiber: normalizeNum(form.querySelector(`input[name="${prefix}_fiber_step"]`)?.value),
    moisture: normalizeNum(form.querySelector(`input[name="${prefix}_moisture_step"]`)?.value),
  };
  const v = validateOwnFoodData(d);
  if (!v.ok) {
    return {
      ok: false,
      error: `${ownfoodFlowLabel(kind)}: ${v.error}`,
    };
  }
  return { ok: true, data: d };
}

function ownfoodFlowReadAmount(kind) {
  const name = kind === "dry" ? "ownfood_dry_grams_step" : "ownfood_wet_grams_step";
  const grams = normalizeNum(form.querySelector(`input[name="${name}"]`)?.value);
  if (!(Number.isFinite(grams) && grams > 0)) {
    return {
      ok: false,
      error: `${ownfoodFlowLabel(kind)}: Bitte gib eine gültige Futtermenge in g/Tag ein.`,
    };
  }
  return { ok: true, grams };
}

function ownfoodFlowSyncLegacyAnalyticsFields(d) {
  const set = (name, value) => {
    const el = form.querySelector(`[name="${name}"]`);
    if (el) el.value = String(value);
  };
  set("ownfood_protein_step", d.protein);
  set("ownfood_fat_step", d.fat);
  set("ownfood_ash_step", d.ash);
  set("ownfood_fiber_step", d.fiber);
  set("ownfood_moisture_step", d.moisture);
}

function ownfoodFlowReadAggregatedAnalytics() {
  const hasModeField = !!form.querySelector('input[name="ownfood_feed_mode_step"]');
  if (!hasModeField) return { ok: false, legacy: true };

  const mode = ownfoodFlowMode();
  if (!mode) {
    return {
      ok: false,
      error: "Bitte wähle aus, ob du Nassfutter, Trockenfutter oder beides fütterst.",
    };
  }

  if (mode === "nass") {
    const wet = ownfoodFlowReadAnalytics("wet");
    if (!wet.ok) return wet;
    ownfoodFlowSyncLegacyAnalyticsFields(wet.data);
    return { ok: true, data: wet.data };
  }

  if (mode === "trocken") {
    const dry = ownfoodFlowReadAnalytics("dry");
    if (!dry.ok) return dry;
    ownfoodFlowSyncLegacyAnalyticsFields(dry.data);
    return { ok: true, data: dry.data };
  }

  if (mode === "beides") {
    const wet = ownfoodFlowReadAnalytics("wet");
    if (!wet.ok) return wet;
    const dry = ownfoodFlowReadAnalytics("dry");
    if (!dry.ok) return dry;

    const wetAmount = ownfoodFlowReadAmount("wet");
    if (!wetAmount.ok) return wetAmount;
    const dryAmount = ownfoodFlowReadAmount("dry");
    if (!dryAmount.ok) return dryAmount;

    const total = wetAmount.grams + dryAmount.grams;
    if (!(Number.isFinite(total) && total > 0)) {
      return {
        ok: false,
        error: "Bitte gib für Nass- und Trockenfutter gültige Tagesmengen an.",
      };
    }

    const weighted = {
      protein: ((wet.data.protein * wetAmount.grams) + (dry.data.protein * dryAmount.grams)) / total,
      fat: ((wet.data.fat * wetAmount.grams) + (dry.data.fat * dryAmount.grams)) / total,
      ash: ((wet.data.ash * wetAmount.grams) + (dry.data.ash * dryAmount.grams)) / total,
      fiber: ((wet.data.fiber * wetAmount.grams) + (dry.data.fiber * dryAmount.grams)) / total,
      moisture: ((wet.data.moisture * wetAmount.grams) + (dry.data.moisture * dryAmount.grams)) / total,
    };

    const validWeighted = validateOwnFoodData(weighted);
    if (!validWeighted.ok) {
      return { ok: false, error: `Kombinierte Werte (Nass + Trocken): ${validWeighted.error}` };
    }

    ownfoodFlowSyncLegacyAnalyticsFields(weighted);
    return { ok: true, data: weighted };
  }

  return { ok: false, error: "Unbekannter Futtermodus im Ownfood-Flow." };
}

function ownfoodFlowValidateCard(key, stepEl = getOwnfoodFlowStep()) {
  if (!stepEl) return { ok: true };

  if (key === "mode") {
    if (!ownfoodFlowMode(stepEl)) {
      return {
        ok: false,
        error: "Bitte wähle aus, ob du Nassfutter, Trockenfutter oder beides fütterst.",
      };
    }
    return { ok: true };
  }

  if (key.endsWith("-composition")) {
    const kind = key.startsWith("dry-") ? "dry" : "wet";
    const composition = sanitizeOpenTextValue(stepEl.querySelector(`[name="ownfood_${kind}_composition_step"]`)?.value || "", { maxLen: 5000 });
    const additives = sanitizeOpenTextValue(stepEl.querySelector(`[name="ownfood_${kind}_additives_step"]`)?.value || "", { maxLen: 5000 });
    if (!composition) return { ok: false, error: `${ownfoodFlowLabel(kind)}: Bitte gib die Zusammensetzung ein.` };
    if (!additives) return { ok: false, error: `${ownfoodFlowLabel(kind)}: Bitte gib die Zusatzstoffe ein.` };
    const analytics = ownfoodFlowReadAnalytics(kind);
    if (!analytics.ok) return analytics;
    return ownfoodFlowReadAmount(kind);
  }

  if (key === "snacks") {
    const has = String(stepEl.querySelector('input[name="ownfood_snacks_has_step"]:checked')?.value || "");
    if (!has) {
      return { ok: false, error: "Bitte gib an, ob deine Katze zusätzlich Snacks bekommt." };
    }
    if (has !== "ja") return { ok: true };

    const snackType = sanitizeOpenTextValue(stepEl.querySelector('[name="ownfood_snack_type_step"]')?.value || "", { maxLen: 500 });
    const snackAmount = normalizeNum(stepEl.querySelector('[name="ownfood_snack_amount_step"]')?.value);

    if (!snackType) {
      return { ok: false, error: "Bitte trage die Sorte der Snacks ein." };
    }
    if (!(Number.isFinite(snackAmount) && snackAmount >= 0)) {
      return { ok: false, error: "Bitte trage eine gültige Snack-Menge in g/Tag ein." };
    }
    return { ok: true };
  }

  return { ok: true };
}

function ownfoodFlowApplySnacksState(stepEl = getOwnfoodFlowStep()) {
  if (!stepEl) return;
  const has = String(stepEl.querySelector('input[name="ownfood_snacks_has_step"]:checked')?.value || "");
  const details = stepEl.querySelector('[data-ownfood-snacks-details]');
  const detailFields = Array.from(stepEl.querySelectorAll('[data-ownfood-snack-detail="1"]'));
  const snacksCard = details?.closest?.('[data-ownfood-card-key="snacks"]');
  const snacksCardActive = !!snacksCard && !snacksCard.hidden;
  if (details) details.hidden = has !== "ja";
  detailFields.forEach((field, idx) => {
    const shouldEnable = has === "ja";
    field.disabled = !shouldEnable;
    const required = snacksCardActive && shouldEnable && idx < 2;
    field.required = required;
    if (snacksCardActive && has !== "ja") field.value = "";
  });
}

function ownfoodFlowSetFollowupState(followup, shouldShow, cardActive) {
  if (!followup) return;
  followup.hidden = !shouldShow;

  Array.from(followup.querySelectorAll("input, textarea, select")).forEach((field) => {
    if (field.type === "hidden") return;
    field.disabled = false;
    field.required = !!cardActive && !!shouldShow && field.dataset.ownfoodRequired === "1";
  });
}

function ownfoodFlowSyncFollowups(stepEl = getOwnfoodFlowStep()) {
  if (!stepEl) return;

  const activeKey = OWNFOOD_FLOW.sequence[OWNFOOD_FLOW.cursor] || "mode";

  ["wet", "dry"].forEach((kind) => {
    const compositionCardActive = activeKey === `${kind}-composition`;
    const composition = sanitizeOpenTextValue(
      stepEl.querySelector(`[name="ownfood_${kind}_composition_step"]`)?.value || "",
      { maxLen: 5000, keepNewlines: true }
    );
    ownfoodFlowSetFollowupState(
      stepEl.querySelector(`[data-ownfood-followup="${kind}-additives"]`),
      composition.length > 0,
      compositionCardActive
    );

    const additives = sanitizeOpenTextValue(
      stepEl.querySelector(`[name="ownfood_${kind}_additives_step"]`)?.value || "",
      { maxLen: 5000, keepNewlines: true }
    );
    const showAnalytics = composition.length > 0 && additives.length > 0;
    ownfoodFlowSetFollowupState(
      stepEl.querySelector(`[data-ownfood-followup="${kind}-analytics"]`),
      showAnalytics,
      compositionCardActive
    );

    ownfoodFlowSetFollowupState(
      stepEl.querySelector(`[data-ownfood-followup="${kind}-amount"]`),
      showAnalytics && ownfoodFlowReadAnalytics(kind).ok,
      compositionCardActive
    );
  });

  ownfoodFlowApplySnacksState(stepEl);

  const hasSnacks = String(stepEl.querySelector('input[name="ownfood_snacks_has_step"]:checked')?.value || "");
  const snackType = sanitizeOpenTextValue(stepEl.querySelector('[name="ownfood_snack_type_step"]')?.value || "", { maxLen: 500 });
  const snackAmount = normalizeNum(stepEl.querySelector('[name="ownfood_snack_amount_step"]')?.value);
  const snacksComplete = !!hasSnacks && (
    hasSnacks !== "ja" || (snackType.length > 0 && Number.isFinite(snackAmount) && snackAmount >= 0)
  );

  ownfoodFlowSetFollowupState(
    stepEl.querySelector('[data-ownfood-followup="notes"]'),
    snacksComplete,
    activeKey === "snacks"
  );
}

function ownfoodFlowToggleCard(card, isActive, stepEl = getOwnfoodFlowStep()) {
  card.hidden = !isActive;

  const isSnacksCard = card.dataset.ownfoodCardKey === "snacks";
  const snackHas = String(stepEl?.querySelector('input[name="ownfood_snacks_has_step"]:checked')?.value || "");

  Array.from(card.querySelectorAll("input, textarea, select")).forEach((field) => {
    if (field.type === "hidden") return;

    if (field.closest("[data-ownfood-followup]")) {
      field.required = false;
      return;
    }

    const isSnackDetail = field.dataset.ownfoodSnackDetail === "1";
    const shouldEnable = !isSnackDetail || snackHas === "ja";
    const shouldRequire = isActive && shouldEnable && field.dataset.ownfoodRequired === "1";

    field.disabled = !shouldEnable;
    field.required = !!shouldRequire;
  });

  if (isSnacksCard) ownfoodFlowApplySnacksState(stepEl);
}

function ownfoodFlowRender() {
  const stepEl = getOwnfoodFlowStep();
  if (!stepEl) return;

  const mode = ownfoodFlowMode(stepEl);
  const sequence = ownfoodFlowSequence(mode);
  OWNFOOD_FLOW.sequence = sequence;

  if (!Number.isFinite(OWNFOOD_FLOW.cursor)) OWNFOOD_FLOW.cursor = 0;
  if (mode === "" && OWNFOOD_FLOW.cursor > 0) OWNFOOD_FLOW.cursor = 0;
  OWNFOOD_FLOW.cursor = Math.max(0, Math.min(sequence.length - 1, OWNFOOD_FLOW.cursor));

  const activeKey = sequence[OWNFOOD_FLOW.cursor] || "mode";
  const cards = Array.from(stepEl.querySelectorAll("[data-ownfood-card-key]"));
  cards.forEach((card) => {
    ownfoodFlowToggleCard(card, card.dataset.ownfoodCardKey === activeKey, stepEl);
  });

  ownfoodFlowSyncFollowups(stepEl);

  try { syncNextButtonState(); } catch {}
}

function ownfoodFlowAdvanceInternal() {
  const stepEl = getOwnfoodFlowStep();
  if (!stepEl) return { handled: false };

  const sequence = OWNFOOD_FLOW.sequence.length
    ? OWNFOOD_FLOW.sequence
    : ownfoodFlowSequence(ownfoodFlowMode(stepEl));
  const key = sequence[OWNFOOD_FLOW.cursor] || "mode";

  const valid = ownfoodFlowValidateCard(key, stepEl);
  if (!valid.ok) {
    return { handled: true, stay: true, error: valid.error || "Bitte prüfe deine Angaben." };
  }

  if (OWNFOOD_FLOW.cursor < sequence.length - 1) {
    OWNFOOD_FLOW.cursor += 1;
    ownfoodFlowRender();
    try { scheduleSaveQuizState(); } catch {}
    return { handled: true, stay: true };
  }

  return { handled: true, stay: false };
}

function ownfoodFlowRetreatInternal() {
  const stepEl = getOwnfoodFlowStep();
  if (!stepEl) return false;
  if (OWNFOOD_FLOW.cursor <= 0) return false;
  OWNFOOD_FLOW.cursor -= 1;
  ownfoodFlowRender();
  try { scheduleSaveQuizState(); } catch {}
  return true;
}

function ownfoodFlowAnalyticsModuleHtml(kind, fallbackStepEl = getOwnfoodFlowStep()) {
  const source =
    form.querySelector(".cookplan-question--q3") ||
    form.querySelector(".barfplan-question--q3") ||
    fallbackStepEl;
  const prefix = kind === "dry" ? "ownfood_dry" : "ownfood_wet";
  const placeholders = kind === "dry"
    ? { protein: "32", fat: "18", ash: "7", fiber: "3", moisture: "8" }
    : { protein: "10", fat: "5", ash: "2", fiber: "1", moisture: "79" };
  const label = ownfoodFlowLabel(kind);
  const catSubjectHtml = '<span class="js-name-text" data-default="deine Katze" data-template="%NAME%">deine Katze</span>';
  const module = document.createElement("div");
  module.className = "ownfood-flow-analytics-module";

  const title = source?.querySelector(".ownfood-analytics-title")?.cloneNode(true) || document.createElement("h3");
  title.className = "ownfood-analytics-title";
  title.textContent = `Wie lauten die analytischen Bestandteile deines ${label}s?`;
  module.appendChild(title);

  const help = document.createElement("p");
  help.className = "ownfood-flow-help";
  help.innerHTML = `Diese Angaben benötigen wir, um die passende Futtermenge für ${catSubjectHtml} zu berechnen.`;
  module.appendChild(help);

  const top = source?.querySelector(".ownfood-analytics-top")?.cloneNode(true);
  if (top) module.appendChild(top);

  const hint = source?.querySelector(".ownfood-analytics-hintline")?.cloneNode(true);
  if (hint) module.appendChild(hint);

  const grid = source?.querySelector(".ownfood-analytics-grid")?.cloneNode(true);
  if (!grid) return module.outerHTML;

  grid.setAttribute("aria-label", `Analytische Bestandteile ${ownfoodFlowLabel(kind)} Eingabe`);
  Array.from(grid.querySelectorAll(".ownfood-analytics-info")).forEach((info) => {
    info.innerHTML = escapeHtml(info.textContent || "")
      .replace(/deine Katze/g, catSubjectHtml)
      .replace(/deiner Katze/g, catSubjectHtml);
  });

  ["protein", "fat", "ash", "fiber", "moisture"].forEach((key) => {
    const input = grid.querySelector(`input[name$="_${key}_step"]`);
    if (!input) return;
    input.name = `${prefix}_${key}_step`;
    input.placeholder = `z. B. ${placeholders[key]}`;
    input.value = "";
    input.removeAttribute("required");
    input.removeAttribute("disabled");
    input.disabled = false;
    input.dataset.ownfoodRequired = "1";
  });

  module.appendChild(grid);
  return module.outerHTML;
}

function initOwnfoodDetailedFlowStep() {
  const stepEl = getOwnfoodFlowStep();
  if (!stepEl) return;

  const nav = stepEl.querySelector(".quiz-nav");
  if (!nav) return;

  if (!stepEl.dataset.ownfoodFlowBuilt) {
    const compositionImg = String(IMG_OWNFOOD_COMPOSITION_EXAMPLE || "").trim();
    const compositionImageHtml = compositionImg
      ? `<img src="${compositionImg}" alt="Beispiel für Etikett mit Zusammensetzung" loading="lazy" decoding="async">`
      : `<div class="ownfood-flow-composition-placeholder">Platzhalterbild: Etikett mit Zusammensetzung</div>`;
    const wetAnalyticsHtml = ownfoodFlowAnalyticsModuleHtml("wet", stepEl);
    const dryAnalyticsHtml = ownfoodFlowAnalyticsModuleHtml("dry", stepEl);
    const catSubjectHtml = '<span class="js-name-text" data-default="deine Katze" data-template="%NAME%">deine Katze</span>';
    const catOwnerHtml = '<span class="js-name-text" data-default="deiner Katze" data-template="von %NAME%">deiner Katze</span>';

    Array.from(stepEl.children).forEach((child) => {
      if (child !== nav) stepEl.removeChild(child);
    });

    nav.insertAdjacentHTML("beforebegin", `
      <div class="ownfood-flow" data-ownfood-flow-root>
        <section class="ownfood-flow-card" data-ownfood-card-key="mode">
          <h3 class="ownfood-flow-title">Fütterst du sowohl Nass- als auch Trockenfutter?</h3>
          <div class="ownfood-flow-choice-grid ownfood-flow-choice-grid--mode">
            <label class="ownfood-flow-choice">
              <input type="radio" name="ownfood_feed_mode_step" value="nass" data-ownfood-required="1">
              <span>Nur Nassfutter</span>
            </label>
            <label class="ownfood-flow-choice">
              <input type="radio" name="ownfood_feed_mode_step" value="trocken">
              <span>Nur Trockenfutter</span>
            </label>
            <label class="ownfood-flow-choice">
              <input type="radio" name="ownfood_feed_mode_step" value="beides">
              <span>Beides</span>
            </label>
          </div>
        </section>

        <section class="ownfood-flow-card" data-ownfood-card-key="wet-composition" hidden>
          <h3 class="ownfood-flow-title">Was ist die Zusammensetzung des Nassfutters ${catOwnerHtml}?</h3>
          <div class="ownfood-flow-composition-image">${compositionImageHtml}</div>
          <p class="ownfood-flow-help">Bitte gib die vollständige Zusammensetzung mit Prozentangaben an (z. B. Huhn 50 %, Brühe 10 %).</p>
          <textarea name="ownfood_wet_composition_step" class="ownfood-flow-textarea" rows="4" placeholder="z. B. Huhn 50 %, Brühe 10 %, ..." data-ownfood-required="1" data-ownfood-sanitize="1"></textarea>
          <p class="ownfood-flow-info">Info: Die Zusammensetzung deines Futters findest du auf dem Etikett unter dem Oberpunkt „Zusammensetzung“.</p>
          <div class="ownfood-flow-followup" data-ownfood-followup="wet-additives" hidden>
            <h4 class="ownfood-flow-subtitle">Welche Zusatzstoffe sind auf dem Nassfutter ${catOwnerHtml} deklariert?</h4>
            <p class="ownfood-flow-help">Bitte gib alle deklarierten Zusatzstoffe an, z. B. Kupfer, Zink, Vitamin A oder Taurin.</p>
            <textarea name="ownfood_wet_additives_step" class="ownfood-flow-textarea" rows="4" placeholder="z. B. Kupfer, Zink, Vitamin A, Taurin" data-ownfood-required="1" data-ownfood-sanitize="1"></textarea>
            <p class="ownfood-flow-info">Info: Die Zusatzstoffe deines Futters findest du auf dem Etikett unter dem Punkt „Zusatzstoffe“.</p>
          </div>
          <div class="ownfood-flow-followup" data-ownfood-followup="wet-analytics" hidden>
            ${wetAnalyticsHtml}
          </div>
          <div class="ownfood-flow-followup" data-ownfood-followup="wet-amount" hidden>
            <h4 class="ownfood-flow-subtitle">Wie viel Futter bekommt ${catSubjectHtml} pro Tag?</h4>
            <p class="ownfood-flow-help">Die richtige Futtermenge ist entscheidend, damit ${catSubjectHtml} gesund und optimal versorgt bleibt.</p>
            <label class="ownfood-flow-inline-field">
              <span>Menge (g)</span>
              <input type="number" name="ownfood_wet_grams_step" min="0" step="0.1" inputmode="decimal" placeholder="z. B. 180" data-ownfood-required="1">
            </label>
          </div>
        </section>

        <section class="ownfood-flow-card" data-ownfood-card-key="dry-composition" hidden>
          <h3 class="ownfood-flow-title">Was ist die Zusammensetzung des Trockenfutters ${catOwnerHtml}?</h3>
          <div class="ownfood-flow-composition-image">${compositionImageHtml}</div>
          <p class="ownfood-flow-help">Bitte gib die vollständige Zusammensetzung mit Prozentangaben an (z. B. Huhn 50 %, Brühe 10 %).</p>
          <textarea name="ownfood_dry_composition_step" class="ownfood-flow-textarea" rows="4" placeholder="z. B. Huhn 50 %, Kartoffel 20 %, ..." data-ownfood-required="1" data-ownfood-sanitize="1"></textarea>
          <p class="ownfood-flow-info">Info: Die Zusammensetzung deines Futters findest du auf dem Etikett unter dem Oberpunkt „Zusammensetzung“.</p>
          <div class="ownfood-flow-followup" data-ownfood-followup="dry-additives" hidden>
            <h4 class="ownfood-flow-subtitle">Welche Zusatzstoffe sind auf dem Trockenfutter ${catOwnerHtml} deklariert?</h4>
            <div class="ownfood-flow-composition-image">
              <div class="ownfood-flow-composition-placeholder">Platzhalterbild: Etikett mit Zusatzstoffen</div>
            </div>
            <p class="ownfood-flow-help">Bitte gib alle deklarierten Zusatzstoffe an, z. B. Kupfer, Zink, Vitamin A oder Taurin.</p>
            <textarea name="ownfood_dry_additives_step" class="ownfood-flow-textarea" rows="4" placeholder="z. B. Kupfer, Zink, Vitamin A, Taurin" data-ownfood-required="1" data-ownfood-sanitize="1"></textarea>
            <p class="ownfood-flow-info">Info: Die Zusatzstoffe deines Futters findest du auf dem Etikett unter dem Punkt „Zusatzstoffe“.</p>
          </div>
          <div class="ownfood-flow-followup" data-ownfood-followup="dry-analytics" hidden>
            ${dryAnalyticsHtml}
          </div>
          <div class="ownfood-flow-followup" data-ownfood-followup="dry-amount" hidden>
            <h4 class="ownfood-flow-subtitle">Wie viel Futter bekommt ${catSubjectHtml} pro Tag?</h4>
            <p class="ownfood-flow-help">Die richtige Futtermenge ist entscheidend, damit ${catSubjectHtml} gesund und optimal versorgt bleibt.</p>
            <label class="ownfood-flow-inline-field">
              <span>Menge (g)</span>
              <input type="number" name="ownfood_dry_grams_step" min="0" step="0.1" inputmode="decimal" placeholder="z. B. 60" data-ownfood-required="1">
            </label>
          </div>
        </section>

        <section class="ownfood-flow-card" data-ownfood-card-key="snacks" hidden>
          <h3 class="ownfood-flow-title">Bekommt ${catSubjectHtml} zusätzlich Snacks?</h3>
          <p class="ownfood-flow-help">Bitte gib die Sorte und die tägliche Menge an.</p>
          <div class="ownfood-flow-choice-grid ownfood-flow-choice-grid--snacks">
            <label class="ownfood-flow-choice">
              <input type="radio" name="ownfood_snacks_has_step" value="nein" data-ownfood-required="1">
              <span>Nein</span>
            </label>
            <label class="ownfood-flow-choice">
              <input type="radio" name="ownfood_snacks_has_step" value="ja">
              <span>Ja</span>
            </label>
          </div>
          <div class="ownfood-flow-snacks-fields" data-ownfood-snacks-details hidden>
            <label>
              <span>Sorte</span>
              <input type="text" name="ownfood_snack_type_step" placeholder="z. B. Hühnerherzen" data-ownfood-snack-detail="1" data-ownfood-sanitize="1">
            </label>
            <label>
              <span>Menge (g/Tag)</span>
              <input type="number" name="ownfood_snack_amount_step" min="0" step="0.1" inputmode="decimal" placeholder="z. B. 10" data-ownfood-snack-detail="1">
            </label>
          </div>
          <p class="ownfood-flow-info">Beispiel: Hühnerherzen – 10 g</p>
          <div class="ownfood-flow-followup" data-ownfood-followup="notes" hidden>
            <h4 class="ownfood-flow-subtitle">Gibt es noch etwas, das wir bei der Bewertung der Ernährung ${catOwnerHtml} berücksichtigen sollen?</h4>
            <textarea name="ownfood_notes_step" class="ownfood-flow-textarea" rows="5" placeholder="Optional: zusätzliche Hinweise" data-ownfood-sanitize="1"></textarea>
          </div>
        </section>

        <input type="hidden" name="ownfood_protein_step" value="">
        <input type="hidden" name="ownfood_fat_step" value="">
        <input type="hidden" name="ownfood_ash_step" value="">
        <input type="hidden" name="ownfood_fiber_step" value="">
        <input type="hidden" name="ownfood_moisture_step" value="">
      </div>
    `);
    try { updateNameTexts(); } catch {}

    stepEl.dataset.ownfoodFlowBuilt = "1";
  }

  if (!stepEl.__ownfoodFlowBound) {
    stepEl.addEventListener("input", (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) return;

      if (target.dataset.ownfoodSanitize === "1") {
        const keepNewlines = target.tagName === "TEXTAREA";
        const cleaned = sanitizeOpenTextValue(target.value, { maxLen: keepNewlines ? 5000 : 600, keepNewlines });
        if (cleaned !== target.value) target.value = cleaned;
      }

      if (target.closest("[data-ownfood-flow-root]")) {
        ownfoodFlowRender();
      } else {
        try { syncNextButtonState(); } catch {}
      }
    });

    stepEl.addEventListener("change", (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) return;

      if (target.name === "ownfood_feed_mode_step") {
        OWNFOOD_FLOW.cursor = 0;
        ownfoodFlowRender();
        try { scheduleSaveQuizState(); } catch {}
        return;
      }

      if (target.name === "ownfood_snacks_has_step") {
        ownfoodFlowRender();
        try { scheduleSaveQuizState(); } catch {}
        return;
      }

      if (target.closest("[data-ownfood-flow-root]")) {
        ownfoodFlowRender();
      } else {
        try { syncNextButtonState(); } catch {}
      }
    });

    stepEl.__ownfoodFlowBound = true;
  }

  OWNFOOD_FLOW.initialized = true;
  OWNFOOD_FLOW.stepEl = stepEl;

  const legacyProtein = normalizeNum(form.querySelector('[name="ownfood_protein_step"]')?.value);
  if (!ownfoodFlowMode(stepEl) && Number.isFinite(legacyProtein)) {
    const defaultMode = stepEl.querySelector('input[name="ownfood_feed_mode_step"][value="nass"]');
    if (defaultMode) defaultMode.checked = true;
  }

  if (stepEl.dataset.ownfoodStartAtMode === "1") {
    OWNFOOD_FLOW.cursor = 0;
    delete stepEl.dataset.ownfoodStartAtMode;
  }

  ownfoodFlowRender();
}

// ---------- Click Handling (Buttons) ----------
quizRoot.addEventListener("click", (e) => {
  const btn = e.target?.closest?.(".plan-option[data-plan]");
  if (!btn) return;

  const plan = btn.dataset.plan;
  if (plan === "full") {
    setFollowupPlanMode("full");
    return;
  }

  // 50/50: Modal öffnen, Auswahl erst nach Save aktivieren
  openOwnFoodModal();
});

// Initial Sync (auch nach Restore)
syncFollowupPlanUI();
setTimeout(syncFollowupPlanUI, 0);
initOwnfoodDetailedFlowStep();

  
  // --------------------------------------------------
  // Submit in den Warenkorb / Checkout
  // --------------------------------------------------

  function handleQuizSubmit() {
    // Kein requestSubmit(): versteckte required Felder aus anderen Flows können sonst
    // die native Browser-Validierung triggern und das Submit scheinbar "verschlucken".
    const submitEvent = new Event("submit", { cancelable: true, bubbles: true });
    form.dispatchEvent(submitEvent);
  }

  // --------------------------------------------------
  // Social Partner Cards: Selection-State & Custom-Feld robust syncen
  // (hilft gegen "verbuggte" Boxen nach HTML/CSS-Resets)
  // --------------------------------------------------
  (function initSocialPartnerCards() {
    const radios = Array.from(form.querySelectorAll('input[name="social_partner"]'));
    if (!radios.length) return;

    const customField =
      form.querySelector('textarea[name="social_custom"]') ||
      form.querySelector('input[name="social_custom"]');

    function syncSocialUI() {
      const checked = radios.find(r => r.checked);

      radios.forEach(r => {
        const card = r.closest(".social-pill, .social-card, label");
        if (!card) return;
        card.classList.toggle("is-selected", r.checked);
      });

      // Custom Feld nur zeigen, wenn "custom" aktiv
      if (customField) {
        const wrap =
          customField.closest(".social-custom-wrap") ||
          customField.closest(".social-custom") ||
          customField.parentElement;

        const shouldShow = !!(checked && checked.value === "custom");

        if (wrap) wrap.hidden = !shouldShow;

        if (!shouldShow) {
          customField.value = "";
        }
      }
    }

    radios.forEach(r => r.addEventListener("change", syncSocialUI));
    syncSocialUI();
  })();

function initFamiliarityInfobox(stepEl, flow) {
  const cfg = flow === "cook"
    ? { name: "cook_familiarity", boxSel: ".cookplan-familiarity-info", textSel: ".flow-familiarity-info-text", noteSel: ".cookplan-choice-note" }
    : { name: "barf_familiarity", boxSel: ".barfplan-familiarity-info", textSel: ".flow-familiarity-info-text", noteSel: ".barfplan-choice-note" };

  const inputs = stepEl.querySelectorAll(`input[name="${cfg.name}"]`);
  const box = stepEl.querySelector(cfg.boxSel);
  const textEl = box?.querySelector(cfg.textSel);

  if (!inputs.length || !box || !textEl) return;

  const update = () => {
    const checked = stepEl.querySelector(`input[name="${cfg.name}"]:checked`);
    if (!checked) {
      box.hidden = true;
      textEl.textContent = "";
      return;
    }

    const label = checked.closest("label");
    const note = label?.querySelector(cfg.noteSel);
    const txt = (note?.textContent || "").trim();

    textEl.textContent = txt;
    box.hidden = !txt;
  };

  inputs.forEach(i => i.addEventListener("change", update));
  update(); // falls beim Reload schon gewählt ist
}

// --------------------------------------------------
// Formular-Klick-Handling (Navigation & Info-Buttons)
// --------------------------------------------------

document.addEventListener("click", async (e) => {
  const clickScope = e.target && e.target.closest
    ? e.target.closest("#cat-quiz-form, #cat-quiz-step9-nav-portal")
    : null;
  if (!clickScope) return;

  const nextBtn = e.target.closest(".btn-next");
  const backBtn = e.target.closest(".btn-back");


/// NEXT
if (nextBtn) {
  e.preventDefault();

  if (navInFlight) return;
  navInFlight = true;

  // Step 6.5 CTA: setzt food_choice Radio bevor validiert wird
  try {
    const forced = nextBtn?.dataset?.foodChoice;
    const stepNoBeforeForce = Number(steps?.[currentStep]?.dataset?.step);
    if (stepNoBeforeForce === 6.5 && forced === "other") {
      OWNFOOD_FLOW.cursor = 0;
      const ownfoodStep = getOwnfoodFlowStep();
      if (ownfoodStep) ownfoodStep.dataset.ownfoodStartAtMode = "1";
    }
    if (forced) {
      const r = form.querySelector(`input[name="food_choice"][value="${forced}"]`);
      if (r) {
        r.checked = true;
        r.dispatchEvent(new Event("change", { bubbles: true }));
        if (typeof scheduleSaveQuizState === "function") scheduleSaveQuizState();
      }
    }
  } catch {}

  try {
    const stepNo = Number(steps?.[currentStep]?.dataset?.step);

    // Step 1 (Alter): Grenzen prüfen und ggf. Fehlermeldung zeigen
    if (stepNo === 1 && !validateAge(true)) {
      return;
    }

    // Step 2 (Gewicht): Maximalgewicht prüfen und Fehlermeldung anzeigen
    if (stepNo === 2 && !validateWeight(true)) {
      return;
    }

    if (stepNo === 7.5) {
      const ownfoodAdvance = ownfoodFlowAdvanceInternal();
      if (ownfoodAdvance.handled && ownfoodAdvance.stay) {
        if (ownfoodAdvance.error) alert(ownfoodAdvance.error);
        return;
      }
    }

    if (!validateStep(currentStep)) {
      alert("Bitte fülle die Pflichtfelder aus.");
      return;
    }


    await submitMarketingOptInIfNeeded();


    const findStepIndex = (n) => steps.findIndex(s => Number(s?.dataset?.step) === n);

    const getFoodChoice = () =>
      (form.querySelector('input[name="food_choice"]:checked')?.value || "").toString().trim().toLowerCase();

    function readOwnFoodFromAnalyticsStep() {
      const flowRes = ownfoodFlowReadAggregatedAnalytics();
      if (!flowRes.legacy) return flowRes;

      const d = {
        protein:  normalizeNum(form.querySelector('input[name="ownfood_protein_step"]')?.value),
        fat:      normalizeNum(form.querySelector('input[name="ownfood_fat_step"]')?.value),
        ash:      normalizeNum(form.querySelector('input[name="ownfood_ash_step"]')?.value),
        fiber:    normalizeNum(form.querySelector('input[name="ownfood_fiber_step"]')?.value),
        moisture: normalizeNum(form.querySelector('input[name="ownfood_moisture_step"]')?.value),
      };
      const v = validateOwnFoodData(d);
      if (!v.ok) return { ok: false, error: v.error };
      return { ok: true, data: d };
    }

    function commitOwnFoodFromAnalyticsStep() {
      const res = readOwnFoodFromAnalyticsStep();
      if (!res.ok) return res;

      const me = calcME(res.data);
      if (!(Number.isFinite(me) && me > 0)) {
        return { ok: false, error: "Aus den Werten konnte keine gültige Energie berechnet werden." };
      }

      // in Hidden ownfood_* (Step 9) schreiben
      writeOwnFoodToHidden(res.data, me);

      // Gramm/Tag (für 100% Fremdfutter-Konzept) berechnen und in Hidden setzen
      try {
        const answers = getAnswers();
        const planAnswers = mapAllergiesForPlan(answers);
        const base = computeBasePlan(planAnswers);
        const kcalDay = (base && typeof base.kcal === "number") ? base.kcal : 0;

        const gramsPerDay = kcalDay / me;
        if (Number.isFinite(gramsPerDay) && gramsPerDay > 0) {
          qField(OWNFOOD_FIELDS.grams).value = String(gramsPerDay);
        }
        qField(OWNFOOD_FIELDS.me).value = String(me);
      } catch {}

      try { scheduleSaveQuizState(); } catch {}
      return { ok: true };
    }


    // Kochplan/BARF: Analytische Bestandteile (Nassfutter) aus Step lesen + ME berechnen
    function readWetFromAnalyticsStep(prefix) {
      const d = {
        protein:  normalizeNum(form.querySelector(`input[name="${prefix}_protein_step"]`)?.value),
        fat:      normalizeNum(form.querySelector(`input[name="${prefix}_fat_step"]`)?.value),
        ash:      normalizeNum(form.querySelector(`input[name="${prefix}_ash_step"]`)?.value),
        fiber:    normalizeNum(form.querySelector(`input[name="${prefix}_fiber_step"]`)?.value),
        moisture: normalizeNum(form.querySelector(`input[name="${prefix}_moisture_step"]`)?.value),
      };
      const v = validateOwnFoodData(d);
      if (!v.ok) return { ok: false, error: v.error };
      return { ok: true, data: d };
    }

    function commitWetFromAnalyticsStep(prefix, meFieldName) {
      const res = readWetFromAnalyticsStep(prefix);
      if (!res.ok) return res;

      const me = calcME(res.data);
      if (!(Number.isFinite(me) && me > 0)) {
        return { ok: false, error: "Aus den Werten konnte keine gültige Energie berechnet werden." };
      }

      const meEl = form.querySelector(`input[name="${meFieldName}"]`);
      if (meEl) meEl.value = String(me);

      try { scheduleSaveQuizState(); } catch {}
      return { ok: true, me };
    }

    let nextIndex = currentStep + 1;

    // Step 6.5: Flow branching nach Fütterungsart
    // - fellinora -> Step 7
    // - other     -> Step 7.5 (Ownfood-Fragen)
    // - cook      -> Step 6.75 (Kochplan Fragen)
    // - barf      -> Step 6.85 (BARF Fragen)
    if (stepNo === 6.5) {
      const choice = getFoodChoice();

      if (choice === "other") {
        const idx75 = findStepIndex(7.5);
        if (idx75 >= 0) {
          nextIndex = idx75;
          OWNFOOD_FLOW.cursor = 0;
          const ownfoodStep = getOwnfoodFlowStep();
          if (ownfoodStep) ownfoodStep.dataset.ownfoodStartAtMode = "1";
        }
      } else if (choice === "cook") {
        const idx675 = findStepIndex(6.75);
        if (idx675 >= 0) nextIndex = idx675;
      } else if (choice === "barf") {
        const idx685 = findStepIndex(6.85);
        if (idx685 >= 0) nextIndex = idx685;
      } else {
        const idx7 = findStepIndex(7);
        if (idx7 >= 0) nextIndex = idx7;
      }
    }

    // Step 7.5: speichern und dann immer zu Step 7 (Opt-in)
if (stepNo === 7.5) {
  const saved = commitOwnFoodFromAnalyticsStep();
  if (!saved.ok) {
    alert(saved.error || "Bitte prüfe deine Eingaben.");
    return;
  }

  const idx7 = findStepIndex(7);
  if (idx7 >= 0) nextIndex = idx7;
}

// Step 6.75: Kochplan – wenn Nassfutter integriert wird (Tage < 7), ME berechnen und speichern
if (stepNo === 6.75) {
  const days = Number(form.querySelector('input[name="cook_days"]:checked')?.value || 0);
  if (Number.isFinite(days) && days > 0 && days < 7) {
    const saved = commitWetFromAnalyticsStep("cookwet", "cookwet_me");
    if (!saved.ok) {
      alert(saved.error || "Bitte prüfe deine Eingaben.");
      return;
    }
  }
  const idx7 = findStepIndex(7);
  if (idx7 >= 0) nextIndex = idx7;
}

// Step 6.85: BARF – wenn Nassfutter integriert wird (Tage < 7), ME berechnen und speichern
if (stepNo === 6.85) {
  const days = Number(form.querySelector('input[name="barf_days"]:checked')?.value || 0);
  if (Number.isFinite(days) && days > 0 && days < 7) {
    const saved = commitWetFromAnalyticsStep("barfwet", "barfwet_me");
    if (!saved.ok) {
      alert(saved.error || "Bitte prüfe deine Eingaben.");
      return;
    }
  }
  const idx7 = findStepIndex(7);
  if (idx7 >= 0) nextIndex = idx7;
}


    // Step 7: Nach dem E-Mail-Gate zu den passenden Ergebnis-/Abo-Steps.
    // Falls spezielle Rezept-Steps (8.75/8.85) nicht im DOM existieren,
    // fallen wir sauber auf den normalen Ergebnis-Step 8 zurück.
    if (stepNo === 7) {
      const choice = getFoodChoice();
      const idx8 = findStepIndex(8);

      if (choice === "cook") {
        const idxCookRes = findStepIndex(8.75);
        if (idxCookRes >= 0) nextIndex = idxCookRes;
        else if (idx8 >= 0) nextIndex = idx8;
      }

      if (choice === "barf") {
        const idxBarfRes = findStepIndex(8.85);
        if (idxBarfRes >= 0) nextIndex = idxBarfRes;
        else if (idx8 >= 0) nextIndex = idx8;
      }
    }

    if (stepNo === 9) {
      const choice = getFoodChoice();

      // Ownfood- und Rezeptflows sollen von ihrer Abo-Seite direkt in den Checkout.
      if (choice === "other" || choice === "cook" || choice === "barf") {
        handleQuizSubmit();
        return;
      }
    }

    if (nextIndex < steps.length) {
      showStep(nextIndex);
    } else {
      handleQuizSubmit();
    }
  } catch (err) {
    return;
  } finally {
    navInFlight = false;
  }
  return;
}



  // BACK
  if (backBtn) {
    e.preventDefault();
    if (navInFlight) return;

    const stepNo = Number(steps?.[currentStep]?.dataset?.step);
    const findStepIndex = (n) => steps.findIndex(s => Number(s?.dataset?.step) === n);
// Step 1 hat Subfragen (currentStep1Index). Back soll erst innerhalb Step 1 zurück,
// und nur wenn wir am Anfang sind, auf Step 0 springen.
// Step 1: Wenn Step 1 bereits "fertig" ist (letzte Subfrage erreicht),
// dann soll Back NICHT innerhalb von Step 1 zurückspringen,
// sondern zur vorherigen Seite (Step 0) gehen.
// Nur solange Step 1 noch nicht fertig ist, gehen wir innerhalb von Step 1 zurück.
if (stepNo === 1) {
  const lastIdx = Math.max(0, step1Questions.length - 1);
  const idx0 = findStepIndex(0);

  const step1IsComplete = currentStep1Index >= lastIdx;

  if (step1IsComplete) {
    if (idx0 >= 0) { showStep(idx0); return; }
  }

  if (currentStep1Index > 0) {
    currentStep1Index = Math.max(0, currentStep1Index - 1);
    updateStep1Questions();
    try { scheduleSaveQuizState(); } catch {}
    return;
  }

  // Step 1 Anfang -> zurück zu Step 0 (falls vorhanden)
  if (idx0 >= 0) { showStep(idx0); return; }
}


    const choice = (form.querySelector('input[name="food_choice"]:checked')?.value || "").toString().trim().toLowerCase();

    // 8 -> 7
    if (stepNo === 8) {
      const idx7 = findStepIndex(7);
      if (idx7 >= 0) { showStep(idx7); return; }
    }

    // 7 -> Back-Ziel abhängig von food_choice
    // - other -> 7.5
    // - cook  -> 6.75
    // - barf  -> 6.85
    // - sonst -> 6.5
    if (stepNo === 7) {
      if (choice === "other") {
        const idx75 = findStepIndex(7.5);
        if (idx75 >= 0) {
          const sequence = ownfoodFlowSequence(ownfoodFlowMode());
          OWNFOOD_FLOW.cursor = Math.max(0, sequence.length - 1);
          showStep(idx75);
          return;
        }
      }

      if (choice === "cook") {
        const idx675 = findStepIndex(6.75);
        if (idx675 >= 0) { showStep(idx675); return; }
      }

      if (choice === "barf") {
        const idx685 = findStepIndex(6.85);
        if (idx685 >= 0) { showStep(idx685); return; }
      }

      const idx65 = findStepIndex(6.5);
      if (idx65 >= 0) { showStep(idx65); return; }
    }

    // 7.5 -> 6.5
    if (stepNo === 7.5) {
      if (ownfoodFlowRetreatInternal()) return;
      const idx65 = findStepIndex(6.5);
      if (idx65 >= 0) { showStep(idx65); return; }
    }

    // 6.85 -> 6.5 (BARF zurück zur Fütterungs-Auswahl)
    if (stepNo === 6.85) {
      const idx65 = findStepIndex(6.5);
      if (idx65 >= 0) { showStep(idx65); return; }
    }

    // 6.75 -> 6.5 (Kochplan zurück zur Fütterungs-Auswahl)
    if (stepNo === 6.75) {
      const idx65 = findStepIndex(6.5);
      if (idx65 >= 0) { showStep(idx65); return; }
    }

    showStep(Math.max(0, currentStep - 1));
    return;
  }

// Gesundheits-Info
  const infoBtn = e.target.closest(".health-info-btn");
  if (infoBtn) {
    e.preventDefault();
    e.stopPropagation();

    if (!healthInfoPanel || !healthInfoHeading || !healthInfoText) return;

    const key   = infoBtn.dataset.infoKey || "";
    const title =
      infoBtn.dataset.infoTitle ||
      infoBtn.closest(".health-pill-inner")?.querySelector(".health-title")?.textContent ||
      "";
    const text  = infoBtn.dataset.infoText || "";

    if (currentHealthInfoKey === key && !healthInfoPanel.hidden) {
      healthInfoPanel.hidden = true;
      currentHealthInfoKey = null;
    } else {
      healthInfoHeading.textContent = title;
      healthInfoText.textContent    = text;

      const rect = infoBtn.getBoundingClientRect();

      if (healthInfoPanel.parentElement !== document.body) {
        document.body.appendChild(healthInfoPanel);
      }

      healthInfoPanel.hidden = false;

      const panelWidth = healthInfoPanel.offsetWidth || 260;
      const half       = panelWidth / 2;
      const padding    = 12;

      let left = rect.left + rect.width / 2;
      left = Math.max(left, half + padding);
      left = Math.min(left, window.innerWidth - half - padding);

      healthInfoPanel.style.position = "fixed";
      healthInfoPanel.style.top      = `${rect.bottom + 8}px`;
      healthInfoPanel.style.left     = `${left}px`;

      currentHealthInfoKey = key;
    }
    return;
  }

  // Tierschutz-Info
  const socialBtn = e.target.closest(".social-info-btn");
  if (socialBtn) {
    e.preventDefault();
    e.stopPropagation();

    if (!socialInfoPanel || !socialInfoHeading || !socialInfoText) return;

    const key   = socialBtn.dataset.infoKey || "";
    const title =
      socialBtn.dataset.infoTitle ||
      socialBtn.closest(".social-pill-inner")?.querySelector(".social-title")?.textContent ||
      "";
    const text  = socialBtn.dataset.infoText || "";

    if (currentSocialInfoKey === key && !socialInfoPanel.hidden) {
      socialInfoPanel.hidden = true;
      currentSocialInfoKey = null;
    } else {
      socialInfoHeading.textContent = title;
      socialInfoText.textContent    = text;

      const rect = socialBtn.getBoundingClientRect();

      if (socialInfoPanel.parentElement !== document.body) {
        document.body.appendChild(socialInfoPanel);
      }

      socialInfoPanel.hidden = false;

      const panelWidth = socialInfoPanel.offsetWidth || 260;
      const half       = panelWidth / 2;
      const padding    = 12;

      let left = rect.left + rect.width / 2;
      left = Math.max(left, half + padding);
      left = Math.min(left, window.innerWidth - half - padding);

      socialInfoPanel.style.position = "fixed";
      socialInfoPanel.style.top      = `${rect.bottom + 8}px`;
      socialInfoPanel.style.left     = `${left}px`;

      currentSocialInfoKey = key;
    }
    return;
  }

  // OWNFOOD-Info (wie Tierschutz)
  const ownBtn = e.target.closest(".ownfood-info-btn");
  if (ownBtn) {
    e.preventDefault();
    e.stopPropagation();

    // Wichtig: nach Back/Forward/Reload kann es mehrere Panels geben (weil eins in <body> portaled wurde).
    // Wir benutzen IMMER das Panel aus dem aktuellen Ownfood-Block, wenn vorhanden.
    const ownWrap = document.getElementById("ownfood-eval-block");
    const ownPanel =
      ownWrap?.querySelector(".ownfood-info-panel") ||
      document.querySelector(".ownfood-info-panel");

    const ownHeading = ownPanel?.querySelector(".ownfood-info-heading");
    const ownText    = ownPanel?.querySelector(".ownfood-info-text");
    if (!ownPanel || !ownHeading || !ownText) return;

    const key   = ownBtn.dataset.infoKey || ownBtn.dataset.infoTitle || "";
    const title = ownBtn.dataset.infoTitle || "";
    const text  = ownBtn.dataset.infoText  || "";

    // Toggle: gleicher Button -> schließen
    if (currentOwnfoodInfoKey === key && !ownPanel.hidden) {
      document.querySelectorAll(".ownfood-info-panel").forEach((p) => (p.hidden = true));
      currentOwnfoodInfoKey = null;
      return;
    }

    // Beim Öffnen immer alle anderen Panels schließen/entfernen (sonst sammeln sich "klebende" Duplikate)
    document.querySelectorAll(".ownfood-info-panel").forEach((p) => {
      if (p !== ownPanel) p.remove();
    });

    // Optional UX: auch andere Popovers schließen
    try { hideAllPopovers(); } catch {}

    ownHeading.textContent = title;
    ownText.textContent    = text;


    // Panel in <body> portalen, damit die fixed-Position korrekt zur Viewport-Box berechnet wird
    if (ownPanel.parentElement !== document.body) {
      document.body.appendChild(ownPanel);
    }

    // Sichtbar machen, aber bis zur finalen Position unsichtbar halten (verhindert "falsche Stelle" beim ersten Render)
    ownPanel.hidden = false;
    ownPanel.style.position = "fixed";
    ownPanel.style.visibility = "hidden";

    // Key früh setzen, damit rAF-Positionierung nur für das aktuell geöffnete Panel greift
    currentOwnfoodInfoKey = key;

    const placeOwnfoodPopover = () => {
      if (ownPanel.hidden || currentOwnfoodInfoKey !== key) return;
      const rect = ownBtn.getBoundingClientRect();

      const panelWidth = ownPanel.offsetWidth || 260;
      const half       = panelWidth / 2;
      const padding    = 12;

      let left = rect.left + rect.width / 2;
      left = Math.max(left, half + padding);
      left = Math.min(left, window.innerWidth - half - padding);

      ownPanel.style.top  = `${rect.bottom + 8}px`;
      ownPanel.style.left = `${left}px`;
      ownPanel.style.visibility = "visible";
    };

    // 2x rAF: sorgt dafür, dass Layout/Fonts/Images fertig gerechnet sind, bevor wir positionieren
    try {
      requestAnimationFrame(() => requestAnimationFrame(placeOwnfoodPopover));
    } catch {
      setTimeout(placeOwnfoodPopover, 0);
    }

    return;
  }
});
(function initNextButtonDisableWatcher() {
  let raf = 0;

  const tick = () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      raf = 0;
      try { syncNextButtonState(); } catch {}
    });
  };

  form.addEventListener("input", tick);
  form.addEventListener("change", tick);
})();


  // NEW: Update 6-step progress bars on any input changes
  form.addEventListener("input",  () => updateProgressBars());
  form.addEventListener("change", () => updateProgressBars());


// --------------------------------------------------
// NEW: stabile Matching-ID pro Checkout (für Appstle Webhook/API)
//  - nicht Email-basiert
//  - pro Submit neu
// --------------------------------------------------
function makeCheckoutMatchId() {
  try {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
  } catch {}

  // Fallback: ausreichend eindeutig für unseren Zweck
  return "cq-" + Date.now() + "-" + Math.random().toString(16).slice(2);
}

// --------------------------------------------------
// Shared Add-to-Cart helper (Fellinora + Ownfood)
// --------------------------------------------------
async function addItemsToCart(items, opts = {}) {
  const {
    redirectToCart = false,
    debugTag = "Cart add",
    verifyViaCartJs = true,
  } = opts;

  if (!Array.isArray(items) || items.length === 0) {
    throw new Error(`[${debugTag}] No items to add`);
  }

  // Aggregate requested quantities by variant id
  const needById = new Map();
  for (const it of items) {
    const id = Number(it?.id);
    const q  = Number(it?.quantity) || 0;
    if (!id || q <= 0) continue;
    needById.set(id, (needById.get(id) || 0) + q);
  }

  const addRes = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    credentials: "same-origin",
    body: JSON.stringify({ items }),
  });

  const addText = await addRes.text().catch(() => "");

  if (addRes.ok) {
    if (redirectToCart) window.location.assign("/cart");
    return { ok: true, status: addRes.status, verified: false, raw: addText };
  }

  console.error(`[${debugTag}] non-2xx:`, addRes.status, addText.slice(0, 800));

  // Fallback verification: check /cart.js to see if items were still added
  if (verifyViaCartJs && needById.size > 0) {
    try {
      const cartRes = await fetch("/cart.js", {
        method: "GET",
        headers: { "Accept": "application/json" },
        credentials: "same-origin",
      });

      if (cartRes.ok) {
        const cart = await cartRes.json().catch(() => null);
        const lineItems = Array.isArray(cart?.items) ? cart.items : [];

        let allPresent = true;
        for (const [id, needQty] of needById.entries()) {
          const li = lineItems.find(x =>
            Number(x?.id) === id || Number(x?.variant_id) === id
          );
          const haveQty = li ? (Number(li.quantity) || 0) : 0;
          if (haveQty < needQty) { allPresent = false; break; }
        }

        if (allPresent) {
          if (redirectToCart) window.location.assign("/cart");
          return { ok: true, status: addRes.status, verified: true, raw: addText };
        }
      }
    } catch (e) {
      console.warn(`[${debugTag}] /cart.js verification failed`, e);
    }
  }

  const err = new Error(`[${debugTag}] Failed to add to cart (${addRes.status})`);
  err.status = addRes.status;
  err.responseText = addText;
  throw err;
}

// --------------------------------------------------
// NEW: Checkout E-Mail Prefill (Checkout-Feld vorausfüllen)
//  - nutzt /checkout?checkout[email]=... mit location.replace()
//  - Hintergrund: Shopify ignoriert POST-Prefill i.d.R. ohne Checkout-Token
// --------------------------------------------------
function cqGetEmailForCheckout() {
  const el = form.querySelector('input[name="email"]');
  return (el && typeof el.value === "string") ? el.value.trim() : "";
}

function cqLooksLikeEmail(v) {
  if (!v) return false;
  // bewusst simpel & robust (HTML input type=email validiert zusätzlich)
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
}

function cqGoToCheckoutWithEmailPrefill(email) {
  const em = String(email || "").trim();

  // Shopify akzeptiert das Prefill zuverlässig über den Query-Parameter.
  // POST /checkout mit checkout[email] wird im Checkout-Flow i.d.R. ignoriert (ohne Shopify-Token).
  // Wir nutzen daher GET + location.replace(), damit die E-Mail nicht in deiner Browser-History "zurück" bleibt.
  if (cqLooksLikeEmail(em)) {
    const qp = encodeURIComponent(em);
    window.location.replace(`/checkout?checkout[email]=${qp}`);
    return;
  }

  window.location.assign("/checkout");
}
// --------------------------------------------------
// Formular-Submit (Warenkorb-Logik)
// --------------------------------------------------
  form.addEventListener("submit", e => {
    e.preventDefault();

    // Falls jemand mit Enter submitet, bevor alle Age-Felder konsistent sind
    if (!validateAge(true)) {
      showStep(0);
      return;
    }

    if (!validateStep(currentStep)) {
      alert("Bitte fülle alle Pflichtfelder aus.");
      return;
    }

    const answers     = getAnswers();
    const planAnswers = mapAllergiesForPlan(answers);
    const base        = computeBasePlan(planAnswers);

    // Wenn Huhn-Allergie: aktuell keine Empfehlung möglich
    if (!base || base.error === "both_allergic") {
      if (base && base.error === "both_allergic") {
        alert("Für diese Allergie haben wir momentan noch kein passendes Futter im Sortiment.");
      } else {
        alert("Es konnte kein Futterpaket berechnet werden. Bitte überprüfe deine Angaben.");
      }
      return;
    }

    // --------------------------------------------------
    // Appstle/Shopify Trial-Flow (Single Selling Plan):
    // - Checkout nutzt IMMER den 30-Tage Selling Plan
    // - Menge im Checkout entspricht aber nur dem 7-Tage Testpaket
    // - Backend (Webhook + Appstle API) stellt nach Kauf:
    //   1) next_billing_date -> +7 Tage
    //   2) Line Items -> Menge für 30 Tage (aus den Properties)
    // --------------------------------------------------
    const TRIAL_DAYS  = 7;
    const TARGET_DAYS = 30;

// Trial bleibt IMMER 7 Tage auf Basis der Quiz-Empfehlung (100% Fellinora)
const trialPlan = computeIntervalPlan(base, TRIAL_DAYS);

// Target (30 Tage) hängt von der Folgeabo-Auswahl ab
const followupPlanMode = getFollowupPlanMode();
let baseForTarget = base;

let ownFoodAnalytics = null;
let ownFoodMe = null;
let ownFoodGramsPerDay = null;

if (followupPlanMode === "half") {
  const res = readOwnFoodFromHidden();
  if (!res.ok) {
    openOwnFoodModal(res.error || "Bitte trage zuerst die analytischen Werte deines Futters ein.");
    return;
  }

  ownFoodAnalytics = res.data;
  ownFoodMe = calcME(ownFoodAnalytics);

  if (!(Number.isFinite(ownFoodMe) && ownFoodMe > 0)) {
    openOwnFoodModal("Aus den Werten konnte keine gültige Energie berechnet werden.");
    return;
  }

  const kcalDay = Number(base?.kcal || 0) || 0;
  ownFoodGramsPerDay = (kcalDay * 0.5) / ownFoodMe;

  const halfFoods = cqGetFoodsFromBase(base).map((food) => {
    const meKcalPerG = Number(food?.meKcalPerG || 0);
    const share = Number(food?.share || 0);
    const gramsPerDay = (Number.isFinite(meKcalPerG) && meKcalPerG > 0)
      ? (kcalDay * 0.5 * share) / meKcalPerG
      : 0;
    return {
      ...food,
      gramsPerDay,
    };
  });

  baseForTarget = {
    ...base,
    foods: halfFoods,
    dailyGramsTotal: cqSumFoodMetric(halfFoods, "gramsPerDay", 6),
  };

  qField(OWNFOOD_FIELDS.grams).value = String(ownFoodGramsPerDay);
  qField(OWNFOOD_FIELDS.me).value = String(ownFoodMe);
}

const targetPlan = computeIntervalPlan(baseForTarget, TARGET_DAYS);
const trialFoods = cqBuildFoodsPayload(base, trialPlan);
const targetFoods = (followupPlanMode === "half")
  ? cqBuildFixedIntervalFoodsFromDaily(baseForTarget, TARGET_DAYS)
  : cqBuildFoodsPayload(baseForTarget, targetPlan);
const currentFoods = cqBuildFoodsPayload(baseForTarget, null);

function buildCurrentFoodState() {
  const stamp = new Date().toISOString();
  const currentFoodKeyLocal = String(answers.currentFood || "").trim().toLowerCase();
  const currentFoodLabelsLocal = {
    nassfutter: "Nassfutter",
    trockenfutter: "Trockenfutter",
    rohfleisch: "Rohfleisch",
    selbstgekocht: "Selbstgekocht",
  };
  const currentFoodLabelLocal = currentFoodKeyLocal
    ? (currentFoodLabelsLocal[currentFoodKeyLocal] || answers.currentFood || "")
    : "";
  const foodChoiceKeyLocal = String(answers.foodChoice || "").trim().toLowerCase();

  if (followupPlanMode === "half" && ownFoodAnalytics && Number.isFinite(ownFoodMe)) {
    return {
      mode: "half_fellinora_half_current_food",
      items: [
        ...currentFoods.map((food) => ({
          source: "catalog",
          code: food.code,
          variant_id: food.variantId != null ? Number(food.variantId) : null,
          variant_key: food.variantKey || null,
          pack_size_g: Number(food.packSizeGrams || 0) || null,
          share: cqRound(food.share || 0, 6),
        })),
        {
          source: "custom",
          label: currentFoodLabelLocal || "Eigenes Futter",
          share: 0.5,
          analytics: {
            protein: Number(ownFoodAnalytics.protein),
            fat: Number(ownFoodAnalytics.fat),
            ash: Number(ownFoodAnalytics.ash),
            fiber: Number(ownFoodAnalytics.fiber),
            moisture: Number(ownFoodAnalytics.moisture),
          },
          me_kcal_per_g: cqRound(ownFoodMe, 6),
        }
      ],
      updated_from: "initial_purchase",
      updated_at: stamp,
    };
  }

  if (foodChoiceKeyLocal === "other") {
    const customItem = {
      source: "custom",
      label: currentFoodLabelLocal || "Eigenes Futter",
      share: 1,
    };
    if (ownFoodAnalytics) customItem.analytics = cqNormalizeAnalytics(ownFoodAnalytics);
    if (Number.isFinite(ownFoodMe)) customItem.me_kcal_per_g = cqRound(ownFoodMe, 6);
    return {
      mode: "custom_only",
      items: [customItem],
      updated_from: "initial_purchase",
      updated_at: stamp,
    };
  }

  if (foodChoiceKeyLocal === "cook") {
    return { mode: "cook_only", items: [], updated_from: "initial_purchase", updated_at: stamp };
  }

  if (foodChoiceKeyLocal === "barf") {
    return { mode: "barf_only", items: [], updated_from: "initial_purchase", updated_at: stamp };
  }

  return {
    mode: "full_fellinora",
    items: currentFoods.map((food) => ({
      source: "catalog",
      code: food.code,
      variant_id: food.variantId != null ? Number(food.variantId) : null,
      variant_key: food.variantKey || null,
      pack_size_g: Number(food.packSizeGrams || 0) || null,
      share: cqRound(food.share || 0, 6),
    })),
    updated_from: "initial_purchase",
    updated_at: stamp,
  };
}

const currentFoodState = buildCurrentFoodState();

sendEvent("quiz_completed", {
  answers: {
    name:                 answers.name,
    age_years:            answers.ageYears,
    younger_than_one:     answers.isYoungCat,
    weight_kg:            answers.weightKg,
    sex:                  answers.sex,
    neutered:             answers.neuteredStatus,
    bcs:                  answers.bcs,
    activity:             answers.activity,
    picky_level:          answers.pickyLevel,
    feeding_frequency:    answers.feedingFrequency,
    health_focuses:       answers.healthFocuses,
    social_partner:       answers.socialPartner,
    social_custom:        answers.socialCustom,
    interval_days:        answers.intervalDays,
    feeding_meals_kitten: answers.kittenMealsPerDay || null,
    add_plan:             answers.addPlan
  }
});

const sellingPlanId = SELLING_PLANS[TARGET_DAYS];
const items = [];
const checkoutMatchId = makeCheckoutMatchId();
const lifestyleKey = String(answers.lifestyle || "").trim();
const lifestyleLabel = lifestyleKey === "wohnungskatze"
  ? "Wohnungskatze"
  : lifestyleKey === "freigaengerkatze"
    ? "Freigängerkatze"
    : lifestyleKey;

const canonicalSharedProps = {
  "_cq_match_id": checkoutMatchId,
  "_cq_quiz_session_id": CatQuiz?.config?.QUIZ_SESSION_ID || "",
  "_cq_flow": "trial7_to_30_via_next_billing",
  "_cq_trial_days": String(TRIAL_DAYS),
  "_cq_target_days": String(TARGET_DAYS),
  "_cq_followup_plan": followupPlanMode,
  "_cq_current_food_mode": String(currentFoodState?.mode || ""),
  "_cq_current_food_state_json": JSON.stringify(currentFoodState),
};

cqAddFoodCollectionProps(canonicalSharedProps, currentFoods, "");
cqAddFoodCollectionProps(canonicalSharedProps, targetFoods, "target_");
cqAddFoodCollectionProps(canonicalSharedProps, trialFoods, "trial_");

const foodProperty = {
  "Berechnet durch": QUIZ_TAG,
  "Geburtsmonat": answers.birthMonth || "",
  "Lebensweise": lifestyleLabel || "",
  ...canonicalSharedProps,
};

if (followupPlanMode === "half" && ownFoodAnalytics && Number.isFinite(ownFoodMe)) {
  foodProperty["_cq_custom_protein"] = String(ownFoodAnalytics.protein);
  foodProperty["_cq_custom_fat"] = String(ownFoodAnalytics.fat);
  foodProperty["_cq_custom_ash"] = String(ownFoodAnalytics.ash);
  foodProperty["_cq_custom_fiber"] = String(ownFoodAnalytics.fiber);
  foodProperty["_cq_custom_moisture"] = String(ownFoodAnalytics.moisture);
  foodProperty["_cq_custom_me_kcal_per_g"] = String(ownFoodMe);
  foodProperty["_cq_custom_grams_per_day"] = String(ownFoodGramsPerDay || 0);
}
    const normalizedFoodChoice = String(answers.foodChoice || "").trim().toLowerCase();
    const isOwnFoodChoice = normalizedFoodChoice === "other";
    const isRecipeChoice = normalizedFoodChoice === "cook" || normalizedFoodChoice === "barf";
    const ownfoodAddonSelected =
      isOwnFoodChoice && (form.querySelector('input[name="ownfood_addon_selected"]')?.value === "1");
    const recipeFlowAddonSelected =
      isRecipeChoice && (form.querySelector('input[name="recipe_flow_addon_selected"]')?.value === "1");

    const shouldAddFoodItems = isOwnFoodChoice
      ? ownfoodAddonSelected
      : (isRecipeChoice ? recipeFlowAddonSelected : true);

function buildFoodItemProperties(food, index) {
  return {
    ...foodProperty,
    "_cq_item_role": "food",
    "_cq_food_code": String(food.code || ""),
    "_cq_food_ui_key": String(food.uiKey || ""),
    "_cq_food_label": String(food.label || food.code || ""),
    "_cq_food_rank": String(index + 1),
    "_cq_food_variant_id": food.variantId != null ? String(food.variantId) : "",
    "_cq_food_variant_key": String(food.variantKey || ""),
    "_cq_food_variant_label": String(food.variantLabel || ""),
    "_cq_food_pack_size_g": String(food.packSizeGrams || 100),
    "_cq_food_share": String(cqRound(food.share || 0, 6)),
    "_cq_food_grams_per_day": String(cqRound(food.gramsPerDay || 0, 6)),
    "_cq_food_grams": food.grams != null ? String(Math.round(Number(food.grams || 0))) : "",
    "_cq_food_units": food.units != null ? String(Math.round(Number(food.units || 0))) : "",
  };
}

if (shouldAddFoodItems) {
  trialFoods.forEach((food, index) => {
    const variantId = Number(food.variantId || 0);
    const quantity = Math.max(0, Math.round(Number(food.units || 0)));
    if (!(variantId > 0) || quantity <= 0) return;

    items.push({
      id: variantId,
      quantity,
      ...(sellingPlanId ? { selling_plan: sellingPlanId } : {}),
      properties: buildFoodItemProperties(food, index)
    });
  });
}


    // --------------------------------------
// IMMER: Gesundheitsplan + Fütterungsplan (PDF)
// --------------------------------------

// Labels aufbereiten
const allergyLabel = (answers.allergyProteins && answers.allergyProteins.length)
  ? answers.allergyProteins.map(v => ALLERGY_LABELS[v] || v).join(", ")
  : "Keine";

const healthFocusLabel = (answers.healthFocuses && answers.healthFocuses.length)
  ? answers.healthFocuses.map(v => HEALTH_LABELS[v] || v).join(", ")
  : "Keine";

// Fütterungshäufigkeit – Kitten automatisch, sonst aus der Frage
let feedingFrequencyProperty = "";
if (answers.ageCategory === "kitten" && answers.kittenMealsPerDay) {
  feedingFrequencyProperty = `${answers.kittenMealsPerDay} Mahlzeiten pro Tag (automatisch berechnet für Kitten)`;
} else if (answers.feedingFrequency) {
  feedingFrequencyProperty = answers.feedingFrequency;
}

// kcal + Tagesmengen
const kcalPerDay = Number(base?.kcal || 0) || 0;

// Format (DE-Komma) für Shopify-Properties
const fmt = (n, decimals = 0) => {
  if (!isFinite(n)) return "";
  return Number(n).toFixed(decimals).replace(".", ",");
};

// Sozialpartner (Label) + Custom (falls vorhanden)
const socialKey   = answers.socialPartner || "";
const socialLabel = socialKey ? (SOCIAL_LABELS[socialKey] || socialKey) : "";
const socialCustom = (answers.socialCustom || "").trim();

// Zusätzliche „fehlende“ Felder für Plan-Properties (lesbar im PDF)
const sexKey = String(answers.sex || "").trim().toLowerCase();
const sexLabel = (sexKey === "female") ? "weiblich"
  : (sexKey === "male") ? "männlich"
  : (answers.sex || "");

const breedValue = String(answers.breed || answers.breedText || "").trim();
const idealWeightKg = resolveIdealWeightKg({ breed: breedValue, sex: sexKey });

const CURRENT_FOOD_LABELS = {
  nassfutter: "Nassfutter",
  trockenfutter: "Trockenfutter",
  rohfleisch: "Rohfleisch",
  selbstgekocht: "Selbstgekocht",
};
const currentFoodKey = String(answers.currentFood || "").trim().toLowerCase();
const currentFoodLabel = currentFoodKey
  ? (CURRENT_FOOD_LABELS[currentFoodKey] || answers.currentFood)
  : "";

const foodChoiceKey = String(answers.foodChoice || "").trim().toLowerCase();
const FOOD_CHOICE_LABELS = {
  fellinora: "Fellinora",
  other: "Eigenes Futter",
  cook: "Kochrezepte",
  barf: "BARF-Rezepte"
};
const foodChoiceLabel = foodChoiceKey
  ? (FOOD_CHOICE_LABELS[foodChoiceKey] || answers.foodChoice)
  : "";

const hasDiseaseKey = String(answers.hasDisease || "").trim().toLowerCase();
const hasDiseaseLabel = (hasDiseaseKey === "ja") ? "Ja"
  : (hasDiseaseKey === "nein") ? "Nein"
  : "";

const DISEASE_LABELS = {
  verstopfung: "Verstopfung",
  arthritis: "Arthritis",
  bauchspeicheldruesenentzuendung: "Bauchspeicheldrüsenentzündung",
  blasenentzuendung: "Blasenentzündung",
  ckd: "Chronische Nierenerkrankung (CKD)",
  diabetes: "Diabetes",
  durchfall: "Durchfall",
  epilepsie: "Epilepsie",
  gastritis: "Gastritis",
  harnwegserkrankung: "Harnwegserkrankung",
  ibd: "IBD",
  katzenasthma: "Katzenasthma",
  lebererkrankung: "Lebererkrankung",
  schilddruesenueberfunktion: "Schilddrüsenüberfunktion",
  andere: "Andere",
};
const diseaseKeys = Array.isArray(answers.diseases) ? answers.diseases : [];
const diseaseLabel = diseaseKeys.length
  ? diseaseKeys.map(k => DISEASE_LABELS[k] || k).join(", ")
  : "";
const diseaseCustom = String(answers.diseaseCustom || "").trim();

const currentGramsTotal = cqSumFoodMetric(currentFoods, "gramsPerDay", 6);
const targetGramsTotal = cqSumFoodMetric(targetFoods, "grams", 0);

// Gemeinsame Properties für beide Pläne
const planPropertiesBase = {
  "Berechnet von": QUIZ_TAG,
  "Quiz Session ID": CatQuiz.config.QUIZ_SESSION_ID,
  "Katze": answers.name,
  "Geschlecht": sexLabel,
  "Alter (Jahre)": answers.ageYears ? answers.ageYears.toString().replace(".", ",") : "",
  "Alter (Monate)": answers.ageMonths ? answers.ageMonths.toString() : "",
  "Geburtsmonat": answers.birthMonth || "",
  "Alterskategorie": answers.ageCategory || "",
  "Jünger als 1 Jahr": answers.isYoungCat ? "Ja" : "Nein",
  "Gewicht (kg)": answers.weightKg ? answers.weightKg.toString().replace(".", ",") : "",
  "BCS": answers.bcs || "",
  "Rasse": breedValue,
  "Aktivitätslevel": answers.activity || "",
  "Lebensweise": lifestyleLabel || "",
  "Kastriert": answers.neuteredStatus || "",
  "Aktuell gefütterte Futterart": currentFoodLabel,
  "Futter (gewählt)": foodChoiceLabel,
  "Erkrankung": hasDiseaseLabel,
  "Allergien (Proteine)": allergyLabel,
  "Gesundheitsfokus": healthFocusLabel,
  "Fütterungshäufigkeit": feedingFrequencyProperty,
  "Sozialprojekt": socialLabel,
  "Kalorienbedarf (kcal/Tag)": fmt(kcalPerDay, 0),
  "Tagesmenge gesamt (g/Tag)": fmt(currentGramsTotal, 0),
  "Folgeabo-Plan": (followupPlanMode === "half")
    ? "50% Fellinora / 50% Fremdfutter"
    : "100% Fellinora",
  "_cq_match_id": checkoutMatchId,
  "_cq_flow": "trial7_to_30_via_next_billing",
  "_cq_trial_days": String(TRIAL_DAYS),
  "_cq_target_days": String(TARGET_DAYS),
};

// Erkrankungs-Details (nur wenn „Ja“)
if (hasDiseaseKey === "ja") {
  if (diseaseLabel) planPropertiesBase["Erkrankung(en)"] = diseaseLabel;
  if (diseaseCustom) planPropertiesBase["Erkrankung (Custom)"] = diseaseCustom;
}

// Eigenes Futter: analytische Werte (lesbar), wenn food_choice="other"
if (foodChoiceKey === "other") {
  const ownPct = (field) => {
    const raw = String(qField(field)?.value || "").trim();
    if (!raw) return "";
    const n = normalizeNum(raw);
    return Number.isFinite(n) ? fmt(n, 1) : raw;
  };
  const ownNum = (field, decimals = 0) => {
    const raw = String(qField(field)?.value || "").trim();
    if (!raw) return "";
    const n = normalizeNum(raw);
    return Number.isFinite(n) ? fmt(n, decimals) : raw;
  };

  const p = ownPct(OWNFOOD_FIELDS.protein);
  const f = ownPct(OWNFOOD_FIELDS.fat);
  const a = ownPct(OWNFOOD_FIELDS.ash);
  const fi = ownPct(OWNFOOD_FIELDS.fiber);
  const m = ownPct(OWNFOOD_FIELDS.moisture);

  if (p)  planPropertiesBase["Eigenes Futter Protein (%)"] = p;
  if (f)  planPropertiesBase["Eigenes Futter Fett (%)"] = f;
  if (a)  planPropertiesBase["Eigenes Futter Rohasche (%)"] = a;
  if (fi) planPropertiesBase["Eigenes Futter Rohfaser (%)"] = fi;
  if (m)  planPropertiesBase["Eigenes Futter Feuchtigkeit (%)"] = m;

  const me = ownNum(OWNFOOD_FIELDS.me, 3);
  const g  = ownNum(OWNFOOD_FIELDS.grams, 0);
  if (me) planPropertiesBase["Eigenes Futter ME (kcal/g)"] = me;
  if (g)  planPropertiesBase["Eigenes Futter Menge (g/Tag)"] = g;

  const feedModeLabelMap = {
    nass: "Nur Nassfutter",
    trocken: "Nur Trockenfutter",
    beides: "Nassfutter + Trockenfutter",
  };
  const ownFoodModeLabel = feedModeLabelMap[String(answers.ownFoodFeedMode || "").trim().toLowerCase()] || "";
  if (ownFoodModeLabel) planPropertiesBase["Eigenes Futter Modus"] = ownFoodModeLabel;

  const wetComp = sanitizeOpenTextValue(answers.ownFoodWetComposition || "", { maxLen: 5000 });
  const wetAdd = sanitizeOpenTextValue(answers.ownFoodWetAdditives || "", { maxLen: 5000 });
  const dryComp = sanitizeOpenTextValue(answers.ownFoodDryComposition || "", { maxLen: 5000 });
  const dryAdd = sanitizeOpenTextValue(answers.ownFoodDryAdditives || "", { maxLen: 5000 });
  const wetG = Number.isFinite(Number(answers.ownFoodWetGramsPerDay)) ? fmt(Number(answers.ownFoodWetGramsPerDay), 1) : "";
  const dryG = Number.isFinite(Number(answers.ownFoodDryGramsPerDay)) ? fmt(Number(answers.ownFoodDryGramsPerDay), 1) : "";
  const ownFoodMode = String(answers.ownFoodFeedMode || "").trim().toLowerCase();
  const includeWetOwnFood = ownFoodMode === "nass" || ownFoodMode === "beides" || !ownFoodMode;
  const includeDryOwnFood = ownFoodMode === "trocken" || ownFoodMode === "beides" || !ownFoodMode;

  if (includeWetOwnFood && wetComp) planPropertiesBase["Nassfutter Zusammensetzung"] = wetComp;
  if (includeWetOwnFood && wetAdd) planPropertiesBase["Nassfutter Zusatzstoffe"] = wetAdd;
  if (includeWetOwnFood && wetG) planPropertiesBase["Nassfutter Menge (g/Tag)"] = wetG;
  if (includeDryOwnFood && dryComp) planPropertiesBase["Trockenfutter Zusammensetzung"] = dryComp;
  if (includeDryOwnFood && dryAdd) planPropertiesBase["Trockenfutter Zusatzstoffe"] = dryAdd;
  if (includeDryOwnFood && dryG) planPropertiesBase["Trockenfutter Menge (g/Tag)"] = dryG;

  const snacksHas = String(answers.ownFoodSnacksHas || "").trim().toLowerCase();
  if (snacksHas) planPropertiesBase["Zusätzliche Snacks"] = snacksHas === "ja" ? "Ja" : "Nein";

  const snackType = sanitizeOpenTextValue(answers.ownFoodSnackType || "", { maxLen: 500 });
  const snackAmount = Number.isFinite(Number(answers.ownFoodSnackAmount)) ? fmt(Number(answers.ownFoodSnackAmount), 1) : "";
  if (snackType) planPropertiesBase["Snack Sorte"] = snackType;
  if (snackAmount) planPropertiesBase["Snack Menge (g/Tag)"] = snackAmount;

  const ownFoodNotes = sanitizeOpenTextValue(answers.ownFoodNotes || "", { maxLen: 4000 });
  if (ownFoodNotes) planPropertiesBase["Hinweise zur Futterbewertung"] = ownFoodNotes;
}
if (String(answers.foodChoice || "").trim().toLowerCase() === "other") {
  const sel = (form.querySelector('input[name="ownfood_addon_selected"]')?.value === "1");
  planPropertiesBase["Probiersbox gewählt"] = sel ? "Ja" : "Nein";
}
if (["cook", "barf"].includes(String(answers.foodChoice || "").trim().toLowerCase())) {
  const sel = (form.querySelector('input[name="recipe_flow_addon_selected"]')?.value === "1");
  planPropertiesBase["Fellinora Futter hinzugefügt"] = sel ? "Ja" : "Nein";
}

cqAddDynamicFoodLineProps(planPropertiesBase, currentFoods, { current: true });
cqAddDynamicFoodLineProps(planPropertiesBase, targetFoods, { targetPlan: true });
planPropertiesBase["30 Tage Abo Fellinora gesamt (g)"] = fmt(targetGramsTotal, 0);

if (followupPlanMode === "half" && ownFoodAnalytics && Number.isFinite(ownFoodMe)) {
  planPropertiesBase["Fremdfutter Protein (%)"] = fmt(ownFoodAnalytics.protein, 1);
  planPropertiesBase["Fremdfutter Fett (%)"] = fmt(ownFoodAnalytics.fat, 1);
  planPropertiesBase["Fremdfutter Rohasche (%)"] = fmt(ownFoodAnalytics.ash, 1);
  planPropertiesBase["Fremdfutter Rohfaser (%)"] = fmt(ownFoodAnalytics.fiber, 1);
  planPropertiesBase["Fremdfutter Feuchtigkeit (%)"] = fmt(ownFoodAnalytics.moisture, 1);

  planPropertiesBase["Fremdfutter ME (kcal/g)"] = fmt(ownFoodMe, 3);
  planPropertiesBase["Fremdfutter Menge (g/Tag)"] = fmt(ownFoodGramsPerDay, 0);
}





if (socialKey === "custom" && socialCustom) {
  planPropertiesBase["Sozialprojekt (Custom)"] = socialCustom;
}

// --------------------------------------------------
// NEU: Alle erfassten Quiz-Variablen auch in die Line-Item-Properties
// der Pläne schreiben.
//
// Hintergrund:
// - getAnswers() enthält nur die wichtigsten/normalisierten Werte.
// - Im Formular existieren zusätzlich Hidden-Fields (z.B. followup_plan,
//   ownfood_* , consent/email, etc.).
//
// Lösung:
// - Form-State (serializeFormState(form)) -> _cq_form_<fieldname>
// - Answers-Objekt -> _cq_answer_<key>
//
// Damit sind alle im Quiz erfassten Variablen am Line Item der Pläne verfügbar.
// --------------------------------------------------

function cqToLineItemString(v) {
  if (v == null) return "";

  // Checkbox-Gruppen etc.
  if (Array.isArray(v)) {
    const cleaned = v
      .map((x) => (x == null ? "" : String(x).trim()))
      .filter(Boolean);
    return cleaned.join(", ");
  }

  // Zahlen / Booleans
  if (typeof v === "boolean") return v ? "Ja" : "Nein";
  if (typeof v === "number") return Number.isFinite(v) ? String(v) : "";

  // Objekte (sollten selten sein) -> JSON
  if (typeof v === "object") {
    try {
      const s = JSON.stringify(v);
      return s && s !== "{}" ? s : "";
    } catch {
      return "";
    }
  }

  return String(v).trim();
}

function cqCollectPropsFromObject(prefix, obj) {
  const out = {};
  if (!obj || typeof obj !== "object") return out;

  for (const [kRaw, v] of Object.entries(obj)) {
    const k = String(kRaw || "").trim();
    if (!k) continue;

    const s = cqToLineItemString(v);
    if (!s) continue;

    out[`${prefix}${k}`] = s;
  }
  return out;
}

function cqCollectPropsFromFormState() {
  // serializeFormState() existiert bereits im File (Persistenz-Block)
  // und deckt ALLE Inputs im Form ab (inkl. Hidden).
  let state = null;
  try {
    state = serializeFormState(form);
  } catch {
    state = null;
  }

  return cqCollectPropsFromObject("_cq_form_", state || {});
}

const planPropertiesAll = {
  ...planPropertiesBase,
  ...cqCollectPropsFromFormState(),
  ...cqCollectPropsFromObject("_cq_answer_", answers),
};

function getSelectedFeedingPlanVariantId() {
  const meals = (answers.ageCategory === "kitten" && Number.isFinite(Number(answers.kittenMealsPerDay)))
    ? Number(answers.kittenMealsPerDay)
    : Number(String(answers.feedingFrequency || "").replace(/[^0-9]/g, ""));

  if (meals === 3 && Number(FUTTERPLAN_3_Mahlzeiten_ID)) {
    return Number(FUTTERPLAN_3_Mahlzeiten_ID);
  }

  if (meals === 4) {
    const fourId = Number(FUTTERPLAN_4_Mahlzeiten_ID || FUTERPLAN_4_Mahlzeiten_ID || 0);
    if (fourId) return fourId;
  }

  return Number(FUTTERPLAN_VARIANT_ID || 0);
}

function getSelectedHealthPlanVariantId() {
  if (foodChoiceKey === "other") return Number(GESUNDHEITSPLAN_OWN_FOOD_ID || 0);
  if (foodChoiceKey === "cook" || foodChoiceKey === "barf") {
    return Number(GESUNDHEITSPLAN_REZEPTE_KOCH_BARF_ID || 0);
  }
  return Number(GESUNDHEITSPLAN_VARIANT_ID || 0);
}


function buildCanonicalPlanProps(planType) {
  return {
    ...canonicalSharedProps,
    "_cq_item_role": String(planType || ""),
    "_cq_plan_type": String(planType || ""),
  };
}

function buildRecipeLabel() {
  if (foodChoiceKey === "other") {
    return currentFoodLabel || "Eigenes Futter";
  }
  if (foodChoiceKey === "cook") return "Kochrezepte";
  if (foodChoiceKey === "barf") return "BARF-Rezepte";
  return cqBuildFoodSummaryLabel(currentFoods);
}

function buildFeedingPlanProperties() {
  const ownFoodCurrent = Number.isFinite(ownFoodGramsPerDay) ? ownFoodGramsPerDay : 0;
  const totalCurrentGrams = cqSumFoodMetric(currentFoods, "gramsPerDay", 6) + (followupPlanMode === "half" ? ownFoodCurrent : 0);

  const props = {
    ...buildCanonicalPlanProps("feeding_plan"),
    "Rezept/Futter": buildRecipeLabel(),
    "Kalorienbedarf (kcal/Tag)": fmt(kcalPerDay, 0),
    "Gewicht (kg)": fmt(answers.weightKg, 1),
    "Futtermenge gesamt aktuell (g/Tag)": fmt(totalCurrentGrams, 0),
    "30 Tage Abo Fellinora gesamt (g)": fmt(targetGramsTotal, 0),
  };

  cqAddDynamicFoodLineProps(props, currentFoods, { current: true });
  cqAddDynamicFoodLineProps(props, targetFoods, { targetPlan: true });

  if (followupPlanMode === "half") {
    props["Futtermenge Eigenes Futter aktuell (g/Tag)"] = fmt(ownFoodCurrent, 0);
    props["50% Plan"] = "Ja";
  }

  return props;
}

function buildNutrientPlanProperties() {
  const nutrientMetrics = buildNutrientPlanMetrics({
    weightKg: answers.weightKg,
    breed: breedValue,
    sex: sexKey,
  });

  return {
    ...buildCanonicalPlanProps("nutrient_plan"),
    "Idealgewicht (kg)": fmt(idealWeightKg, 1),
    "Proteinbedarf (g/Tag)": fmt(nutrientMetrics.proteinG, 1),
    "Argininbedarf (mg/Tag)": fmt(nutrientMetrics.arginineMg, 0),
    "Histidinbedarf (mg/Tag)": fmt(nutrientMetrics.histidineMg, 0),
    "Isoleucinbedarf (mg/Tag)": fmt(nutrientMetrics.isoleucineMg, 0),
    "Leucinbedarf (mg/Tag)": fmt(nutrientMetrics.leucineMg, 0),
    "Lysinbedarf (mg/Tag)": fmt(nutrientMetrics.lysineMg, 0),
    "Methioninbedarf (mg/Tag)": fmt(nutrientMetrics.methionineMg, 0),
    "Methionin + Cystin Bedarf (mg/Tag)": fmt(nutrientMetrics.methionineCystinMg, 0),
    "Phenylalaninbedarf (mg/Tag)": fmt(nutrientMetrics.phenylalanineMg, 0),
    "Phenylalanin + Tyrosin Bedarf (mg/Tag)": fmt(nutrientMetrics.phenylalanineTyrosinMg, 0),
    "Threoninbedarf (mg/Tag)": fmt(nutrientMetrics.threonineMg, 0),
    "Tryptophanbedarf (mg/Tag)": fmt(nutrientMetrics.tryptophanMg, 0),
    "Valinbedarf (mg/Tag)": fmt(nutrientMetrics.valineMg, 0),
    "Fettbedarf (g/Tag)": fmt(nutrientMetrics.fatG, 1),
    "Linolsäurebedarf (mg/Tag)": fmt(nutrientMetrics.linoleicAcidMg, 0),
    "Arachidonsäurebedarf (mg/Tag)": fmt(nutrientMetrics.arachidonicAcidMg, 1),
    "Vitamin A Bedarf (IE/Tag)": fmt(nutrientMetrics.vitaminAIE, 0),
    "Vitamin D Bedarf (IE/Tag)": fmt(nutrientMetrics.vitaminDIE, 0),
    "Vitamin E Bedarf (mg/Tag)": fmt(nutrientMetrics.vitaminEMg, 1),
    "Thiamin (B1) Bedarf (µg/Tag)": fmt(nutrientMetrics.thiaminUg, 0),
    "Riboflavin (B2) Bedarf (µg/Tag)": fmt(nutrientMetrics.riboflavinUg, 0),
    "Niacin (B3) Bedarf (µg/Tag)": fmt(nutrientMetrics.niacinUg, 0),
    "Pantothensäure (B5) Bedarf (µg/Tag)": fmt(nutrientMetrics.pantothenicAcidUg, 0),
    "Pyridoxin (B6) Bedarf (µg/Tag)": fmt(nutrientMetrics.pyridoxineUg, 0),
    "Biotin (B7) Bedarf (µg/Tag)": fmt(nutrientMetrics.biotinUg, 1),
    "Folsäure (B9) Bedarf (µg/Tag)": fmt(nutrientMetrics.folicAcidUg, 0),
    "Cobalamin (B12) Bedarf (µg/Tag)": fmt(nutrientMetrics.cobalaminUg, 2),
    "Calciumbedarf (mg/Tag)": fmt(nutrientMetrics.calciumMg, 0),
    "Phosphorbedarf (mg/Tag)": fmt(nutrientMetrics.phosphorusMg, 0),
    "Magnesiumbedarf (mg/Tag)": fmt(nutrientMetrics.magnesiumMg, 0),
    "Natriumbedarf (mg/Tag)": fmt(nutrientMetrics.sodiumMg, 0),
    "Kaliumbedarf (mg/Tag)": fmt(nutrientMetrics.potassiumMg, 0),
    "Chloridbedarf (mg/Tag)": fmt(nutrientMetrics.chlorideMg, 0),
    "Eisenbedarf (mg/Tag)": fmt(nutrientMetrics.ironMg, 1),
    "Kupferbedarf (mg/Tag)": fmt(nutrientMetrics.copperMg, 2),
    "Zinkbedarf (mg/Tag)": fmt(nutrientMetrics.zincMg, 1),
    "Manganbedarf (mg/Tag)": fmt(nutrientMetrics.manganeseMg, 2),
    "Iodbedarf (µg/Tag)": fmt(nutrientMetrics.iodineUg, 0),
    "Selenbedarf (µg/Tag)": fmt(nutrientMetrics.seleniumUg, 0),
  };
}

function buildFellinoraHealthPlanProperties() {
  const healthMetrics = buildFoodCollectionHealthMetrics({
    weightKg: answers.weightKg,
    bcs: answers.bcs,
    currentFood: answers.currentFood,
    foods: currentFoods,
    waterMlPerKg: 40,
    taurineMgPerKg: 50,
  });

  const props = {
    ...planPropertiesAll,
    ...buildCanonicalPlanProps("health_plan"),
    "Plan-Typ": "Gesundheitsplan",
    "Plan-Modus": "Fellinora Gesundheitsplan",
    "Name": answers.name || "",
    "Rasse": breedValue,
    "Geschlecht": sexLabel,
    "Idealgewicht (kg)": fmt(idealWeightKg, 1),
    "Alter": answers.ageCategory === "kitten" ? `${answers.ageMonths || ""} Monate` : `${answers.ageYears || ""} Jahre`,
    "Status": answers.neuteredStatus || "",
    "Proteinaufnahme Fellinora gesamt (g/Tag)": fmt(healthMetrics.proteinIntakeG, 1),
    "Proteinbedarf Katze (g/Tag)": fmt(healthMetrics.proteinNeedG, 1),
    "Fettaufnahme Fellinora gesamt (g/Tag)": fmt(healthMetrics.fatIntakeG, 1),
    "Mindestbedarf Fett (g/Tag)": fmt(healthMetrics.fatNeedG, 1),
    "Kohlenhydrate aus Fellinora gesamt (g/Tag)": fmt(healthMetrics.carbIntakeG, 1),
    "Max. Kohlenhydrate (g/Tag)": fmt(healthMetrics.carbMaxG, 1),
    "Wasserbedarf täglich (ml)": fmt(healthMetrics.waterNeedMl, 0),
    "Wasser aus Fellinora gesamt (ml/Tag)": fmt(healthMetrics.waterFromFoodMl, 0),
    "Taurinbedarf (mg/Tag)": fmt(healthMetrics.taurineNeedMg, 0),
    "BCS": String(answers.bcs || ""),
    "Spielzeiten": healthMetrics.playTimes,
    "30 Tage Abo Fellinora gesamt (g)": fmt(targetGramsTotal, 0),
    "50%": followupPlanMode === "half" ? "Ja" : "Nein",
    "Allergien": allergyLabel,
    "Erkrankung": hasDiseaseLabel,
    "Gesundheitsfokus": healthFocusLabel,
    "KCal Bedarf": fmt(kcalPerDay, 0),
    "Aktuelles Futter": currentFoodLabel,
    "Sozialprojekt": socialLabel,
  };

  cqAddDynamicFoodLineProps(props, currentFoods, { current: true });
  cqAddDynamicFoodLineProps(props, targetFoods, { targetPlan: true });

  if (followupPlanMode === "half" && ownFoodAnalytics) {
    props["Eigenes Futter Protein (%)"] = fmt(ownFoodAnalytics.protein, 1);
    props["Eigenes Futter Fett (%)"] = fmt(ownFoodAnalytics.fat, 1);
    props["Eigenes Futter Rohasche (%)"] = fmt(ownFoodAnalytics.ash, 1);
    props["Eigenes Futter Rohfaser (%)"] = fmt(ownFoodAnalytics.fiber, 1);
    props["Eigenes Futter Feuchtigkeit (%)"] = fmt(ownFoodAnalytics.moisture, 1);
    props["Eigenes Futter ME (kcal/g)"] = fmt(ownFoodMe, 3);
    props["Eigenes Futter Menge (g/Tag)"] = fmt(ownFoodGramsPerDay, 0);
  }

  if (hasDiseaseKey === "ja") {
    if (diseaseLabel) props["Erkrankung(en)"] = diseaseLabel;
    if (diseaseCustom) props["Erkrankung (Custom)"] = diseaseCustom;
  }
  if (socialKey === "custom" && socialCustom) {
    props["Sozialprojekt (Custom)"] = socialCustom;
  }
  return props;
}

const selectedHealthPlanId = getSelectedHealthPlanVariantId();
const selectedFeedingPlanId = getSelectedFeedingPlanVariantId();

function buildGenericHealthPlanProperties() {
  return {
    ...planPropertiesAll,
    ...buildCanonicalPlanProps("health_plan"),
    "Plan-Typ": "Gesundheitsplan",
    "Plan-Modus": foodChoiceLabel || "Gesundheitsplan",
    "Name": answers.name || "",
    "Rasse": breedValue,
    "Geschlecht": sexLabel,
    "Idealgewicht (kg)": fmt(idealWeightKg, 1),
    "Gewicht (kg)": fmt(answers.weightKg, 1),
  };
}

if (selectedHealthPlanId) {
  const healthPlanProps = (selectedHealthPlanId === Number(GESUNDHEITSPLAN_VARIANT_ID || 0))
    ? buildFellinoraHealthPlanProperties()
    : buildGenericHealthPlanProperties();

  items.push({
    id: selectedHealthPlanId,
    quantity: 1,
    properties: healthPlanProps
  });
}

if (selectedFeedingPlanId) {
  items.push({
    id: selectedFeedingPlanId,
    quantity: 1,
    properties: buildFeedingPlanProperties()
  });
}

if (Number(NAEHRSTOFFPLAN_ID || 0)) {
  items.push({
    id: Number(NAEHRSTOFFPLAN_ID),
    quantity: 1,
    properties: buildNutrientPlanProperties()
  });
}

if (window.CatQuizRecipeResults?.buildCartItems) {
  try {
    const recipeResultItems = window.CatQuizRecipeResults.buildCartItems({ answers, form, quizRoot });
    if (Array.isArray(recipeResultItems) && recipeResultItems.length) {
      items.push(...recipeResultItems);
    }
  } catch (e) {
    console.warn("[CatQuiz] could not append recipe result items:", e);
  }
}

if (window.CatQuizBarfRecipeResults?.buildCartItems) {
  try {
    const barfRecipeResultItems = window.CatQuizBarfRecipeResults.buildCartItems({ answers, form, quizRoot });
    if (Array.isArray(barfRecipeResultItems) && barfRecipeResultItems.length) {
      items.push(...barfRecipeResultItems);
    }
  } catch (e) {
    console.warn("[CatQuiz] could not append BARF recipe result items:", e);
  }
}

const currentStepNo = Number(steps?.[currentStep]?.dataset?.step);

if (currentStepNo === 10 && window.CatQuizUpsell?.buildCartItems) {
  try {
    const upsellItems = window.CatQuizUpsell.buildCartItems({ answers, form, quizRoot });
    if (Array.isArray(upsellItems) && upsellItems.length) {
      items.push(...upsellItems);
    }
  } catch (e) {
    console.warn("[CatQuiz] could not append upsell items:", e);
  }
}

    if (!items.length) {
      alert("Es konnten keine Produkte für den Warenkorb erstellt werden.");
      return;
    }

    console.log("→ Wird an Shopify gesendet:", items);

    // Robust Add-to-Cart: verhindert False-Errors (z.B. wenn Shopify/Theme kein JSON liefert)
    // und schützt gegen Doppelklick/Doppelsubmit.
    if (window.__fellinoraIsAddingToCart) return;
    window.__fellinoraIsAddingToCart = true;

    (async () => {
try {
  await addItemsToCart(items, {
    debugTag: "Fellinora Add-to-cart",
    redirectToCart: false,
    verifyViaCartJs: true,
  });

  // Prefill Shopify Checkout Email aus Step 7 (E-Mail bleibt Pflicht im Quiz,
  // aber landet automatisch auch im Checkout-Feld)
  cqGoToCheckoutWithEmailPrefill(cqGetEmailForCheckout());
  return;
} catch (err) {
  console.error("[Fellinora Add-to-cart] error", err);
  alert("Leider ist ein Fehler beim Hinzufügen zum Warenkorb aufgetreten. Bitte versuche es erneut.");
}
finally {
        window.__fellinoraIsAddingToCart = false;
      }
    })();
});

document.addEventListener("click", e => {
    const clickedHealthInfo  = e.target.closest(".health-info-btn");
    const clickedHealthPanel = e.target.closest(".health-info-panel-inner");

    const clickedSocialInfo  = e.target.closest(".social-info-btn");
    const clickedSocialPanel = e.target.closest(".social-info-panel-inner");

    const clickedOwnfoodInfo  = e.target.closest(".ownfood-info-btn");
    const clickedOwnfoodPanel = e.target.closest(".ownfood-info-panel-inner");

    if (!clickedHealthInfo && !clickedHealthPanel && healthInfoPanel && !healthInfoPanel.hidden) {
      healthInfoPanel.hidden = true;
      currentHealthInfoKey = null;
    }

    if (!clickedSocialInfo && !clickedSocialPanel && socialInfoPanel && !socialInfoPanel.hidden) {
      socialInfoPanel.hidden = true;
      currentSocialInfoKey = null;
    }

    const ownfoodPanel = document.querySelector('.ownfood-info-panel');
    if (!clickedOwnfoodInfo && !clickedOwnfoodPanel && ownfoodPanel && !ownfoodPanel.hidden) {
      ownfoodPanel.hidden = true;
      currentOwnfoodInfoKey = null;
    }
  });
function initConsentStep() {
  const consentStep = form.querySelector('.quiz-step[data-step="7"]');
  if (!consentStep) return;

  const marketingCheckbox = consentStep.querySelector('input[name="consent_marketing"]');
  const emailInput = consentStep.querySelector('input[name="email"]');
  const doiHint = consentStep.querySelector(".consent-email-hint--doi");

  if (!emailInput) return;

  // Email ist jetzt IMMER Pflicht
  emailInput.required = true;

  function syncDoiHint() {
    const on = !!marketingCheckbox?.checked;
    if (doiHint) doiHint.hidden = !on;
  }

  marketingCheckbox?.addEventListener("change", () => {
    syncDoiHint();
    // Email NICHT mehr leeren – bleibt Pflicht & wird für Abbruch-Erinnerung genutzt
    emailInput.setCustomValidity("");
  });

  emailInput.addEventListener("input", () => {
    emailInput.setCustomValidity("");
  });

  syncDoiHint();
}

initConsentStep();

// ------------------------
// Turnstile init + token handling (robust)
// ------------------------
let turnstileWidgetId = null;
let lastTurnstileToken = "";

function initTurnstileIfNeeded() {
  const el = document.getElementById("turnstile-optin");
  if (!el) return;

  if (!window.turnstile) return;
  if (turnstileWidgetId !== null) return;

  turnstileWidgetId = window.turnstile.render(el, {
    sitekey: TURNSTILE_SITE_KEY,

    // Empfehlung: "invisible" ist am smoothesten fürs Quiz
    // Wenn du es sichtbar willst, lass "normal".
    size: "invisible",

    execution: "execute",
    appearance: "interaction-only",

    callback: (token) => {
      lastTurnstileToken = token || "";
    },
    "expired-callback": () => {
      lastTurnstileToken = "";
    },
    "error-callback": () => {
      lastTurnstileToken = "";
    }
  });
}

async function getTurnstileToken() {
  initTurnstileIfNeeded();

  // Script lädt async; kurzer Retry
  if (!window.turnstile || turnstileWidgetId === null) {
    await new Promise(r => setTimeout(r, 150));
    initTurnstileIfNeeded();
  }

  if (!window.turnstile || turnstileWidgetId === null) {
    alert("Sicherheitsprüfung konnte nicht geladen werden. Bitte Seite neu laden.");
    throw new Error("turnstile_not_ready");
  }

  // 1) Falls schon ein Token da ist: nutzen
  let token =
    (window.turnstile.getResponse && window.turnstile.getResponse(turnstileWidgetId)) ||
    lastTurnstileToken;

  if (token) return token;

  // 2) Challenge triggern
  window.turnstile.execute(turnstileWidgetId, { action: "quiz_optin" });

  // 3) Warten bis Token da ist
  const deadline = Date.now() + 15000;
  while (Date.now() < deadline) {
    token =
      (window.turnstile.getResponse && window.turnstile.getResponse(turnstileWidgetId)) ||
      lastTurnstileToken;

    if (token) return token;
    await new Promise(r => setTimeout(r, 100));
  }

  throw new Error("turnstile_timeout");
}


function isValidEmail(value) {
  const v = (value || "").trim();
  // simple + robust enough for UI; final validation happens server-side anyway
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}

let marketingSubmitDone = false;
let marketingSubmitInFlight = false;

function setStepNavBusy(isBusy, stepEl) {
  const el = stepEl || steps?.[currentStep];
  if (!el) return;

  const btns = Array.from(el.querySelectorAll(".btn-next, .btn-back"));

  btns.forEach((b) => {
    if ("disabled" in b) b.disabled = !!isBusy;

    b.classList.toggle("is-busy", !!isBusy);
    b.setAttribute("aria-disabled", isBusy ? "true" : "false");
    b.setAttribute("aria-busy", isBusy ? "true" : "false");
  });
}



async function submitMarketingOptInIfNeeded() {
  // DONE -> nie wieder senden
  if (marketingSubmitDone) return;

  // In-Flight -> nicht parallel senden
  if (marketingSubmitInFlight) return;

  const consentStep = steps[currentStep];
  const stepNo = Number(consentStep?.dataset?.step);
  if (stepNo !== 7) return;

  const emailInput = consentStep.querySelector('input[name="email"]');
  const email = (emailInput?.value || "").trim();

  // Email ist (laut deinem initConsentStep) Pflicht. Hier hart validieren:
  if (!isValidEmail(email)) {
    emailInput?.focus();
    alert("Bitte gib eine gültige E-Mail-Adresse ein.");
    throw new Error("invalid_email");
  }

  const marketingChecked =
    !!consentStep.querySelector('input[name="consent_marketing"]')?.checked;

  // Ohne Haken: KEIN Klaviyo/DOI Call (aber Email bleibt Pflicht für euch)
  if (!marketingChecked) return;

  // Ab hier: Lock setzen, damit Double-Click nicht doppelt feuert
marketingSubmitInFlight = true;
setStepNavBusy(true, consentStep);


  try {
    // Turnstile nur bei Opt-in
    let token = "";
    try {
      token = await getTurnstileToken();
    } catch (err) {
      alert("Sicherheitsprüfung konnte nicht abgeschlossen werden. Bitte versuche es erneut.");
      throw err;
    }

    const payload = {
      email,
      consent_marketing: true,
      turnstile_token: token
    };

    const res = await fetch(OPTIN_ENDPOINT_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    // IMPORTANT: erst text() lesen, dann JSON parsen (robuster als res.json() direkt)
    const txt = await res.text().catch(() => "");
    let data = {};
    try { data = txt ? JSON.parse(txt) : {}; } catch { data = { raw: txt }; }

    if (!res.ok) {
      console.error("[Opt-in] non-2xx:", res.status, data);
      alert("Opt-in konnte nicht gespeichert werden. Bitte versuche es erneut.");
      throw new Error("optin_failed");
    }

    if (data && data.ok === false) {
      console.error("[Opt-in] Worker ok=false:", data);
      alert("Opt-in konnte nicht gespeichert werden (Klaviyo). Bitte versuche es erneut.");
      throw new Error("klaviyo_failed");
    }

    console.log("[Opt-in] success", data);

    // HIER ist das entscheidend:
    marketingSubmitDone = true;
    try { scheduleSaveQuizState(); } catch {}
    return;
} finally {
  marketingSubmitInFlight = false;
  setStepNavBusy(false, consentStep);
}

}


  // --------------------------------------------------
  // Progressive Steps aus vorhandenen Werten restoren
  // --------------------------------------------------

  function restoreProgressiveStepsFromExistingValues() {
    // STEP 1
    const nameFilled =
      nameInput && nameInput.value.trim().length > 0;

    const ageFilled =
  (ageYearsInput && ageYearsInput.value.trim().length > 0) ||
  (ageMonthsInput && ageMonthsInput.value.trim().length > 0) ||
  (ageCategoryInputs && ageCategoryInputs.some(input => input.checked));


    const sexFilled =
      sexInputs && sexInputs.some(input => input.checked);

    const neuteredFilled =
      neuteredInputs && neuteredInputs.some(input => input.checked);

    const breedFilled =
      (breedHiddenInput && breedHiddenInput.value.trim().length > 0) ||
      (breedTextInput && breedTextInput.value.trim().length > 0);

    const hasStep1Values =
      nameFilled || ageFilled || sexFilled || neuteredFilled || breedFilled;

    if (hasStep1Values && step1Questions.length) {
      currentStep1Index = step1Questions.length - 1;
    }

    // STEP 4
  
    const allergyFilled =
      allergyInputs && allergyInputs.some(input => input.checked);

    const feedingFreqFilled =
      feedingFreqInputs && feedingFreqInputs.some(input => input.checked);

    const pickyFilled =
      pickyInputs && pickyInputs.some(input => !!(input.value || "").trim());

    const foodFilled =
      currentFoodInputs && currentFoodInputs.some(input => input.checked);

    const hasStep4Values =
      allergyFilled || feedingFreqFilled || pickyFilled || foodFilled;

    if (hasStep4Values && step4Questions.length) {
      currentStep4Index = step4Questions.length - 1;
    }

    // STEP 6.75 (Kochplan)
    try {
      const cookF = (form.querySelector('input[name="cook_familiarity"]:checked')?.value || "").trim();
      const cookD = Number(form.querySelector('input[name="cook_days"]:checked')?.value || 0);
      if (cookF) currentCookStepIndex = Math.max(currentCookStepIndex, 1);
      if (cookD && cookD < 7) currentCookStepIndex = Math.max(currentCookStepIndex, 2);
      else if (cookD) currentCookStepIndex = Math.max(currentCookStepIndex, 1);
    } catch {}

    // STEP 6.85 (BARF)
    try {
      const barfF = (form.querySelector('input[name="barf_familiarity"]:checked')?.value || "").trim();
      const barfD = Number(form.querySelector('input[name="barf_days"]:checked')?.value || 0);
      if (barfF) currentBarfStepIndex = Math.max(currentBarfStepIndex, 1);
      if (barfD && barfD < 7) currentBarfStepIndex = Math.max(currentBarfStepIndex, 2);
      else if (barfD) currentBarfStepIndex = Math.max(currentBarfStepIndex, 1);
    } catch {}
  }

// --------------------------------------------------
// Initialisierung (Restore localStorage -> UI)
// --------------------------------------------------

function runRestoreFromSavedState(saved) {
  _isRestoringQuizState = true;

  try {
    // 1) Form-Felder wiederherstellen
    if (saved && saved.fields) {
      applyFormState(form, saved.fields);

      if (typeof saved.currentStep1Index === "number") currentStep1Index = saved.currentStep1Index;
      if (typeof saved.currentStep4Index === "number") currentStep4Index = saved.currentStep4Index;
      if (typeof saved.currentCookStepIndex === "number") currentCookStepIndex = saved.currentCookStepIndex;
      if (typeof saved.currentBarfStepIndex === "number") currentBarfStepIndex = saved.currentBarfStepIndex;

      if (typeof saved.ageCategory === "string") ageCategory = saved.ageCategory;

      marketingSubmitDone = !!saved.marketingSubmitDone;

      // --- Restore: Custom-UIs synchronisieren (kein Dispatch / kein Step-Advance) ---
      try { updateNameTexts(); } catch {}

      // Breed: Hidden/Text-Feld + Mix-Button/Autocomplete-UI konsistent setzen
      try {
        if (typeof _syncBreedUIFromCurrentValue === "function") {
          _syncBreedUIFromCurrentValue();
        } else {
          // Fallback: falls nur Hidden gefüllt ist
          if (breedHiddenInput && breedTextInput && !breedTextInput.value && breedHiddenInput.value) {
            breedTextInput.value = breedHiddenInput.value;
          }
        }
      } catch {}

      // Wählerischkeit: aktive Optik aus hidden value herstellen
      try {
        if (pickyHiddenInput && typeof setPickyLevel === "function") {
          const key = String(pickyHiddenInput.value || "").trim();
          if (key) {
            const idx = (typeof PICKY_LEVELS !== "undefined")
              ? PICKY_LEVELS.findIndex(lvl => lvl && lvl.key === key)
              : -1;
            if (idx >= 0) setPickyLevel(idx, { skipStepAdvance: true, skipDispatch: true });
          }
        }
      } catch {}

    }

    // Restore UI Sync: Breed (Rasse) + Picky (Wählerisch)
    try {
      if (typeof _syncBreedUIFromCurrentValue === "function") {
        _syncBreedUIFromCurrentValue();
      }
    } catch (e) {}

    try {
      if (pickyHiddenInput && pickyOptions && pickyOptions.length) {
        const key = (pickyHiddenInput.value || "").trim();
        if (key) {
          const idx = PICKY_LEVELS.findIndex(l => l.key === key);
          setPickyLevel(idx >= 0 ? idx : 0, { skipStepAdvance: true, skipDispatch: true });
        }
      }
    } catch (e) {}

    // 2) Fallback: wenn keine gespeicherten Indizes existieren → aus vorhandenen Werten ableiten
    const hadSavedIndexes =
      saved && (typeof saved.currentStep1Index === "number" || typeof saved.currentStep4Index === "number" || typeof saved.currentCookStepIndex === "number" || typeof saved.currentBarfStepIndex === "number");

    if (!hadSavedIndexes) {
      restoreProgressiveStepsFromExistingValues();
    }

    // 3) UI auf Stand bringen
    updateStep1Questions();
    ensureStep4StartIndex();
    updateStep4Questions();
updateBCSVisibility();
    updateBreedWeightInfo();

    // Age-UI konsistent setzen (Infobox / required / Geburtsmonat etc.)
    const selectedAgeRadio = ageCategoryInputs.find(r => r.checked);
    if (selectedAgeRadio) {
      setAgeCategory(selectedAgeRadio.value);
    } else if (ageCategory) {
      // Fallback: falls Radio beim Restore nicht korrekt gecheckt ist
      const r = ageCategoryInputs.find(x => x && x.value === ageCategory);
      if (r) r.checked = true;
      setAgeCategory(ageCategory);
    }

      // Step 3: Activity/Lifestyle UI sync (show lifestyle block if activity already chosen)
      try { window.__catQuizSyncActivityLifestyleUI && window.__catQuizSyncActivityLifestyleUI(); } catch {}

// 4) Step-Startlogik:
// Step 0 soll sich wie alle anderen Steps verhalten:
// -> Wenn sessionStorage einen Step kennt: immer dahin (reload/back_forward/navigate)
// -> Sonst: Step 0 (falls vorhanden), sonst Index 0

const findStepIndexByNo = (n) => steps.findIndex(s => Number(s?.dataset?.step) === n);

// Default: Step 0, wenn vorhanden
let desiredStep = findStepIndexByNo(0);
if (desiredStep < 0) desiredStep = 0;

// Session-Step hat Priorität (egal ob reload oder navigate, damit es konsistent ist)
const s = loadSessionStep();
if (typeof s === "number") desiredStep = s;

// clamp
const clampedStep = Math.max(0, Math.min(desiredStep, steps.length - 1));

// showStep triggert progress updates; wir wollen dabei NICHT speichern → Guard ist aktiv
showStep(clampedStep);

// Nach Restore den aktuellen Step sicher erneut rendern (Safari/Reload)
try {
  const stepNoNow = Number(steps?.[clampedStep]?.dataset?.step);
  scheduleStepRerender(stepNoNow);
} catch {}

try {
  const stepNoNow = Number(steps?.[clampedStep]?.dataset?.step);
  scheduleStepRerender(stepNoNow);
} catch {}

    // 5) Progressbars einmal rendern
    updateProgressBars();

    // 6) Optional init
    initDiseaseSection();
  } finally {
    // Guard aus
    _isRestoringQuizState = false;

    // Einmal sauber speichern (jetzt sind Form + Indizes konsistent)
    try { saveQuizState(); } catch {}
  }
}
// =====================================================
// FIX: Ingredient-Ray immer nach jedem Result-Render anhängen
// (wichtig bei mehreren updateResultSummary()-Varianten im File)
// =====================================================
try {
  const __origUpdateResultSummary = updateResultSummary;
  
  updateResultSummary = function (...args) {
    const out = __origUpdateResultSummary.apply(this, args);

    try {
      const answers = (typeof getAnswers === "function") ? getAnswers() : {};
      const choice = getResultFlowChoice(answers);
      const isOwnFoodMode = (choice === "other");
      const isCookRecipeMode = (choice === "cook");
      const isBarfRecipeMode = (choice === "barf");
      const isRecipeFlowMode = isCookRecipeMode || isBarfRecipeMode;

      const oldRay = resultBox && resultBox.querySelector
        ? resultBox.querySelector(".result-ingredient-ray-host")
        : null;

      const oldProd = resultBox && resultBox.querySelector
        ? resultBox.querySelector(".result-produktion-host")
        : null;

      const oldCommunity = resultBox && resultBox.querySelector
        ? resultBox.querySelector(".community-section-host")
        : null;

      if (isOwnFoodMode) {
        if (oldRay) oldRay.remove();
        if (oldProd) oldProd.remove();
        if (oldCommunity) oldCommunity.remove();
        mountFaqIntoResult();
      } else if (isRecipeFlowMode) {
        if (oldRay) oldRay.remove();
        if (oldProd) oldProd.remove();
        mountFaqIntoResult();
        mountCommunitySection();
        reorderCookResultSections();
      } else {
        mountIngredientRayIntoResult();
        mountProduktionAfterRay();
        mountCommunitySection();
        mountFaqIntoResult();
      }
    } catch (e2) {
      // silent
    }

    return out;
  };
} catch (e) {}
 


// Initial Restore (normaler Erst-Load)
const saved = loadQuizState();
runRestoreFromSavedState(saved);

// pageshow: wichtig für bfcache (Safari/Back-Forward Cache)
window.addEventListener("pageshow", (e) => {
  if (!e || !e.persisted) return; // nur BFCache-Fälle
  const saved = loadQuizState();
  runRestoreFromSavedState(saved);
});
const __initialStepNo = Number(steps?.[clampedStep]?.dataset?.step) || 1;
sendEvent("quiz_started", { initial_step: __initialStepNo });
sendEvent("quiz_step_viewed", { step: __initialStepNo });

  }
})();
